(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 5687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 5957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ strategies; },
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 6096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, createLiteralElement, createNumberElement

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6.__assign)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}



/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "Rw": function() { return /* binding */ IntlError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "bc": function() { return /* binding */ IntlErrorCode; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(655);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage
            ? "default message (".concat(typeof descriptor.defaultMessage === 'string'
                ? descriptor.defaultMessage
                : descriptor.defaultMessage
                    .map(function (e) { var _a; return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e); })
                    .join(), ")")
            : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 2644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6284);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5957);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8222);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 6284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6096);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5957);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1092);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),

/***/ 1050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(655);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 1092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ formatToParts; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6096);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1050);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6029)


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(9615);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "kG": function() { return /* binding */ UnstyledButton; },
/* harmony export */   "zu": function() { return /* binding */ StyledButtonGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2125);
/* harmony import */ var _icons_ArrowIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7009);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5741);
/* harmony import */ var _icons_small__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6154);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      --button-color: ",
        ";\n      --button-hover-color: ",
        ";\n      --button-hover-border-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      --button-color: ",
        ";\n      --button-hover-color: ",
        ";\n      --button-hover-border-color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      --button-color: ",
        ";\n      --button-hover-color: ",
        ";\n      --button-hover-border-color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      --button-color: ",
        ";\n      --button-hover-color: ",
        ";\n      --button-hover-border-color: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      --button-color: ",
        ";\n      --button-hover-color: ",
        ";\n      --button-hover-border-color: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: var( --button-color );\n      color: ",
        ";\n\n      &:hover {\n        border-color: var( --button-hover-border-color );\n        background-color: var( --button-hover-color );\n        color: var( --button-hover-text-color );\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: transparent;\n      color: var( --button-color );\n\n      &:hover {\n        background-color: var( --button-color );\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a,\n  button {\n    --button-hover-text-color: ",
        ";\n\n    ",
        "\n    \n    ",
        "\n\n    ",
        "\n    \n    ",
        "\n    \n    ",
        "\n\n    display: ",
        ";\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    min-height: 40px;\n    padding: calc( 0.72em - 1px ) 1.2rem;\n    /* white-space: nowrap; */\n    border-radius: 100rem;\n    border: 1px solid var( --button-color );\n    \n    ",
        ";\n    font-size: ",
        ";\n    text-decoration: none;\n    transition: \n      border-color .3s ease-out,\n      background-color .3s ease-out,\n      color .3s ease-out;\n\n    ",
        "\n\n    ",
        "\n\n    svg {\n      height: calc( 1em * 0.8 );\n      \n      &:first-child {\n        margin-right: 0.6rem;\n      }\n      &:last-child {\n        margin-left: 0.6rem;\n        margin-right: -0.3rem;\n      }\n\n      path {\n        fill: currentColor;\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  flex-wrap: wrap;\n  gap: calc( var( --grid-gutter ) / 2 );\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





function ButtonContents(param) {
    var label = param.label, icon = param.icon;
    switch(icon){
        case "rightArrow":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            });
        case "support":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_small__WEBPACK_IMPORTED_MODULE_4__.Support, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: label
                    })
                ]
            });
        default:
            return label;
    }
}
function Button(param) {
    var _color = param.color, color = _color === void 0 ? "green" : _color, _outline = param.outline, outline = _outline === void 0 ? false : _outline, _size = param.size, size = _size === void 0 ? "normal" : _size, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _href = param.href, href = _href === void 0 ? null : _href, _target = param.target, target = _target === void 0 ? null : _target, _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
        $color: color,
        $style: outline ? "outline" : "filled",
        $size: size,
        $fullWidth: fullWidth,
        children: onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnstyledButton, {
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonContents, {
                label: children,
                icon: icon
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnstyledButton, {
            href: href,
            target: target,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonContents, {
                label: children,
                icon: icon
            })
        })
    });
}
function UnstyledButton(param) {
    var _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, _href = param.href, href = _href === void 0 ? null : _href, _target = param.target, target = _target === void 0 ? null : _target, children = param.children;
    if (onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
            type: "button",
            onClick: onClick,
            children: children
        });
    }
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            href: href,
            target: target,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
        type: "submit",
        children: children
    });
}
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cb55606b-0"
})(_templateObject7(), function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.$color === "green" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), p.theme.colors.green400, p.theme.colors.green700, p.theme.colors.green700);
}, function(p) {
    return p.$color === "red" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), p.theme.colors.red400, p.theme.colors.red700, p.theme.colors.red700);
}, function(p) {
    return p.$color === "blue" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), p.theme.colors.blue700, p.theme.colors.black, p.theme.colors.black);
}, function(p) {
    return p.$color === "black" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3(), p.theme.colors.black, p.theme.colors.green400, p.theme.colors.green400);
}, function(p) {
    return p.$color === "darkGreen" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject4(), p.theme.colors.green700, p.theme.colors.black, p.theme.colors.black);
}, function(p) {
    return p.$fullWidth ? "flex" : "inline-flex";
}, function(p) {
    return p.theme.typo.medium;
}, function(p) {
    return p.theme.typo.sizes[p.$size];
}, function(p) {
    return p.$style === "filled" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject5(), p.theme.colors.realWhite);
}, function(p) {
    return p.$style === "outline" && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6(), p.theme.colors.realWhite);
});
StyledButton.defaultProps = {
    $style: "filled",
    $size: "normal",
    $fullWidth: false
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);
var StyledButtonGroup = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cb55606b-1"
})(_templateObject8(), function(p) {
    return p.$flexDirection;
}, function(p) {
    return p.$flexDirection === "row" ? "flex-start" : "flex-end";
});
StyledButtonGroup.defaultProps = {
    $flexDirection: "row"
};


/***/ }),

/***/ 7753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sQ": function() { return /* binding */ imageUrl; }
/* harmony export */ });
/* unused harmony export brixelApiImageUrl */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var Buffer = __webpack_require__(1876)["Buffer"];





var BRIXEL_API_ORIGIN = "https://dwjey54naux7i.cloudfront.net";
var ORIGIN = "https://d2q4aqnr9moxpw.cloudfront.net";
var HANDLER = "https://d2n5d47bkfvacq.cloudfront.net";
var BUCKET_PREFIX = "cms";
var BUCKET = "fw-brixel-cms-bucket";
var isValidUrl = function(url) {
    return [
        ORIGIN,
        BRIXEL_API_ORIGIN, 
    ].some(function(vu) {
        return url === null || url === void 0 ? void 0 : url.startsWith(vu);
    });
};
var isBrixewlApiUrl = function(url) {
    return [
        BRIXEL_API_ORIGIN, 
    ].some(function(vu) {
        return url === null || url === void 0 ? void 0 : url.startsWith(vu);
    });
};
var universalBtoa = function(payload) {
    if (typeof btoa !== "undefined") {
        return btoa(payload);
    }
    return Buffer.from(payload, "utf8").toString("base64");
};
var imageLoader = function(preResizeEdits, dateModified) {
    return function(param) {
        var src = param.src, width = param.width;
        if (!isValidUrl(src)) {
            return src;
        }
        if (src.endsWith(".svg")) {
            return src;
        }
        if (isBrixewlApiUrl(src)) {
            return brixelApiImageUrl({
                src: src,
                width: width
            });
        }
        return imageUrl({
            src: src,
            width: width,
            preResizeEdits: preResizeEdits,
            dateModified: dateModified
        });
    };
};
var imageUrl = function(param) {
    var src = param.src, _preResizeEdits = param.preResizeEdits, preResizeEdits = _preResizeEdits === void 0 ? null : _preResizeEdits, _dateModified = param.dateModified, dateModified = _dateModified === void 0 ? null : _dateModified, _width = param.width, width = _width === void 0 ? null : _width, _height = param.height, height = _height === void 0 ? null : _height, _fit = param.fit, fit = _fit === void 0 ? "inside" : _fit, _focalPoint = param.focalPoint, focalPoint = _focalPoint === void 0 ? null : _focalPoint;
    if (!isValidUrl(src)) {
        throw new Error("The image src URL must begin with the Cloufront URL associated with the S3 bucket for this image processor.");
    }
    var edits = preResizeEdits ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, preResizeEdits) : {};
    edits.resize = {
        width: width,
        height: height,
        options: {
            fit: fit
        }
    };
    if (focalPoint) {
    // TODO calc coords for extracting the crop
    // edits.extract = {
    //   left,
    //   top,
    //   right,
    //   bottom,
    // }
    }
    var imageRequest = JSON.stringify({
        bucket: BUCKET,
        key: src.replace(ORIGIN, BUCKET_PREFIX),
        edits: edits,
        dateModified: dateModified
    });
    var encodedRequest = universalBtoa(imageRequest);
    return "".concat(HANDLER, "/").concat(encodedRequest);
};
var brixelApiImageUrl = function(param) {
    var src = param.src, width = param.width;
    return "".concat(src, "?width=").concat(width);
};
function Image(_param) {
    var _preResizeEdits = _param.preResizeEdits, preResizeEdits = _preResizeEdits === void 0 ? null : _preResizeEdits, _dateModified = _param.dateModified, dateModified = _dateModified === void 0 ? null : _dateModified, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "preResizeEdits",
        "dateModified"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        loader: imageLoader(preResizeEdits, dateModified),
        sizes: "100vw"
    }, props), {
        alt: props.alt || ""
    }));
}
/* harmony default export */ __webpack_exports__["ZP"] = (Image);


/***/ }),

/***/ 5741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIsExternalURL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);






function Link(_param) {
    var children = _param.children, href = _param.href, _target = _param.target, target = _target === void 0 ? null : _target, _rel = _param.rel, rel = _rel === void 0 ? null : _rel, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "href",
        "target",
        "rel",
        "disabled"
    ]);
    var isExternalURL = useIsExternalURL(href);
    if (disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: children
        });
    }
    if (target === "_blank" || isExternalURL) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: target || "_blank",
            rel: rel,
            children: children
        });
    }
    if (!href) {
        throw new Error("No href passed to Link");
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    }));
}
var useIsExternalURL = function(url) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isExternal = ref[0], setIsExternal = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            if (!/^(?:[a-z]+:)?\/\//i.test(url)) {
                setIsExternal(false);
                return;
            }
            var host = window.location.host;
            setIsExternal(new URL(url, "https://".concat(host)).hostname !== host);
        }
    }, [
        url
    ]);
    return isExternal;
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 7009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function ArrowIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 33 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M32.0607 13.0607C32.6464 12.4749 32.6464 11.5251 32.0607 10.9393L22.5147 1.3934C21.9289 0.807611 20.9792 0.807611 20.3934 1.3934C19.8076 1.97919 19.8076 2.92893 20.3934 3.51472L28.8787 12L20.3934 20.4853C19.8076 21.0711 19.8076 22.0208 20.3934 22.6066C20.9792 23.1924 21.9289 23.1924 22.5147 22.6066L32.0607 13.0607ZM0 13.5H31V10.5H0V13.5Z",
            fill: "#06262D"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowIcon);


/***/ }),

/***/ 6154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Document": function() { return /* reexport */ Document; },
  "EVCharger": function() { return /* reexport */ EVCharger; },
  "Garden": function() { return /* reexport */ Garden; },
  "HighEndEquipment": function() { return /* reexport */ HighEndEquipment; },
  "Laundry": function() { return /* reexport */ Laundry; },
  "Lift": function() { return /* reexport */ Lift; },
  "LightBulb": function() { return /* reexport */ LightBulb; },
  "Materials": function() { return /* reexport */ Materials; },
  "Parking": function() { return /* reexport */ Parking; },
  "Plans": function() { return /* reexport */ Plans; },
  "SecurityCamera": function() { return /* reexport */ SecurityCamera; },
  "SmartHome": function() { return /* reexport */ SmartHome; },
  "SteamOven": function() { return /* reexport */ SteamOven; },
  "Support": function() { return /* reexport */ Support; },
  "Toilet": function() { return /* reexport */ Toilet; },
  "Wheelchair": function() { return /* reexport */ Wheelchair; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/icons/small/EVCharger.tsx

function EVCharger() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.9471 1.6911C18.1574 1.59114 18.3952 1.56479 18.6223 1.61627C18.8494 1.66775 19.0525 1.79408 19.1992 1.97496C19.3458 2.15584 19.4274 2.38076 19.4308 2.61358L19.4309 2.62283L19.4308 5.337L21.2997 5.43502C21.4699 5.4443 21.6352 5.49531 21.7811 5.58355C21.9269 5.6718 22.0488 5.79457 22.136 5.94104C22.2232 6.08752 22.273 6.25319 22.281 6.42346C22.289 6.59372 22.2551 6.76335 22.1821 6.91739L19.7028 12.1263L19.7023 12.1274C19.6016 12.3401 19.4316 12.5122 19.2202 12.6156C19.0085 12.7192 18.7678 12.7476 18.5377 12.6962C18.3076 12.6448 18.1019 12.5166 17.9544 12.3327C17.8069 12.1489 17.7263 11.9203 17.726 11.6845L17.726 8.96944L15.8591 8.87153C15.6887 8.86266 15.5224 8.8119 15.3763 8.7238C15.2299 8.63557 15.1076 8.51259 15.0202 8.36575C14.9328 8.21892 14.883 8.05278 14.8753 7.88209C14.8675 7.71149 14.9019 7.54161 14.9755 7.3875L17.4627 2.16737C17.5661 1.95878 17.7368 1.79106 17.9471 1.6911ZM18.1608 3.65466V5.93957C18.1608 6.27734 18.4253 6.55601 18.7626 6.5737L20.8861 6.68508L18.996 10.6563V8.36687C18.996 8.0291 18.7315 7.75044 18.3942 7.73275L16.2708 7.62138L18.1608 3.65466ZM18.5544 11.584L18.5553 11.5823L18.5544 11.584Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.9477 7.8342C2.9477 7.4835 3.232 7.1992 3.5827 7.1992H5.22606C5.82941 7.1992 6.40805 7.43888 6.83468 7.86552C7.26131 8.29215 7.50099 8.87079 7.50099 9.47413C7.50099 10.0775 7.26131 10.6561 6.83468 11.0828C6.40805 11.5094 5.82941 11.7491 5.22606 11.7491H3.5827C3.232 11.7491 2.9477 11.4648 2.9477 11.1141V7.8342ZM4.2177 8.4692V10.4791H5.22606C5.49258 10.4791 5.74819 10.3732 5.93665 10.1847C6.12512 9.99627 6.23099 9.74066 6.23099 9.47413C6.23099 9.20761 6.12512 8.952 5.93665 8.76354C5.74819 8.57508 5.49258 8.4692 5.22606 8.4692H4.2177Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.71777 10.7041C1.71777 10.3534 2.00207 10.0691 2.35277 10.0691H3.58272C3.93342 10.0691 4.21772 10.3534 4.21772 10.7041C4.21772 11.0548 3.93342 11.3391 3.58272 11.3391H2.35277C2.00207 11.3391 1.71777 11.0548 1.71777 10.7041Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.71777 8.24422C1.71777 7.89352 2.00207 7.60922 2.35277 7.60922H3.58272C3.93342 7.60922 4.21772 7.89352 4.21772 8.24422C4.21772 8.59492 3.93342 8.87922 3.58272 8.87922H2.35277C2.00207 8.87922 1.71777 8.59492 1.71777 8.24422Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.4044 4.30252C12.6843 4.02258 13.064 3.86531 13.4599 3.86531C13.8106 3.86531 14.0949 4.14961 14.0949 4.50031C14.0949 4.85101 13.8106 5.13531 13.4599 5.13531C13.4008 5.13531 13.3442 5.15878 13.3024 5.20054C13.2607 5.24231 13.2372 5.29895 13.2372 5.35802V20.9168C13.2372 20.9758 13.2607 21.0325 13.3024 21.0743C13.3442 21.116 13.4008 21.1395 13.4599 21.1395H19.9441C20.0032 21.1395 20.0598 21.116 20.1016 21.0743C20.1434 21.0325 20.1668 20.9758 20.1668 20.9168V14.2215C20.1668 13.8708 20.4511 13.5865 20.8018 13.5865C21.1525 13.5865 21.4368 13.8708 21.4368 14.2215V20.9168C21.4368 21.3127 21.2796 21.6923 20.9996 21.9723C20.7197 22.2522 20.34 22.4095 19.9441 22.4095H13.4599C13.064 22.4095 12.6843 22.2522 12.4044 21.9723C12.1245 21.6923 11.9672 21.3127 11.9672 20.9168V5.35802C11.9672 4.96213 12.1245 4.58245 12.4044 4.30252Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.65783 10.1855C7.53577 10.135 7.40497 10.1091 7.27289 10.1091L6.86258 10.1091C6.51187 10.1091 6.22758 9.82484 6.22758 9.47414C6.22758 9.12344 6.51187 8.83914 6.86258 8.83914H7.27223C7.57097 8.83903 7.86716 8.89774 8.14322 9.01192C8.4194 9.12615 8.67036 9.29365 8.8818 9.50486C9.09324 9.71608 9.261 9.96687 9.37551 10.2429C9.49003 10.519 9.54905 10.8149 9.5492 11.1137L9.5492 18.4946C9.5492 18.7611 9.65508 19.0168 9.84354 19.2052C10.032 19.3937 10.2876 19.4996 10.5541 19.4996H12.6023C12.953 19.4996 13.2373 19.7839 13.2373 20.1346C13.2373 20.4853 12.953 20.7696 12.6023 20.7696H10.5541C9.95079 20.7696 9.37215 20.5299 8.94552 20.1032C8.51888 19.6766 8.2792 19.098 8.2792 18.4946V11.1144C8.27914 10.9823 8.25305 10.8515 8.20244 10.7295C8.15183 10.6075 8.07769 10.4967 7.98424 10.4034C7.8908 10.31 7.77988 10.236 7.65783 10.1855Z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Garden.tsx

function Garden() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.29069 2.022C5.39365 2.03725 4.47784 2.18538 3.60555 2.45633C3.36474 2.53113 2.96068 2.67789 2.86482 2.72537C2.64409 2.83471 2.51433 3.03019 2.50117 3.27323C2.49287 3.42644 2.52782 3.53817 2.63678 3.70674C2.70096 3.80605 2.80604 4.01654 2.86893 4.17179C3.02349 4.55338 3.15324 5.02065 3.37429 5.99186C3.6067 7.01295 3.70599 7.40711 3.84163 7.84722C4.2102 9.04312 4.65755 9.86597 5.28094 10.4947C5.71875 10.9362 6.19332 11.2424 6.77469 11.4583C7.0786 11.5711 7.45963 11.6657 7.77635 11.7068C7.91555 11.7249 8.23045 11.7319 8.36947 11.72C9.13027 11.6549 9.84833 11.3224 10.5345 10.7176C10.5954 10.6639 10.7241 10.5403 10.8204 10.443L10.9954 10.266L11.0414 10.35C11.1057 10.4675 11.2546 10.7761 11.3457 10.9807C11.7166 11.8131 12.0064 12.7652 12.1866 13.7423C12.2285 13.9696 12.2712 14.2305 12.2712 14.2589V14.2808L10.653 14.2832L9.03475 14.2857L8.95662 14.3035C8.41374 14.4269 8.03258 14.8086 7.92675 15.3348C7.90506 15.4427 7.9007 15.6599 7.91819 15.7604C7.94102 15.8916 8.97393 20.9588 8.99298 21.0331C9.03648 21.2029 9.08943 21.3212 9.18451 21.4611C9.37263 21.7378 9.67169 21.9319 10.0238 22.0057C10.0921 22.0201 10.2261 22.0208 13.0204 22.0208C15.8129 22.0208 15.9486 22.0201 16.0169 22.0058C16.3352 21.9391 16.6016 21.7803 16.7995 21.5393C16.9003 21.4165 16.9869 21.2537 17.0314 21.1034C17.0562 21.0197 18.1033 15.8913 18.1257 15.7437C18.1632 15.4974 18.1114 15.2045 17.9896 14.9745C17.8097 14.6346 17.4863 14.3944 17.0866 14.3039L17.006 14.2857L15.4846 14.2832C14.6478 14.2819 13.9631 14.2793 13.9631 14.2776C13.9631 14.2686 14.1242 13.8941 14.2038 13.718C14.3176 13.4665 14.5867 12.9364 14.7172 12.7067C14.8665 12.4441 15.0328 12.1752 15.1731 11.9694L15.2194 11.9015L15.2792 11.9653C15.6352 12.345 15.9825 12.6074 16.3638 12.7846C16.9736 13.0679 17.5752 13.0917 18.2869 12.8605C19.1022 12.5957 19.7333 12.0329 20.1647 11.1861C20.3176 10.8857 20.4438 10.5631 20.5753 10.1365C20.6217 9.98588 20.7548 9.4618 20.8315 9.12821C21.0043 8.37635 21.0731 8.10412 21.1477 7.87615C21.2218 7.6498 21.2982 7.4788 21.3921 7.3292C21.4777 7.19279 21.5012 7.11375 21.5 6.96706C21.4992 6.88023 21.4954 6.85189 21.4762 6.78937C21.4444 6.68558 21.4017 6.61171 21.3297 6.53626C21.2455 6.44803 21.1745 6.40399 21.0179 6.34299C19.9154 5.91359 18.6921 5.78142 17.5068 5.96364C16.6709 6.09215 15.8458 6.38414 15.1205 6.80814C14.7027 7.05237 14.3218 7.39996 14.0859 7.75218C13.8341 8.12819 13.7143 8.47218 13.6844 8.90458C13.6509 9.3904 13.7845 9.91205 14.0719 10.4175C14.1319 10.5231 14.2866 10.7597 14.3351 10.8202L14.3599 10.851L14.281 10.9607C14.0226 11.3199 13.8018 11.6637 13.5841 12.0456C13.5051 12.1843 13.3316 12.5046 13.3067 12.558L13.2874 12.5993L13.2766 12.5621C13.2706 12.5416 13.2446 12.4462 13.2188 12.3501C12.931 11.2784 12.507 10.2443 11.9903 9.35365C11.9409 9.26855 11.8985 9.19373 11.896 9.18737C11.8933 9.18054 11.9288 9.13225 11.9827 9.06937C12.6208 8.32487 13.0104 7.56678 13.1374 6.82243C13.1956 6.48143 13.1955 6.09096 13.1371 5.76872C13.0365 5.21332 12.7895 4.71335 12.383 4.24242C12.0997 3.91415 11.6669 3.55739 11.2696 3.32472C10.2473 2.72608 9.11085 2.32017 7.9447 2.1372C7.4127 2.05373 6.82643 2.0129 6.29069 2.022ZM6.0045 3.32636C5.47359 3.3585 4.97061 3.43417 4.48618 3.55479C4.34687 3.58947 4.08976 3.65973 4.08346 3.66483C4.08243 3.66567 4.09873 3.70891 4.11969 3.76093C4.17645 3.90176 4.27534 4.19578 4.33355 4.39682C4.44023 4.76516 4.50235 5.01644 4.68738 5.82808C4.95975 7.02284 5.095 7.51253 5.30325 8.05797C5.83635 9.4542 6.59297 10.1695 7.77635 10.3958C7.92368 10.424 8.00164 10.4317 8.14251 10.4319C8.606 10.4324 9.05524 10.2467 9.53688 9.85548C9.74143 9.68932 10.0251 9.39849 10.2039 9.17159L10.2609 9.09926L10.229 9.05589C10.1676 8.97216 9.96075 8.71395 9.87325 8.61169C9.33588 7.98366 8.69987 7.43447 8.15652 7.12927C8.09478 7.0946 8.02192 7.04899 7.99462 7.02791C7.8944 6.95061 7.80981 6.81371 7.77573 6.67367C7.75241 6.57785 7.75626 6.44033 7.78475 6.35136C7.84369 6.16735 7.96458 6.02845 8.13409 5.94999C8.24028 5.90083 8.29501 5.88914 8.42028 5.88882C8.51196 5.88859 8.53994 5.89169 8.59284 5.9079C8.85585 5.98852 9.47175 6.40962 9.97398 6.85221C10.3419 7.17642 10.7404 7.59518 11.0529 7.98602L11.1176 8.06697L11.1878 7.97363C11.6817 7.31751 11.9138 6.67991 11.8586 6.13116C11.8281 5.82824 11.7293 5.5633 11.5471 5.29539C11.4508 5.15387 11.3601 5.04908 11.2053 4.90079C10.9096 4.61727 10.6073 4.4188 10.0675 4.15364C9.10993 3.68326 8.09355 3.4095 7.02539 3.33427C6.77347 3.31652 6.23568 3.31236 6.0045 3.32636ZM18.2938 7.18218C17.5848 7.21808 16.918 7.37856 16.2854 7.66553C16.0328 7.78013 15.7495 7.93761 15.6075 8.04236C15.0146 8.47969 14.8585 8.97678 15.1223 9.58689C15.1525 9.65671 15.2264 9.80228 15.2394 9.81748C15.241 9.81929 15.2983 9.76723 15.3668 9.70177C15.5059 9.56873 15.6543 9.4388 15.7734 9.34577C15.9975 9.17073 16.1232 9.11582 16.2998 9.11582C16.5755 9.11582 16.7916 9.25118 16.9087 9.49727C16.9798 9.6467 16.9866 9.80607 16.9292 9.97532C16.8857 10.1037 16.8119 10.1982 16.6819 10.2922C16.5759 10.3689 16.483 10.4465 16.3305 10.5861C16.2018 10.7038 16.0632 10.8455 16.0632 10.8594C16.0632 10.8718 16.2 11.0376 16.2777 11.1192C16.5929 11.451 16.8924 11.6412 17.2038 11.7074C17.3032 11.7285 17.4813 11.7272 17.5964 11.7044C17.9165 11.6412 18.1912 11.5206 18.4105 11.347C18.4831 11.2895 18.6389 11.1335 18.7032 11.0538C18.9105 10.7971 19.0915 10.4358 19.2476 9.96705C19.3484 9.6643 19.4326 9.341 19.59 8.65301C19.7221 8.07539 19.8274 7.67027 19.9014 7.45511C19.9177 7.40762 19.931 7.36436 19.931 7.35896C19.931 7.35356 19.9225 7.34725 19.9121 7.34493C19.9017 7.34261 19.8267 7.32575 19.7456 7.30745C19.4874 7.24926 19.2274 7.21051 18.963 7.19081C18.7948 7.17829 18.4569 7.17393 18.2938 7.18218ZM9.22455 15.5807C9.22478 15.5864 9.46076 16.7476 9.74895 18.1613L10.2729 20.7315L13.0216 20.7336L15.7703 20.7357L16.2964 18.153L16.8225 15.5703H13.0233C9.98937 15.5703 9.22422 15.5724 9.22455 15.5807Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/HighEndEquipment.tsx

function HighEndEquipment() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.824 2.03305C11.7218 2.04921 11.6221 2.08074 11.5229 2.12826C11.3303 2.22052 11.1862 2.34358 11.0713 2.51378C11.0484 2.54774 10.8288 2.97 10.5834 3.45214L10.1371 4.32874L9.37855 4.33331C8.53656 4.33839 8.55158 4.33749 8.38515 4.39315C8.19875 4.4555 8.01906 4.5747 7.89857 4.71592C7.68346 4.96803 7.58834 5.28904 7.63578 5.6028C7.66648 5.80574 7.72962 5.95914 7.84705 6.1161C7.89065 6.17437 8.12603 6.41022 8.89269 7.16381L9.27737 7.54194L8.92984 8.33934C8.53302 9.24987 8.51886 9.28373 8.49227 9.38601C8.36874 9.86134 8.58205 10.3661 9.0151 10.6232C9.31261 10.7997 9.72083 10.8217 10.028 10.6776C10.0632 10.6611 10.5213 10.4057 11.046 10.1101L11.9999 9.57266L12.95 10.1077C13.4725 10.402 13.9216 10.6536 13.948 10.6668C14.0093 10.6976 14.1238 10.7359 14.2093 10.7543C14.302 10.7743 14.5349 10.7743 14.6342 10.7543C14.9805 10.6845 15.2735 10.4618 15.4254 10.1527C15.5046 9.99158 15.5395 9.83766 15.5386 9.65274C15.5379 9.51754 15.5219 9.41755 15.4825 9.30185C15.4711 9.26824 15.298 8.86454 15.0978 8.40474C14.8977 7.94494 14.7325 7.56154 14.7307 7.55274C14.7282 7.5403 14.8791 7.38799 15.4085 6.86874C16.1334 6.15781 16.1701 6.11842 16.2502 5.96656C16.2706 5.92781 16.3001 5.85798 16.3157 5.81139C16.4268 5.47915 16.3804 5.12346 16.1879 4.83274C16.0328 4.59855 15.7839 4.42845 15.496 4.35989C15.441 4.34678 15.3712 4.34538 14.6518 4.34288L13.8676 4.34015L13.6738 3.95845C13.0704 2.77037 12.9681 2.57165 12.9341 2.52038C12.8487 2.39163 12.7473 2.29158 12.6124 2.2029C12.4248 2.07953 12.2216 2.01982 11.995 2.02152C11.9384 2.02194 11.8614 2.02714 11.824 2.03305ZM6.24 3.27644C5.9211 3.31736 5.62262 3.49952 5.45098 3.75797C5.41545 3.81146 5.239 4.14982 4.95222 4.71442L4.50845 5.58809L3.72822 5.59079L2.948 5.5935L2.864 5.61434C2.65824 5.66539 2.4852 5.76076 2.33651 5.90504C2.17771 6.05913 2.07442 6.24478 2.02286 6.46874C1.99777 6.57774 1.99409 6.7613 2.01459 6.88074C2.04558 7.0613 2.11491 7.22482 2.22036 7.3661C2.25704 7.41524 2.47206 7.6321 2.95806 8.1101C3.33533 8.48115 3.64503 8.78858 3.6463 8.79326C3.64757 8.79794 3.48617 9.17594 3.28763 9.63326C3.0891 10.0906 2.91271 10.5061 2.89565 10.5567C2.85589 10.6747 2.83907 10.7807 2.8393 10.9121C2.83994 11.2916 3.02462 11.6309 3.3456 11.8423C3.47954 11.9305 3.59966 11.9775 3.764 12.006C3.84488 12.02 3.88142 12.022 3.996 12.0185C4.11258 12.015 4.14514 12.011 4.224 11.9905C4.2746 11.9774 4.3484 11.9525 4.388 11.9352C4.4276 11.9179 4.89095 11.6605 5.41768 11.3632L6.37535 10.8227L6.53768 10.9139C6.73901 11.0269 6.79209 11.0457 6.924 11.0505C7.00214 11.0534 7.03302 11.051 7.09003 11.0375C7.21898 11.0069 7.32017 10.9494 7.40574 10.8579C7.55068 10.703 7.60761 10.493 7.56026 10.2881C7.52577 10.1388 7.4382 10.0069 7.3169 9.92156C7.2308 9.86096 6.6473 9.5382 6.58218 9.51516C6.42947 9.46112 6.24257 9.47079 6.10582 9.53982C6.07207 9.55686 4.30798 10.5493 4.24602 10.5861C4.23731 10.5913 4.22458 10.6211 4.61207 9.72874C4.80886 9.27554 4.97822 8.88118 4.98842 8.85238C5.06227 8.6438 5.01589 8.40428 4.86932 8.23739C4.84219 8.2065 4.51438 7.88142 4.14085 7.51499L3.46169 6.84874L4.22085 6.8444C4.97497 6.84008 4.98042 6.83993 5.044 6.82222C5.22078 6.77295 5.34305 6.67878 5.43545 6.52074C5.4586 6.48114 5.69803 6.01423 5.96752 5.48315L6.4575 4.51757L6.50275 4.50861C6.72566 4.46449 6.91877 4.28222 6.98146 4.05674C6.98758 4.03474 6.99475 3.97707 6.99739 3.92858C7.00513 3.78664 6.97616 3.67204 6.90501 3.56309C6.81715 3.42856 6.69196 3.33498 6.54314 3.29258C6.47602 3.27346 6.32562 3.26546 6.24 3.27644ZM17.5266 3.27635C17.3431 3.31018 17.1966 3.4075 17.095 3.56309C17.0238 3.67204 16.9949 3.78664 17.0026 3.92858C17.0095 4.05575 17.0353 4.13663 17.1006 4.23674C17.189 4.37214 17.3346 4.47208 17.4985 4.50999L17.545 4.52074L18.0508 5.51674C18.3289 6.06454 18.5693 6.53254 18.585 6.55674C18.6701 6.68801 18.795 6.77734 18.956 6.82222C19.0196 6.83993 19.025 6.84008 19.7791 6.8444L20.5383 6.84874L19.8631 7.51094C19.4918 7.87514 19.1642 8.19995 19.135 8.23273C18.9846 8.4019 18.9369 8.64119 19.0116 8.85238C19.0217 8.88118 19.1911 9.27554 19.3879 9.72874C19.7759 10.6222 19.7627 10.5913 19.754 10.5861C19.6784 10.5417 17.9284 9.55712 17.8947 9.54007C17.7574 9.47078 17.5708 9.46103 17.4178 9.51516C17.3509 9.53884 16.7646 9.86368 16.684 9.92172C16.591 9.98869 16.5333 10.056 16.4873 10.1511C16.4192 10.2919 16.4048 10.476 16.4507 10.6167C16.5053 10.784 16.6318 10.9265 16.7889 10.9977C16.8786 11.0384 16.9663 11.0546 17.076 11.0505C17.2079 11.0457 17.261 11.0269 17.4623 10.9139L17.6246 10.8227L18.5823 11.3632C19.109 11.6605 19.5724 11.9179 19.612 11.9352C19.6516 11.9525 19.7254 11.9773 19.776 11.9905C19.8538 12.0106 19.8884 12.015 20 12.0185C20.2561 12.0268 20.4561 11.9729 20.6544 11.8423C20.8775 11.6954 21.0354 11.4874 21.1111 11.2407C21.1463 11.126 21.1605 11.0317 21.1607 10.9121C21.1609 10.7807 21.1441 10.6747 21.1043 10.5567C21.0873 10.5061 20.9109 10.0906 20.7123 9.63336C20.5138 9.1761 20.3524 8.7981 20.3537 8.79336C20.355 8.78862 20.6647 8.48115 21.0419 8.11009C21.5279 7.63214 21.743 7.41522 21.7796 7.36609C21.8851 7.22482 21.9544 7.0613 21.9854 6.88074C22.0059 6.7613 22.0022 6.57774 21.9771 6.46874C21.9252 6.24331 21.8208 6.05642 21.661 5.90303C21.5113 5.75933 21.3386 5.66422 21.1371 5.61449L21.052 5.5935L20.2717 5.59079L19.4914 5.58809L19.2977 5.20642C18.7108 4.05045 18.5922 3.81966 18.5581 3.76838C18.446 3.5995 18.2889 3.46477 18.1013 3.37664C18.0107 3.33409 17.9709 3.32054 17.864 3.29596C17.7714 3.27466 17.5923 3.26425 17.5266 3.27635ZM11.536 4.3419C11.283 4.83958 11.0589 5.27298 11.038 5.30502C10.9521 5.4369 10.8216 5.52874 10.656 5.57402C10.6292 5.58133 10.4228 5.58499 9.85116 5.5883L9.08232 5.59274L9.7859 6.28474C10.1729 6.66534 10.5055 6.99794 10.525 7.02383C10.5679 7.08079 10.6098 7.16638 10.6292 7.23674C10.6492 7.30933 10.6492 7.48437 10.6292 7.55609C10.6213 7.58433 10.4462 7.99473 10.2401 8.46809C10.034 8.94145 9.86672 9.33006 9.8683 9.33166C9.86988 9.33327 10.2774 9.10576 10.7739 8.82608C11.2704 8.54641 11.7034 8.30489 11.7363 8.28938C11.8311 8.24461 11.8861 8.23281 12 8.23281C12.1138 8.23281 12.1689 8.24462 12.2634 8.28925C12.2961 8.30469 12.7292 8.54622 13.2258 8.82598C13.7224 9.10574 14.1301 9.3333 14.1317 9.33167C14.1334 9.33004 13.9694 8.94891 13.7674 8.48472C13.5653 8.02054 13.393 7.62063 13.3845 7.59604C13.3588 7.52218 13.3494 7.44823 13.3546 7.36108C13.3625 7.22899 13.4019 7.121 13.4789 7.02026C13.5005 6.99193 13.8337 6.65914 14.2193 6.28074L14.9204 5.59274L14.1422 5.58855C13.5374 5.5853 13.3569 5.58206 13.332 5.57402C13.2634 5.55187 13.2262 5.53627 13.18 5.5104C13.0718 5.44972 13.0057 5.38473 12.9424 5.27674C12.923 5.24374 12.704 4.81626 12.4556 4.32678C12.2072 3.83729 12.0022 3.43685 12 3.43691C11.9978 3.43698 11.789 3.84422 11.536 4.3419ZM11.808 10.7815C11.4468 10.8182 11.0741 10.9743 10.804 11.2021C10.6183 11.3587 5.28888 16.1661 5.25896 16.204C5.21027 16.2656 5.17968 16.3216 5.15475 16.3947C5.12604 16.4789 5.11866 16.6469 5.13982 16.735C5.19338 16.9578 5.37127 17.1396 5.59224 17.1975C5.64509 17.2113 5.68113 17.2151 5.756 17.2146C5.92873 17.2135 6.04558 17.1651 6.19442 17.033C6.23924 16.9933 7.47293 15.8829 8.93595 14.5655C10.399 13.2481 11.6122 12.1582 11.632 12.1434C11.6865 12.1028 11.7726 12.0626 11.844 12.0445C11.923 12.0245 12.0504 12.0227 12.136 12.0406C12.206 12.0551 12.3067 12.1013 12.365 12.1456C12.3875 12.1627 13.6183 13.2675 15.1001 14.6007C16.5819 15.9339 17.8162 17.0435 17.8431 17.0665C17.9114 17.1247 17.9917 17.1683 18.076 17.193C18.1744 17.2217 18.3082 17.2235 18.4078 17.1975C18.6146 17.1433 18.779 16.9865 18.8495 16.7761C18.8659 16.7271 18.868 16.7057 18.8679 16.5887C18.8678 16.4617 18.8668 16.4541 18.8431 16.3874C18.8134 16.3043 18.7473 16.2022 18.6826 16.1399C18.6367 16.0956 13.3561 11.3462 13.2398 11.2445C12.9983 11.0334 12.7238 10.8912 12.424 10.8217C12.2496 10.7813 11.9822 10.7638 11.808 10.7815ZM8.156 16.5971C8.01564 16.6188 7.91502 16.6716 7.80774 16.7798C7.7237 16.8646 7.68116 16.9346 7.64674 17.0447L7.628 17.1047V18.7127C7.628 20.2382 7.62876 20.3257 7.64282 20.4167C7.72636 20.9579 8.02306 21.4216 8.476 21.7187C8.71814 21.8776 9.01941 21.9841 9.308 22.0128C9.37037 22.019 10.1707 22.0209 12.056 22.0192L14.716 22.0167L14.816 21.998C15.218 21.9224 15.5572 21.7447 15.8356 21.4637C16.1136 21.183 16.2951 20.8187 16.3572 20.4167C16.3712 20.3257 16.372 20.2382 16.372 18.7127V17.1047L16.3533 17.0447C16.3179 16.9316 16.2768 16.8648 16.1884 16.7767C16.0532 16.6422 15.9378 16.5945 15.748 16.5947C15.6586 16.5948 15.6339 16.5978 15.572 16.6162C15.3716 16.6759 15.217 16.8289 15.147 17.0367C15.1328 17.0788 15.132 17.1503 15.1277 18.6567C15.1228 20.3848 15.1262 20.2694 15.076 20.3888C15.0029 20.5624 14.8501 20.6974 14.6665 20.7506L14.604 20.7687H12H9.396L9.33353 20.7506C9.22262 20.7185 9.12829 20.6608 9.04685 20.5752C8.9773 20.5021 8.93182 20.4234 8.89505 20.3127C8.88642 20.2868 8.88355 19.9843 8.87982 18.7047C8.8747 16.9513 8.87916 17.0826 8.82046 16.959C8.75799 16.8275 8.66993 16.733 8.544 16.6623C8.44724 16.6081 8.2737 16.5789 8.156 16.5971Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Laundry.tsx

function Laundry() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.92401 2.03007C4.64624 2.05803 4.3299 2.17245 4.09201 2.33099C3.64057 2.63187 3.35076 3.08902 3.26683 3.63267C3.25248 3.72566 3.25201 3.98877 3.25201 12.0207C3.25201 20.0526 3.25248 20.3157 3.26683 20.4087C3.35076 20.9523 3.64057 21.4095 4.09201 21.7103C4.33561 21.8727 4.64745 21.9838 4.93941 22.0122C5.06394 22.0243 18.9383 22.0241 19.0606 22.012C19.3559 21.9827 19.6614 21.8739 19.908 21.7101C20.3585 21.411 20.6493 20.9523 20.7332 20.4087C20.7476 20.3157 20.748 20.0526 20.748 12.0207C20.748 3.98877 20.7476 3.72566 20.7332 3.63267C20.6493 3.08902 20.3595 2.63187 19.908 2.33099C19.6644 2.16865 19.3526 2.05758 19.0606 2.02917C18.9494 2.01835 5.03164 2.01923 4.92401 2.03007ZM5.05125 3.2768C4.89045 3.29383 4.74257 3.37701 4.63659 3.51003C4.5849 3.57491 4.55449 3.63111 4.52693 3.71267L4.50801 3.76867L4.5059 5.39467L4.50379 7.02067H12H19.4962L19.4941 5.39467L19.492 3.76867L19.4731 3.71267C19.4031 3.50552 19.2407 3.34921 19.0343 3.29041L18.972 3.27267L12.04 3.27173C8.22741 3.27121 5.08247 3.2735 5.05125 3.2768ZM13.1538 4.21325C12.625 4.26434 12.2389 4.76543 12.324 5.29004C12.4335 5.96528 13.2009 6.30361 13.7676 5.92652C13.9757 5.78803 14.1185 5.57553 14.1686 5.32979C14.1888 5.23091 14.1903 5.07992 14.1723 4.97839C14.1088 4.6205 13.8364 4.32881 13.48 4.23684C13.4271 4.22319 13.2646 4.20282 13.232 4.20576C13.2254 4.20636 13.1902 4.20973 13.1538 4.21325ZM16.9017 4.2136C16.5135 4.25101 16.184 4.53938 16.0874 4.92629C16.0636 5.02159 16.0579 5.19983 16.0755 5.30067C16.13 5.61384 16.3298 5.87137 16.62 6.00251C16.7625 6.06687 16.9344 6.09446 17.0912 6.07811C17.2101 6.06571 17.3034 6.0387 17.4129 5.98489C17.7375 5.82541 17.936 5.5068 17.936 5.14562C17.936 5.00771 17.9123 4.89258 17.8588 4.77097C17.7401 4.5011 17.5098 4.30734 17.22 4.23354C17.1763 4.22241 17.0129 4.20317 16.984 4.20575C16.9774 4.20635 16.9404 4.20987 16.9017 4.2136ZM6.29925 4.5247C6.06151 4.5503 5.84885 4.72744 5.77584 4.96067C5.75092 5.04028 5.74526 5.18643 5.7636 5.27719C5.80324 5.47347 5.9506 5.64975 6.13919 5.7265C6.2576 5.77468 6.20667 5.7732 7.66048 5.77075L8.98801 5.76852L9.04673 5.75037C9.20047 5.70283 9.33547 5.59718 9.41629 5.46114C9.51791 5.29007 9.52709 5.05159 9.43891 4.87331C9.35586 4.70542 9.20806 4.58531 9.02267 4.53506C8.97587 4.52237 8.87239 4.52122 7.66401 4.51995C6.94461 4.5192 6.33047 4.52134 6.29925 4.5247ZM4.50598 14.2707L4.50801 20.2727L4.52693 20.3287C4.55376 20.4081 4.58499 20.4668 4.63173 20.5256C4.72064 20.6376 4.85266 20.7238 4.98152 20.754C5.04185 20.7682 5.28462 20.7687 12 20.7687C18.7154 20.7687 18.9582 20.7682 19.0185 20.754C19.1474 20.7238 19.2794 20.6376 19.3683 20.5256C19.415 20.4668 19.4463 20.4081 19.4731 20.3287L19.492 20.2727L19.494 14.2707L19.4961 8.26867H12H4.50395L4.50598 14.2707ZM11.876 9.52214C10.8878 9.5421 9.89977 9.87245 9.09096 10.4533C8.71708 10.7219 8.37545 11.0469 8.08281 11.4127C7.52246 12.113 7.15189 12.9906 7.0407 13.8807C7.01083 14.1197 7.00417 14.2365 7.00417 14.5207C7.00417 14.8669 7.02382 15.1052 7.07676 15.4007C7.30649 16.6831 8.02766 17.8244 9.09091 18.588C9.75625 19.0658 10.5586 19.3815 11.36 19.4806C11.7667 19.531 12.2356 19.5309 12.64 19.4805C13.5277 19.37 14.3981 19.0024 15.1064 18.439C15.3904 18.2131 15.6784 17.9267 15.9027 17.647C16.4775 16.9303 16.8456 16.0629 16.9597 15.1567C16.9889 14.9245 16.9958 14.8042 16.9958 14.5207C16.9958 14.2371 16.9889 14.1168 16.9597 13.8847C16.7871 12.5131 16.0427 11.2675 14.9091 10.4534C14.0299 9.82191 12.9808 9.49983 11.876 9.52214ZM11.692 10.7848C10.8003 10.8607 9.98543 11.2374 9.35781 11.8641C9.04047 12.181 8.82046 12.49 8.62439 12.894C8.27747 13.609 8.16942 14.4222 8.31594 15.2155C8.41037 15.7267 8.6368 16.2611 8.93849 16.6847C9.51379 17.4923 10.3758 18.0395 11.344 18.2116C11.8899 18.3086 12.4888 18.2799 13.008 18.1318C13.5554 17.9756 14.0437 17.7122 14.4578 17.3495C14.9833 16.8893 15.3597 16.3183 15.5717 15.6599C15.7788 15.0167 15.803 14.2915 15.6397 13.6235C15.5312 13.18 15.3229 12.7237 15.0615 12.3567C14.455 11.5051 13.5291 10.9441 12.5 10.8047C12.2685 10.7733 11.926 10.7649 11.692 10.7848ZM11.824 12.0253C11.8086 12.027 11.7582 12.0324 11.712 12.0373C11.4519 12.0648 11.1722 12.146 10.916 12.2683C10.0624 12.6758 9.50475 13.5518 9.50267 14.4887C9.50244 14.5934 9.5054 14.628 9.51897 14.679C9.57936 14.9062 9.76465 15.0841 9.99201 15.1332C10.0604 15.148 10.2054 15.1463 10.2739 15.1299C10.414 15.0963 10.5486 15.0036 10.636 14.8807C10.7168 14.7669 10.7415 14.6861 10.7522 14.5007C10.7606 14.3552 10.7664 14.3125 10.7915 14.2147C10.8483 13.9925 10.9565 13.8018 11.1164 13.6419C11.2632 13.4951 11.4256 13.3953 11.618 13.3338C11.7318 13.2974 11.8054 13.2848 11.9765 13.2728C12.1052 13.2638 12.1454 13.2579 12.197 13.2408C12.4032 13.172 12.5679 12.9878 12.612 12.7767C12.6269 12.7056 12.6271 12.5843 12.6124 12.5152C12.5656 12.2942 12.4013 12.1153 12.18 12.0446C12.1327 12.0295 12.1028 12.0263 11.988 12.0245C11.9132 12.0233 11.8394 12.0237 11.824 12.0253Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Lift.tsx

function Lift() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.45833 3.27075C3.34327 3.27075 3.25 3.36403 3.25 3.47909V20.5624C3.25 20.6775 3.34327 20.7708 3.45833 20.7708H6.375V10.7708C6.375 10.4392 6.50669 10.1213 6.74112 9.88687C6.97554 9.65245 7.29348 9.52075 7.625 9.52075H16.375C16.7065 9.52075 17.0245 9.65245 17.2589 9.88687C17.4933 10.1213 17.625 10.4392 17.625 10.7708V20.7708H20.5417C20.6567 20.7708 20.75 20.6775 20.75 20.5624V3.47909C20.75 3.36403 20.6567 3.27075 20.5417 3.27075H3.45833ZM20.5417 22.0208C21.3471 22.0208 22 21.3678 22 20.5624V3.47909C22 2.67367 21.3471 2.02075 20.5417 2.02075H3.45833C2.65292 2.02075 2 2.67367 2 3.47909V20.5624C2 21.3678 2.65292 22.0208 3.45833 22.0208H20.5417ZM16.375 20.7708V10.7708H12.625V20.7708H16.375ZM11.375 20.7708V10.7708H7.625L7.625 20.7708H11.375ZM12.875 4.64575C13.1511 4.43865 13.5429 4.49461 13.75 4.77075L15.125 6.60408L16.5 4.77075C16.7071 4.49461 17.0989 4.43865 17.375 4.64575C17.6511 4.85286 17.7071 5.24461 17.5 5.52075L15.625 8.02075C15.507 8.17813 15.3217 8.27075 15.125 8.27075C14.9283 8.27075 14.743 8.17813 14.625 8.02075L12.75 5.52075C12.5429 5.24461 12.5989 4.85286 12.875 4.64575ZM8.25 4.52075C8.44672 4.52075 8.63197 4.61337 8.75 4.77075L10.625 7.27075C10.8321 7.54689 10.7761 7.93865 10.5 8.14575C10.2239 8.35286 9.83211 8.29689 9.625 8.02075L8.25 6.18742L6.875 8.02075C6.66789 8.29689 6.27614 8.35286 6 8.14575C5.72386 7.93865 5.66789 7.54689 5.875 7.27075L7.75 4.77075C7.86803 4.61337 8.05328 4.52075 8.25 4.52075Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/LightBulb.tsx

function LightBulb() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.91711 11.8828C6.91711 8.76346 9.5087 6.17188 12.628 6.17188C15.7473 6.17188 18.3389 8.76346 18.3389 11.8828C18.3389 13.4485 17.7088 14.8061 16.6763 15.8386C15.9711 16.5437 15.5648 17.5822 15.5648 18.6331V20.2051C15.5648 21.5675 14.4527 22.6795 13.0903 22.6795H12.1656C10.8033 22.6795 9.69123 21.5675 9.69123 20.2051V18.6331C9.69123 17.5876 9.28895 16.5542 8.59038 15.8493C7.52962 14.8871 6.91711 13.4232 6.91711 11.8828ZM12.628 7.42188C10.1991 7.42188 8.16711 9.45382 8.16711 11.8828C8.16711 13.1101 8.65918 14.2296 9.43975 14.9321C9.44789 14.9394 9.45584 14.9469 9.46358 14.9547C10.4229 15.914 10.9412 17.2797 10.9412 18.6331V20.2051C10.9412 20.8771 11.4936 21.4295 12.1656 21.4295H13.0903C13.7623 21.4295 14.3148 20.8771 14.3148 20.2051V18.6331C14.3148 17.2797 14.8331 15.914 15.7924 14.9547C16.6093 14.1378 17.0889 13.0912 17.0889 11.8828C17.0889 9.45382 15.0569 7.42188 12.628 7.42188Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.628 21.4294C12.9732 21.4294 13.253 21.7093 13.253 22.0544V22.9791C13.253 23.3243 12.9732 23.6041 12.628 23.6041C12.2828 23.6041 12.003 23.3243 12.003 22.9791V22.0544C12.003 21.7093 12.2828 21.4294 12.628 21.4294Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.69122 18.3557C9.69122 18.0105 9.97105 17.7307 10.3162 17.7307H14.9398C15.2849 17.7307 15.5648 18.0105 15.5648 18.3557C15.5648 18.7009 15.2849 18.9807 14.9398 18.9807H10.3162C9.97105 18.9807 9.69122 18.7009 9.69122 18.3557Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.863 11.8828C19.863 11.5376 20.1428 11.2578 20.488 11.2578H21.4127C21.7579 11.2578 22.0377 11.5376 22.0377 11.8828C22.0377 12.228 21.7579 12.5078 21.4127 12.5078H20.488C20.1428 12.5078 19.863 12.228 19.863 11.8828Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.628 2.47314C12.9732 2.47314 13.253 2.75297 13.253 3.09814V4.02285C13.253 4.36803 12.9732 4.64785 12.628 4.64785C12.2828 4.64785 12.003 4.36803 12.003 4.02285V3.09814C12.003 2.75297 12.2828 2.47314 12.628 2.47314Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.99051 5.15278C6.23459 4.90871 6.63031 4.90871 6.87439 5.15278L7.52169 5.80008C7.76576 6.04416 7.76576 6.43988 7.52169 6.68396C7.27761 6.92804 6.88188 6.92804 6.6378 6.68396L5.99051 6.03667C5.74643 5.79259 5.74643 5.39686 5.99051 5.15278Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.2809 5.15278C19.0368 4.90871 18.6411 4.90871 18.397 5.15278L17.7497 5.80008C17.5056 6.04416 17.5056 6.43988 17.7497 6.68396C17.9938 6.92804 18.3895 6.92804 18.6336 6.68396L19.2809 6.03667C19.5249 5.79259 19.5249 5.39686 19.2809 5.15278Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.21829 11.8828C3.21829 11.5376 3.49811 11.2578 3.84329 11.2578H4.768C5.11318 11.2578 5.393 11.5376 5.393 11.8828C5.393 12.228 5.11318 12.5078 4.768 12.5078H3.84329C3.49811 12.5078 3.21829 12.228 3.21829 11.8828Z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Materials.tsx

function Materials() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.54145 2.02927C5.20199 2.06412 4.88169 2.19033 4.60145 2.39966C4.50008 2.47538 4.33797 2.63426 4.25836 2.73592C4.05434 2.99647 3.91572 3.32267 3.87391 3.64062C3.86928 3.67582 3.78457 4.53802 3.68567 5.55662C3.58677 6.57522 3.49845 7.48062 3.48941 7.56862C3.48037 7.65662 3.35425 8.95262 3.20913 10.4486C3.06401 11.9446 2.93977 13.2226 2.93305 13.2886C2.8473 14.1294 2.35026 19.2749 2.34755 19.3498C2.34452 19.4332 2.34668 19.4619 2.35988 19.5138C2.39772 19.6623 2.57428 20.0349 2.70727 20.2468C3.0724 20.8288 3.5632 21.2833 4.16545 21.5973C4.83622 21.9471 5.59336 22.0839 6.35124 21.9923C7.06166 21.9065 7.74078 21.612 8.30259 21.1462C8.54296 20.9469 8.81185 20.6507 8.99276 20.3859C9.0073 20.3646 9.02177 20.3502 9.02491 20.3539C9.02805 20.3576 9.05723 20.3984 9.08976 20.4445C9.44595 20.9499 9.94957 21.3758 10.5094 21.6451C11.2301 21.9918 12.0183 22.1014 12.8014 21.9637C13.3438 21.8684 13.8646 21.6497 14.3214 21.3255C14.6528 21.0904 14.9694 20.7733 15.2011 20.4445C15.2337 20.3984 15.2628 20.3576 15.266 20.3539C15.2691 20.3502 15.2836 20.3646 15.2981 20.3859C15.4429 20.5978 15.6268 20.8117 15.8294 21.0036C16.2415 21.394 16.7705 21.6994 17.3167 21.8619C17.9123 22.0392 18.542 22.0677 19.1454 21.9447C20.0647 21.7573 20.883 21.2299 21.4334 20.47C21.5979 20.2429 21.7685 19.9363 21.8726 19.6806C21.9367 19.5234 21.9478 19.4715 21.9433 19.3498C21.9405 19.2719 21.5989 15.7368 21.3418 13.1246C21.3264 12.9684 21.2022 11.6904 21.0658 10.2846C20.9294 8.87882 20.8142 7.69262 20.8097 7.64862C20.8053 7.60462 20.717 6.69922 20.6135 5.63662C20.51 4.57402 20.4216 3.67582 20.417 3.64062C20.392 3.45072 20.3321 3.25644 20.2417 3.07262C20.1368 2.85947 20.0306 2.71351 19.8604 2.54858C19.7052 2.39819 19.5614 2.29807 19.3654 2.20408C19.1982 2.12385 19.0454 2.07577 18.8412 2.03907C18.7703 2.02631 18.3444 2.02535 12.1854 2.02407C8.56644 2.02331 5.57665 2.02565 5.54145 2.02927ZM5.65593 3.27694C5.40565 3.30623 5.18953 3.4959 5.12913 3.73923C5.1188 3.78083 5.05837 4.37224 4.94167 5.57368C4.84694 6.54887 4.76945 7.35385 4.76945 7.36252C4.76945 7.39639 5.08117 7.5202 5.29789 7.57239C6.03989 7.7511 6.79929 7.59219 7.41345 7.12969C7.80665 6.83359 8.11522 6.39537 8.27609 5.90462C8.34787 5.68565 8.38073 5.48483 8.39322 5.18862C8.40102 5.00375 8.41055 4.96036 8.46788 4.84862C8.51373 4.75923 8.63413 4.6389 8.72545 4.59116C8.96702 4.4649 9.25255 4.50399 9.45014 4.69039C9.58834 4.82075 9.64941 4.97555 9.64947 5.19567C9.64966 5.84137 9.95399 6.52451 10.4402 6.97068C10.8513 7.34791 11.2955 7.55337 11.8654 7.62991C11.9656 7.64335 12.3253 7.64335 12.4254 7.62991C12.6923 7.59407 12.9104 7.53568 13.1337 7.44034C13.8051 7.15356 14.3267 6.56903 14.5369 5.86796C14.604 5.64427 14.6309 5.47511 14.6414 5.21262C14.6463 5.09053 14.6528 5.01727 14.6617 4.98491C14.7414 4.69502 15.0224 4.49547 15.3164 4.51988C15.4825 4.53366 15.616 4.59928 15.7303 4.7233C15.8496 4.85265 15.8974 4.98444 15.8974 5.18325C15.8974 5.57803 16.0144 6.01181 16.2172 6.36862C16.505 6.87526 16.9228 7.24266 17.4614 7.46289C18.0953 7.72206 18.8214 7.70304 19.4514 7.41077C19.5041 7.38635 19.5214 7.37447 19.5214 7.36283C19.5214 7.35433 19.4442 6.55115 19.3497 5.57799C19.2344 4.38915 19.173 3.78734 19.1625 3.74375C19.111 3.52822 18.9392 3.35416 18.7148 3.29014L18.6534 3.27262L12.1814 3.27164C8.62184 3.27111 5.68537 3.27349 5.65593 3.27694ZM8.9388 7.3352C8.70787 7.65905 8.40747 7.95895 8.07859 8.19395C7.66453 8.48983 7.1982 8.69813 6.70945 8.80551C6.64345 8.82002 6.58825 8.83264 6.58681 8.83356C6.58196 8.83663 6.62481 8.98477 6.66161 9.09224C6.83453 9.59707 7.18618 10.0509 7.63745 10.3516C7.97509 10.5766 8.36651 10.7162 8.77345 10.7568C8.90005 10.7695 9.16981 10.7674 9.30145 10.7528C10.0028 10.6749 10.6433 10.2971 11.0575 9.71672C11.2169 9.49347 11.3447 9.22804 11.4215 8.96066C11.4405 8.89468 11.4546 8.83845 11.4529 8.83571C11.4512 8.83296 11.4344 8.82834 11.4156 8.82543C11.3456 8.81457 11.1171 8.75487 10.9953 8.7156C10.2221 8.46623 9.55064 7.97243 9.0801 7.3072L9.01968 7.22176L8.9388 7.3352ZM15.2134 7.30262C15.1826 7.34714 15.1272 7.4216 15.0902 7.46809C14.6196 8.05959 14.0051 8.48675 13.2955 8.7156C13.1738 8.75487 12.9453 8.81457 12.8753 8.82543C12.8565 8.82834 12.8397 8.83296 12.838 8.83571C12.832 8.84547 12.9045 9.08236 12.9442 9.18239C13.0591 9.47196 13.2044 9.70613 13.4173 9.94487C13.7072 10.2698 14.0828 10.5114 14.5163 10.6518C14.7562 10.7294 14.9914 10.7651 15.2654 10.7654C15.6449 10.7659 15.9492 10.7021 16.2957 10.5494C16.5611 10.4325 16.8123 10.2581 17.034 10.0369C17.3098 9.76175 17.5074 9.44814 17.6293 9.09224C17.6663 8.98427 17.7089 8.83677 17.7041 8.83335C17.7026 8.83231 17.6532 8.82148 17.5942 8.80929C17.2242 8.7328 16.8109 8.56959 16.4749 8.3673C15.9882 8.07428 15.6213 7.72738 15.2814 7.23891C15.2698 7.22217 15.2678 7.22403 15.2134 7.30262ZM4.63802 8.70262C4.63279 8.72787 4.20102 13.1878 4.20125 13.2142C4.20141 13.2317 4.2173 13.2489 4.28616 13.3062C4.45926 13.4501 4.59413 13.5374 4.79745 13.6369C5.04799 13.7596 5.29205 13.8338 5.57745 13.8741C5.70362 13.8919 6.07654 13.8942 6.19345 13.8779C6.46018 13.8407 6.69982 13.7731 6.92542 13.6716C7.53213 13.3986 8.0171 12.8746 8.24241 12.2486C8.27376 12.1615 8.33219 11.9643 8.32775 11.9606C8.32648 11.9596 8.29665 11.9526 8.26145 11.9451C7.61309 11.8072 7.03521 11.5186 6.54545 11.0879C6.44761 11.0019 6.25941 10.8126 6.18021 10.7206C5.77105 10.2453 5.48612 9.67387 5.35449 9.06462C5.34119 9.00302 5.32791 8.93418 5.32498 8.91164C5.32205 8.88911 5.31692 8.86624 5.31358 8.86083C5.31024 8.85543 5.26209 8.84262 5.2066 8.83237C5.06506 8.80624 4.89693 8.76395 4.76441 8.72114C4.70224 8.70105 4.64921 8.68462 4.64657 8.68462C4.64392 8.68462 4.64007 8.69272 4.63802 8.70262ZM19.5414 8.71703C19.4192 8.75711 19.2188 8.80786 19.0863 8.83231C19.0296 8.84277 18.9805 8.85569 18.9772 8.861C18.9739 8.86631 18.9688 8.88911 18.9659 8.91164C18.9422 9.094 18.8502 9.41771 18.7494 9.67262C18.5168 10.2615 18.0979 10.8188 17.5854 11.2213C17.3556 11.4018 17.087 11.5659 16.8334 11.6808C16.5729 11.7988 16.308 11.8859 16.0294 11.9451C15.9942 11.9526 15.9644 11.9596 15.9631 11.9606C15.9587 11.9643 16.0171 12.1615 16.0485 12.2486C16.2696 12.8628 16.7377 13.3765 17.331 13.6559C17.5566 13.7621 17.7995 13.8338 18.0694 13.8739C18.2057 13.8941 18.5716 13.8942 18.7134 13.8741C18.9993 13.8337 19.243 13.7596 19.4934 13.6369C19.6968 13.5374 19.8316 13.4501 20.0047 13.3062C20.0736 13.2489 20.0895 13.2317 20.0896 13.2142C20.0898 13.1878 19.658 8.72784 19.6528 8.70262C19.6508 8.69272 19.6465 8.68483 19.6433 8.68509C19.6401 8.68535 19.5942 8.69972 19.5414 8.71703ZM12.0974 10.4144C12.0732 10.4504 12.0195 10.5231 11.9781 10.5762C11.4894 11.2016 10.8216 11.6533 10.0574 11.8755C9.97393 11.8998 9.80149 11.9418 9.74265 11.9522C9.71215 11.9576 9.71191 11.9579 9.71737 11.9871C9.72041 12.0032 9.73545 12.0579 9.7508 12.1085C9.84357 12.4147 10.0028 12.7185 10.1972 12.96C10.5633 13.4151 11.0962 13.7373 11.6654 13.8476C11.8418 13.8817 11.9223 13.8886 12.1454 13.8886C12.3686 13.8886 12.4491 13.8817 12.6254 13.8476C12.8454 13.8049 13.0426 13.7372 13.2614 13.629C13.7464 13.3893 14.1414 12.993 14.3814 12.5053C14.4227 12.4213 14.469 12.3184 14.4843 12.2766C14.5166 12.1886 14.5655 12.0298 14.5735 11.9871C14.579 11.9579 14.5787 11.9576 14.5482 11.9522C14.4894 11.9418 14.317 11.8998 14.2334 11.8755C13.7676 11.7401 13.3189 11.5095 12.9454 11.2138C12.6628 10.9899 12.3753 10.6843 12.1934 10.4144C12.1692 10.3785 12.1476 10.3491 12.1454 10.3491C12.1432 10.3491 12.1216 10.3785 12.0974 10.4144ZM8.98958 13.5144C8.94511 13.5848 8.8137 13.7548 8.7237 13.8584C8.26145 14.3903 7.64997 14.7849 6.97345 14.9877C6.8593 15.0219 6.72225 15.0568 6.64145 15.0721C6.5793 15.0838 6.58016 15.0771 6.62221 15.2235C6.70519 15.5125 6.8713 15.8323 7.06526 16.0766C7.14825 16.1811 7.35638 16.39 7.45745 16.4702C7.83532 16.7699 8.25629 16.9445 8.74945 17.0058C8.85709 17.0192 9.1834 17.0192 9.28945 17.0058C9.82209 16.9385 10.2639 16.7458 10.6535 16.4106C11.0328 16.0844 11.3077 15.6449 11.4367 15.1586L11.4563 15.0846L11.4389 15.0812C11.4293 15.0794 11.353 15.0615 11.2694 15.0416C11.0814 14.9967 10.9504 14.9555 10.7692 14.884C10.0858 14.6144 9.50492 14.156 9.06949 13.5426C9.04373 13.5063 9.02057 13.4766 9.01805 13.4766C9.01552 13.4766 9.00271 13.4936 8.98958 13.5144ZM15.2214 13.5426C15.0892 13.7288 14.9777 13.8619 14.8186 14.0235C14.5102 14.3367 14.1825 14.5732 13.7906 14.7655C13.6432 14.8379 13.4287 14.9243 13.2774 14.9723C13.1939 14.9989 12.9353 15.0651 12.852 15.0812L12.8346 15.0846L12.8542 15.1586C13.0727 15.9827 13.6986 16.6413 14.5091 16.9002C14.664 16.9497 14.8183 16.983 14.9974 17.0057C15.1005 17.0188 15.4374 17.0189 15.5414 17.0059C16.0322 16.9444 16.4541 16.77 16.8294 16.4734C16.9333 16.3913 17.1408 16.1835 17.2256 16.0766C17.4205 15.8311 17.5868 15.5103 17.669 15.2213C17.7104 15.0757 17.7115 15.0838 17.6494 15.0721C17.5686 15.0568 17.4316 15.0219 17.3174 14.9877C16.6409 14.7849 16.0294 14.3903 15.5672 13.8584C15.4772 13.7548 15.3458 13.5848 15.3013 13.5144C15.2882 13.4936 15.2754 13.4766 15.2728 13.4766C15.2703 13.4766 15.2472 13.5063 15.2214 13.5426ZM4.05453 14.7026C4.05192 14.7213 3.95036 15.759 3.82884 17.0086L3.60789 19.2806L3.66818 19.4008C4.01652 20.0951 4.67815 20.588 5.44945 20.7277C5.61249 20.7572 5.71696 20.7661 5.89745 20.766C6.29313 20.7657 6.63789 20.6852 6.99745 20.5089C7.37864 20.3221 7.68913 20.0581 7.9355 19.7115C8.22303 19.3071 8.39326 18.7834 8.39342 18.3028C8.39345 18.2244 8.39268 18.2208 8.37545 18.2169C8.36555 18.2147 8.31217 18.2038 8.25683 18.1927C7.51425 18.0433 6.79636 17.6386 6.27529 17.0754C6.01184 16.7907 5.81209 16.4987 5.64577 16.1551C5.4921 15.8377 5.39 15.5262 5.32929 15.1897C5.32107 15.1441 5.31286 15.1054 5.31106 15.1036C5.30925 15.1018 5.27935 15.0952 5.24461 15.089C4.85499 15.0197 4.4596 14.8835 4.13006 14.7051C4.093 14.685 4.0619 14.6686 4.06097 14.6686C4.06003 14.6686 4.05713 14.6839 4.05453 14.7026ZM20.1574 14.7059C19.8425 14.8812 19.4161 15.0259 19.008 15.0961C18.9751 15.1017 18.9814 15.0847 18.9495 15.2526C18.9424 15.29 18.9244 15.3692 18.9096 15.4286C18.6833 16.3372 18.1245 17.1269 17.3374 17.6503C16.9528 17.9061 16.4793 18.1031 16.0341 18.1927C15.9787 18.2038 15.9253 18.2147 15.9154 18.2169C15.8982 18.2208 15.8974 18.2244 15.8975 18.3028C15.898 18.7853 16.0674 19.3064 16.3554 19.7115C16.6018 20.0581 16.9123 20.3221 17.2934 20.5089C17.6546 20.6859 17.9982 20.7659 18.3974 20.7659C18.5864 20.7659 18.7186 20.753 18.8975 20.7169C19.6404 20.567 20.2842 20.0758 20.6227 19.4008L20.6829 19.2806L20.4623 17.0126C20.2264 14.5873 20.2346 14.6682 20.2267 14.6695C20.2238 14.6699 20.1926 14.6863 20.1574 14.7059ZM12.0857 16.6826C11.8658 16.9932 11.5742 17.2928 11.2654 17.5253C10.8267 17.8556 10.2471 18.1118 9.72945 18.2041L9.65345 18.2177L9.65379 18.3531C9.65511 18.8682 9.85841 19.4189 10.2044 19.8445C10.2773 19.9343 10.4587 20.1173 10.548 20.1913C10.9244 20.5034 11.373 20.6951 11.8614 20.7528C12.0957 20.7804 12.4049 20.7672 12.6414 20.7193C13.0443 20.6379 13.4236 20.456 13.7429 20.1913C13.8439 20.1076 14.0197 19.9278 14.1037 19.8223C14.4356 19.4056 14.6341 18.8615 14.6367 18.3611L14.6374 18.2177L14.5614 18.2041C14.2819 18.1542 13.9346 18.0392 13.6432 17.9001C13.0809 17.6316 12.572 17.2007 12.2052 16.6826C12.1748 16.6397 12.1479 16.6046 12.1454 16.6046C12.143 16.6046 12.1161 16.6397 12.0857 16.6826Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Parking.tsx

function Parking() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.278 2.02549C16.2538 2.0271 16.1764 2.03229 16.106 2.03702C15.012 2.11054 13.9151 2.53659 13.0434 3.22656C12.7027 3.49627 12.3566 3.84372 12.0929 4.18077C11.4698 4.97716 11.0744 5.92188 10.9461 6.92077C10.8875 7.37698 10.8862 7.88309 10.9426 8.34478C11.0428 9.16549 11.3392 9.98494 11.7881 10.6821C12.5859 11.9209 13.8325 12.799 15.262 13.1289C15.8937 13.2746 16.5858 13.308 17.246 13.2244C18.7921 13.0286 20.188 12.1911 21.109 10.9065C21.5828 10.2457 21.9202 9.44283 22.0628 8.63678C22.1226 8.2983 22.1455 8.02453 22.1455 7.64478C22.1455 7.34303 22.1369 7.19206 22.1056 6.94077C22.0028 6.1165 21.716 5.32233 21.2678 4.62077C20.7261 3.77295 19.9453 3.06697 19.0579 2.62272C18.3968 2.29174 17.73 2.10345 16.994 2.03992C16.8666 2.02892 16.3754 2.01902 16.278 2.02549ZM16.406 3.27437C15.4086 3.2982 14.439 3.67227 13.6776 4.32704C12.8337 5.05273 12.3029 6.05453 12.1783 7.15677C12.117 7.69843 12.1659 8.31153 12.3109 8.82078C12.5485 9.65463 13.0045 10.3767 13.65 10.941C14.1952 11.4175 14.8581 11.7548 15.558 11.9116C16.4089 12.1023 17.2973 12.0371 18.102 11.7249C18.6697 11.5048 19.1533 11.1917 19.5892 10.7621C19.9653 10.3915 20.2295 10.024 20.4587 9.55278C20.7038 9.04888 20.8418 8.53758 20.8861 7.96878C20.9047 7.72977 20.896 7.37146 20.8653 7.11278C20.7635 6.25373 20.394 5.42708 19.8169 4.76703C19.6622 4.59017 19.4052 4.34669 19.218 4.19971C18.6725 3.77135 18.0084 3.47199 17.3227 3.34532C17.0421 3.29349 16.7034 3.26728 16.406 3.27437ZM15.1985 4.52486C15.0203 4.54444 14.8517 4.65014 14.7469 4.80793C14.7115 4.86141 14.6833 4.92758 14.6639 5.00306C14.6509 5.05341 14.65 5.21909 14.65 7.64478C14.65 10.4041 14.648 10.2549 14.6873 10.3648C14.7365 10.5026 14.8627 10.641 15.0036 10.7117C15.0848 10.7525 15.1601 10.7683 15.274 10.7683C15.388 10.7683 15.4632 10.7525 15.5445 10.7117C15.6822 10.6426 15.8025 10.5135 15.8586 10.3746C15.902 10.267 15.902 10.2667 15.902 9.2283V8.2699L16.324 8.26641C16.7765 8.26266 16.8065 8.26028 16.9865 8.21384C17.5248 8.07499 17.971 7.7097 18.2141 7.20878C18.3039 7.02361 18.369 6.79268 18.3908 6.58164C18.4038 6.45587 18.3959 6.21194 18.3749 6.08878C18.3066 5.68819 18.1104 5.3165 17.8228 5.0428C17.6759 4.90302 17.542 4.80938 17.358 4.71793C17.1747 4.62677 17.003 4.57223 16.7942 4.53885C16.6951 4.52298 16.6556 4.52209 15.974 4.52026C15.5802 4.51919 15.2313 4.52126 15.1985 4.52486ZM15.902 6.39685V7.02179L16.268 7.01882C16.6204 7.01596 16.6363 7.01518 16.6938 6.99779C16.8047 6.96429 16.8735 6.92206 16.962 6.83314C17.053 6.74181 17.0982 6.66693 17.1273 6.55962C17.152 6.46855 17.152 6.32076 17.1272 6.23323C17.0791 6.06323 16.9559 5.91316 16.802 5.8373C16.6811 5.77766 16.6854 5.77817 16.272 5.77486L15.902 5.7719V6.39685ZM8.32204 8.27411C7.69128 8.3045 7.08151 8.583 6.64777 9.03879C6.41429 9.28415 6.26696 9.50794 6.13562 9.81678C6.06839 9.97485 4.79093 12.8213 4.77849 12.8408C4.77287 12.8496 4.73806 12.8691 4.70115 12.8842C4.60232 12.9246 4.39409 13.0292 4.30012 13.0857C3.64862 13.4777 3.17238 14.071 2.9342 14.7875C2.87892 14.9539 2.84508 15.088 2.81854 15.246C2.77767 15.4894 2.77804 15.4763 2.77804 16.6888C2.77804 17.9543 2.77528 17.8842 2.83384 18.1125C2.91595 18.4327 3.07596 18.7169 3.30993 18.9582L3.39776 19.0488L3.39792 19.6328C3.39802 19.9652 3.40163 20.2564 3.4063 20.3088C3.4836 21.1755 4.13924 21.8695 5.00604 22.0021C5.13508 22.0218 5.41508 22.0219 5.54204 22.0022C6.37054 21.8738 6.99508 21.2521 7.13084 20.4208C7.14212 20.3518 7.14516 20.2644 7.14793 19.9308L7.15131 19.5248H12.1501H17.1489L17.1521 19.9348C17.1548 20.2763 17.1577 20.3588 17.1693 20.4288C17.2379 20.8414 17.4251 21.2037 17.7151 21.4851C17.8703 21.6356 18.0169 21.7391 18.202 21.829C19.0727 22.2514 20.1103 21.9513 20.6218 21.129C20.7157 20.9781 20.8169 20.7289 20.8548 20.5551C20.8964 20.3646 20.8966 20.3616 20.8999 19.6826L20.903 19.0444L20.9766 18.9706C21.2607 18.6856 21.442 18.323 21.5075 17.9088C21.5211 17.823 21.522 17.7405 21.522 16.6928C21.522 15.8198 21.5197 15.5456 21.5115 15.4648C21.4727 15.0825 21.3735 14.7334 21.2093 14.4008C21.0726 14.124 20.998 14.0343 20.842 13.9598C20.6319 13.8594 20.4026 13.8773 20.2082 14.0093C20.0367 14.1258 19.9426 14.3097 19.9422 14.5293C19.942 14.6405 19.9619 14.7113 20.0309 14.8444C20.1425 15.0599 20.1967 15.2039 20.2332 15.382C20.2703 15.5635 20.2711 15.5934 20.2685 16.7168L20.266 17.7768L20.2436 17.8408C20.21 17.9365 20.164 18.0082 20.0867 18.0855C20.0096 18.1627 19.9247 18.2142 19.822 18.2461L19.762 18.2648H12.154C5.84329 18.2648 4.53853 18.263 4.50204 18.2541C4.47784 18.2482 4.42024 18.2251 4.37404 18.2026C4.29876 18.166 4.2817 18.1535 4.20972 18.0813C4.14371 18.0151 4.1234 17.9887 4.09562 17.9328C4.07703 17.8954 4.05376 17.836 4.04392 17.8008L4.02604 17.7368V16.6808C4.02604 15.5234 4.02469 15.5603 4.07444 15.3488C4.12085 15.1514 4.22492 14.9071 4.33179 14.7448C4.63168 14.2892 5.1168 13.9856 5.66204 13.9124C5.73299 13.9028 6.1922 13.9011 8.61804 13.9009C10.5127 13.9008 11.5194 13.898 11.5763 13.8926C11.7421 13.8769 11.8519 13.8252 11.966 13.7093C12.1013 13.572 12.1579 13.4244 12.1473 13.2368C12.1377 13.0689 12.0826 12.9453 11.9646 12.8274C11.8846 12.7474 11.8104 12.7045 11.674 12.6595C11.6478 12.6508 11.1537 12.6485 8.94404 12.6468C7.46013 12.6456 6.24604 12.6426 6.24604 12.6402C6.24604 12.6378 6.4794 12.1149 6.76462 11.4783C7.04984 10.8417 7.2972 10.2886 7.31431 10.2493C7.37563 10.1084 7.46274 9.98738 7.58971 9.86665C7.75711 9.70748 7.96353 9.5982 8.19404 9.54671C8.25905 9.53219 8.30753 9.53007 8.69404 9.52487C9.17701 9.51837 9.18482 9.51746 9.30833 9.45315C9.47211 9.36788 9.59996 9.20485 9.63486 9.03678C9.65264 8.95114 9.65072 8.81634 9.6306 8.73841C9.56947 8.50159 9.36654 8.31614 9.12604 8.2773C9.07992 8.26985 8.4614 8.2674 8.32204 8.27411ZM6.05804 15.1574C5.66444 15.2236 5.34804 15.5429 5.2858 15.9368C5.27592 15.9993 5.27392 16.1504 5.2822 16.2099C5.33073 16.559 5.58078 16.8602 5.91501 16.9722C6.11159 17.038 6.34295 17.035 6.53393 16.9639C6.83984 16.8501 7.06218 16.5924 7.13022 16.2728C7.1504 16.178 7.15419 16.0327 7.13892 15.9396C7.12522 15.856 7.08819 15.7366 7.05614 15.6728C6.9217 15.4048 6.66507 15.2111 6.37856 15.1611C6.30287 15.1479 6.12657 15.1458 6.05804 15.1574ZM17.9005 15.1641C17.8124 15.1833 17.785 15.1922 17.706 15.2274C17.3711 15.3768 17.1499 15.7158 17.1501 16.0798C17.1503 16.6612 17.6657 17.1011 18.238 17.0084C18.5293 16.9612 18.7847 16.7752 18.9196 16.5121C18.9994 16.3564 19.0261 16.2328 19.0196 16.0488C19.0148 15.9131 18.9992 15.8375 18.9533 15.7264C18.8397 15.4512 18.6107 15.2522 18.3184 15.1748C18.2124 15.1467 18.005 15.1414 17.9005 15.1641ZM4.65582 19.8988C4.65842 20.2659 4.65881 20.2738 4.67717 20.3288C4.71827 20.4518 4.78888 20.5535 4.88867 20.6334C4.99892 20.7217 5.12634 20.7654 5.27308 20.7654C5.37973 20.7654 5.45817 20.748 5.54604 20.705C5.67451 20.642 5.77004 20.5466 5.8346 20.4168C5.89354 20.2982 5.8956 20.2812 5.89984 19.8788L5.90356 19.5248H5.27836H4.65316L4.65582 19.8988ZM18.4002 19.8828C18.4039 20.2696 18.4051 20.282 18.4509 20.3908C18.5252 20.5676 18.7019 20.7149 18.8855 20.7532C18.9699 20.7708 19.0992 20.769 19.178 20.7491C19.3818 20.6978 19.5515 20.5387 19.621 20.3341L19.6418 20.2728L19.6443 19.8988L19.6469 19.5248H19.0218H18.3967L18.4002 19.8828Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Plans.tsx

function Plans() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.26685 2.66659C6.00075 2.70905 5.76057 2.831 5.57172 3.01952C5.38628 3.20465 5.26836 3.43275 5.21671 3.7063C5.20399 3.77364 5.20292 4.03714 5.20086 7.58812L5.19865 11.3977L4.20076 11.401C3.11904 11.4047 3.15736 11.4031 2.99485 11.4494C2.77952 11.5107 2.61706 11.6049 2.45613 11.7617C2.2749 11.9383 2.16135 12.1438 2.10134 12.4035L2.08309 12.4825L2.08084 16.9945C2.07879 21.0692 2.0798 21.5143 2.09117 21.5865C2.13567 21.869 2.2641 22.117 2.46414 22.3069C2.65834 22.4912 2.88032 22.6002 3.14685 22.6422C3.21913 22.6536 3.69252 22.6546 8.05085 22.6526L12.8749 22.6503L12.9549 22.6319C13.2048 22.5744 13.4147 22.4606 13.586 22.2896C13.7715 22.1044 13.8897 21.8756 13.9409 21.6028C13.9534 21.5361 13.9547 21.3558 13.9568 19.2806L13.9592 17.0307L17.477 17.0285L20.9949 17.0263L21.0749 17.0079C21.4424 16.9238 21.7377 16.7088 21.9181 16.3942C21.987 16.2742 22.0495 16.0911 22.0683 15.9545C22.0719 15.9281 22.077 17.1701 22.0795 18.7145C22.0821 20.2589 22.083 18.518 22.0816 14.8457C22.079 8.17607 22.079 8.16876 22.0627 8.07371C21.9716 7.5406 21.5554 7.13073 21.0149 7.04199C20.9578 7.03262 20.5844 7.0308 18.701 7.03068L16.4551 7.03054L16.4528 5.38454L16.4504 3.73854L16.4322 3.65854C16.3743 3.40469 16.2654 3.20308 16.0909 3.02634C15.8952 2.82832 15.6684 2.71288 15.3829 2.66599C15.2861 2.65009 6.36651 2.65068 6.26685 2.66659ZM6.45485 7.65412V11.3977L7.12485 11.4004C7.78603 11.4031 7.79569 11.4034 7.85885 11.4207C7.89405 11.4304 7.95345 11.4536 7.99085 11.4722C8.04641 11.4999 8.07364 11.5208 8.13971 11.5863C8.2292 11.6751 8.26833 11.7361 8.30012 11.8362C8.33848 11.957 8.33837 12.1045 8.29984 12.2258C8.24819 12.3885 8.10468 12.5427 7.94285 12.6094C7.8272 12.6571 7.97955 12.6543 5.55685 12.6544L3.33485 12.6545V14.5265V16.3985L5.20085 16.3987C6.33952 16.3988 7.09534 16.4018 7.13993 16.4065C7.29537 16.4229 7.40149 16.4737 7.51562 16.5865C7.63568 16.7052 7.68677 16.8127 7.70265 16.9802C7.708 17.0366 7.71084 17.8179 7.71084 19.2325L7.71085 21.3985H10.2069H12.7029V17.0265V12.6545L12.0409 12.6544C11.3222 12.6543 11.3238 12.6543 11.2149 12.6094C11.0531 12.5427 10.9095 12.3885 10.8579 12.226C10.8188 12.1027 10.8187 11.9586 10.8578 11.8354C10.8894 11.7361 10.9287 11.6749 11.018 11.5863C11.0841 11.5208 11.1113 11.4999 11.1669 11.4722C11.2043 11.4536 11.2637 11.4303 11.2989 11.4204L11.3629 11.4026L13.2809 11.4004L15.1989 11.3982V7.65438V3.91054H10.8269H6.45485V7.65412ZM16.4528 9.92854L16.4504 11.5705L16.4322 11.6505C16.3743 11.9044 16.2654 12.106 16.0909 12.2827C15.8957 12.4803 15.6678 12.5963 15.3829 12.6431C15.3285 12.652 15.1786 12.6543 14.6369 12.6544L13.9589 12.6545V14.2145V15.7745H17.3909H20.8229V12.0305V8.28654H18.639H16.4551L16.4528 9.92854ZM2.08282 17.0305C2.08282 19.5099 2.08374 20.5242 2.08485 19.2845C2.08596 18.0448 2.08596 16.0162 2.08485 14.7765C2.08374 13.5368 2.08282 14.5511 2.08282 17.0305ZM3.33485 18.2785V18.9025H4.89485H6.45485V18.2785V17.6545H4.89485H3.33485V18.2785ZM3.33485 20.7785V21.3985H4.89485H6.45485V20.7785V20.1585H4.89485H3.33485V20.7785Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/SecurityCamera.tsx

function SecurityCamera() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.43601 3.56046C6.23335 3.6004 5.08937 4.01819 4.14401 4.76271C3.81052 5.02536 3.45533 5.38216 3.19088 5.72016C2.56289 6.52283 2.16112 7.4939 2.04065 8.50016C2.01206 8.73905 2.00429 8.88511 2.00427 9.18416C2.00425 9.49216 2.01189 9.62578 2.04453 9.88816C2.227 11.3549 2.98657 12.6925 4.16001 13.6136C4.94767 14.2318 5.89966 14.6307 6.89761 14.7605C7.21266 14.8015 7.23813 14.8023 8.39403 14.8059L9.48004 14.8093L9.47459 14.8307C9.4716 14.8425 9.22567 15.826 8.92809 17.0162L8.38702 19.1802L7.93952 19.1842L7.49201 19.1882L7.42801 19.2106C7.23322 19.279 7.08543 19.4328 7.0228 19.6324C7.00657 19.6841 7.0041 19.7079 7.00455 19.8082C7.00499 19.9079 7.00783 19.9332 7.02479 19.9883C7.08619 20.1878 7.25348 20.353 7.45169 20.4097L7.51601 20.4282H12H16.484L16.5483 20.4097C16.7466 20.353 16.9138 20.1878 16.9752 19.9883C16.9922 19.9332 16.995 19.9079 16.9955 19.8082C16.9959 19.7079 16.9935 19.6841 16.9772 19.6324C16.9148 19.4333 16.7663 19.2788 16.572 19.2106L16.508 19.1882L16.0602 19.1842L15.6125 19.1802L15.068 16.9962L14.5235 14.8122L15.6077 14.8073C16.7589 14.8022 16.7896 14.8013 17.1024 14.7605C18.3304 14.6007 19.4657 14.0425 20.3432 13.167C21.2961 12.2163 21.87 10.9844 21.9804 9.65216C21.9866 9.57736 21.9918 9.48647 21.9918 9.45016C21.9919 9.41161 21.9953 9.38416 22 9.38416C22.0051 9.38416 22.008 9.30934 22.008 9.17569C22.008 9.03875 22.0053 8.96891 22 8.97216C21.995 8.97529 21.992 8.95512 21.992 8.91727C21.992 8.88435 21.9866 8.79143 21.9801 8.71079C21.8914 7.62383 21.4858 6.58813 20.8089 5.72016C20.5473 5.38478 20.19 5.0257 19.856 4.76271C19.0524 4.12977 18.081 3.72312 17.08 3.6005C16.6981 3.55372 17.0664 3.55704 12.128 3.55578C9.64421 3.55514 7.53281 3.55725 7.43601 3.56046ZM7.34801 4.81701C6.53577 4.86816 5.74524 5.14873 5.08865 5.61888C4.40373 6.10933 3.87738 6.77778 3.56638 7.55216C3.3984 7.97042 3.29935 8.39693 3.26356 8.85616C3.25201 9.00426 3.25216 9.372 3.26382 9.51216C3.30799 10.0431 3.42434 10.5011 3.63518 10.9739C4.06788 11.9442 4.86394 12.7387 5.84001 13.1745C6.30044 13.3801 6.76155 13.4979 7.27201 13.5403C7.48276 13.5578 16.5173 13.5578 16.728 13.5403C17.5934 13.4683 18.4001 13.1533 19.072 12.625C19.9769 11.9134 20.5695 10.8727 20.7116 9.74549C20.7565 9.38901 20.758 8.98728 20.7156 8.64416C20.6183 7.8566 20.304 7.10143 19.8168 6.48416C19.0325 5.49053 17.8941 4.89391 16.6348 4.81659C16.4693 4.80643 7.50961 4.80683 7.34801 4.81701ZM11.8 6.06115C11.4788 6.09001 11.2747 6.13031 11.016 6.21592C10.3239 6.44499 9.74138 6.90349 9.34594 7.53036C9.22808 7.71719 9.10519 7.97988 9.02869 8.20851C8.86693 8.69191 8.83165 9.27171 8.93283 9.78416C9.12078 10.7362 9.73583 11.5434 10.6047 11.9786C10.954 12.1535 11.3469 12.2641 11.7331 12.2961C11.8552 12.3062 12.1449 12.3062 12.2669 12.2961C12.6531 12.2641 13.046 12.1535 13.3953 11.9786C13.9092 11.7212 14.3473 11.3236 14.6494 10.8402C15.2211 9.92541 15.2816 8.77793 14.809 7.81129C14.6473 7.48045 14.4473 7.20557 14.175 6.93997C13.6798 6.4569 13.0536 6.16005 12.352 6.07578C12.2494 6.06345 11.8826 6.05373 11.8 6.06115ZM11.884 7.31263C11.3798 7.34114 10.8932 7.58613 10.5662 7.97616C10.3514 8.23239 10.2072 8.54516 10.1513 8.87616C10.13 9.00202 10.1225 9.23585 10.1355 9.36416C10.1715 9.71798 10.2975 10.0364 10.5153 10.3242C10.6245 10.4685 10.8205 10.6499 10.98 10.7543C11.0771 10.8178 11.2713 10.9122 11.385 10.9511C11.6038 11.0259 11.7611 11.0516 12 11.0516C12.3115 11.0516 12.5514 10.9962 12.828 10.8603C13.0325 10.7599 13.1808 10.6515 13.3442 10.4832C13.4953 10.3273 13.581 10.2057 13.6797 10.007C13.7802 9.80482 13.8413 9.5922 13.8645 9.36416C13.8776 9.23539 13.87 9.00187 13.8486 8.87616C13.7257 8.15283 13.2055 7.5747 12.4992 7.37627C12.3865 7.34463 12.2503 7.32115 12.1487 7.31588C12.1043 7.31357 12.05 7.31057 12.028 7.30922C12.006 7.30786 11.9412 7.30939 11.884 7.31263ZM2.00351 9.18416C2.00351 9.30076 2.00463 9.34847 2.00599 9.29016C2.00736 9.23186 2.00736 9.13647 2.00599 9.07816C2.00463 9.01986 2.00351 9.06756 2.00351 9.18416ZM10.225 16.9882C9.92526 18.1871 9.68001 19.1717 9.68001 19.1762C9.68001 19.1815 10.4566 19.1842 12 19.1842C13.5435 19.1842 14.32 19.1815 14.32 19.1762C14.32 19.1717 14.0748 18.1871 13.775 16.9882L13.23 14.8082H12H10.77L10.225 16.9882Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/SmartHome.tsx

function SmartHome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.3562 2.47152C11.0255 2.49305 10.7182 2.59858 10.4367 2.78728C10.2522 2.911 1.72659 9.16597 1.67102 9.21844C1.47976 9.39899 1.42819 9.71241 1.55134 9.94583C1.62027 10.0765 1.70925 10.1647 1.8319 10.224C1.93264 10.2727 1.99575 10.287 2.1118 10.2873C2.22634 10.2877 2.28217 10.275 2.38004 10.2263C2.43145 10.2007 3.52541 9.40226 6.7983 7.00158C9.58266 4.95923 11.1692 3.80033 11.2066 3.78157C11.2946 3.73734 11.3628 3.72267 11.4803 3.72267C11.5978 3.72267 11.666 3.73734 11.754 3.78151C11.7912 3.8002 13.3841 4.96379 16.1622 7.00153C19.4393 9.40526 20.5291 10.2007 20.5806 10.2263C20.6785 10.275 20.7343 10.2877 20.8489 10.2873C20.9649 10.287 21.028 10.2727 21.1288 10.224C21.2514 10.1647 21.3404 10.0765 21.4093 9.94583C21.4399 9.88795 21.4686 9.79899 21.4686 9.76246C21.4686 9.75035 21.4722 9.74044 21.4766 9.74044C21.4814 9.74044 21.4846 9.70829 21.4846 9.66C21.4846 9.61576 21.4815 9.5815 21.4776 9.58388C21.4738 9.58625 21.4682 9.5699 21.4653 9.54754C21.451 9.44024 21.3763 9.30028 21.2896 9.21844C21.2341 9.16603 12.7087 2.91119 12.5239 2.7873C12.3081 2.64261 12.1006 2.55558 11.8482 2.50396C11.7004 2.47371 11.5126 2.46134 11.3562 2.47152ZM17.0103 2.79666C16.7767 2.82972 16.5671 3.01334 16.5009 3.24285C16.4852 3.29722 16.4826 3.32423 16.4831 3.42278C16.4837 3.52599 16.4861 3.54578 16.5051 3.60272C16.5388 3.70412 16.5842 3.77721 16.6616 3.85499C16.7762 3.9702 16.8908 4.0244 17.0501 4.03879C17.0942 4.04276 17.545 4.04614 18.0519 4.04628L18.9735 4.04655L18.9736 4.98021C18.9737 5.55145 18.9768 5.941 18.9817 5.98378C19.011 6.23984 19.1877 6.44857 19.4349 6.5193C19.5265 6.54551 19.6885 6.54526 19.7733 6.51877C19.9894 6.45122 20.1451 6.29382 20.207 6.08013L20.2251 6.01782V3.31482L20.207 3.25252C20.1457 3.04088 19.9952 2.88726 19.7773 2.81387L19.7213 2.79502L18.3778 2.79414C17.6388 2.79365 17.0235 2.79478 17.0103 2.79666ZM1.48699 9.66847C1.48699 9.71465 1.48831 9.73355 1.48992 9.71045C1.49154 9.68736 1.49154 9.64958 1.48992 9.62648C1.48831 9.60339 1.48699 9.62229 1.48699 9.66847ZM4.46092 10.3048C4.34507 10.3302 4.20959 10.4154 4.12637 10.5152C4.07068 10.582 4.01671 10.6888 3.99775 10.7696C3.98364 10.8297 3.9831 10.9972 3.9831 15.3184C3.9831 19.6369 3.98365 19.8086 3.99787 19.9087C4.086 20.5294 4.46318 21.0579 5.01674 21.3361C5.19088 21.4237 5.38594 21.4857 5.5868 21.5176C5.67476 21.5315 5.91346 21.5321 11.4803 21.5321C17.0472 21.5321 17.2859 21.5315 17.3739 21.5176C17.9122 21.4323 18.3678 21.1423 18.667 20.6944C18.7883 20.5128 18.8918 20.2661 18.9363 20.0526C18.9802 19.8419 18.9638 19.7754 18.9638 19.7754C18.9638 19.7754 18.9638 19.6162 18.9638 19.3859C18.9113 19.162 18.7134 18.9653 18.4944 18.9192C18.4231 18.9042 18.2832 18.9039 18.214 18.9186C17.9969 18.9646 17.8155 19.1386 17.7452 19.3682C17.7316 19.4129 17.7124 19.5421 17.7124 19.7514L17.722 19.7807L17.7032 19.8367C17.6657 19.9484 17.6247 20.0147 17.5424 20.0966C17.4215 20.2169 17.3209 20.2644 17.1524 20.2804C17.0418 20.2908 5.92242 20.2913 5.80643 20.2808C5.64392 20.2661 5.53801 20.2159 5.41823 20.0966C5.33591 20.0147 5.29494 19.9484 5.25743 19.8367L5.23864 19.7807L5.2345 15.2904C5.23056 11.0037 5.22973 10.7979 5.21605 10.7532C5.14587 10.524 4.96406 10.3496 4.74732 10.3036C4.68152 10.2897 4.52701 10.2903 4.46092 10.3048Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.3912 12.4171C17.2446 12.4171 16.1449 12.8727 15.3341 13.6834C15.0901 13.9275 14.6943 13.9275 14.4503 13.6834C14.2062 13.4393 14.2062 13.0436 14.4503 12.7995C15.4955 11.7543 16.9131 11.1671 18.3912 11.1671C19.8694 11.1671 21.287 11.7543 22.3322 12.7995C22.5763 13.0436 22.5763 13.4393 22.3322 13.6834C22.0881 13.9275 21.6924 13.9275 21.4483 13.6834C20.6375 12.8726 19.5379 12.4171 18.3912 12.4171Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.3911 15.0331C17.7366 15.0331 17.1089 15.293 16.6461 15.7557C16.402 15.9998 16.0063 15.9997 15.7622 15.7556C15.5182 15.5115 15.5182 15.1158 15.7623 14.8717C16.4596 14.1746 17.4052 13.7831 18.3911 13.7831C19.377 13.7831 20.3226 14.1746 21.0199 14.8717C21.264 15.1158 21.264 15.5115 21.02 15.7556C20.776 15.9997 20.3802 15.9998 20.1361 15.7557C19.6733 15.293 19.0456 15.0331 18.3911 15.0331Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2618 17.0866C19.2618 17.5675 18.8721 17.9572 18.3912 17.9572C17.9104 17.9572 17.5206 17.5675 17.5206 17.0866C17.5206 16.6058 17.9104 16.216 18.3912 16.216C18.8721 16.216 19.2618 16.6058 19.2618 17.0866Z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/small/SteamOven.tsx

function SteamOven() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.46905 2.02689C3.29108 2.05694 3.1153 2.1873 3.02822 2.35383C2.97716 2.45149 2.96326 2.51239 2.96316 2.63886C2.96307 2.76459 2.97143 2.80903 3.01188 2.89766C3.09508 3.08 3.26042 3.2162 3.44645 3.25566C3.48014 3.2628 3.55123 3.26684 3.6449 3.26693L3.79087 3.26707V12.0221V20.7771L3.6449 20.7772C3.55123 20.7773 3.48014 20.7813 3.44645 20.7885C3.26042 20.8279 3.09508 20.9641 3.01188 21.1465C2.97143 21.2351 2.96307 21.2795 2.96316 21.4053C2.96324 21.5 2.96613 21.5266 2.98189 21.5773C3.04532 21.7815 3.20257 21.9389 3.40696 22.0027L3.46695 22.0215H12.9565H22.4461L22.5061 22.0027C22.7085 21.9395 22.8687 21.7804 22.9292 21.5825C22.9385 21.5523 22.946 21.5174 22.946 21.5049C22.946 21.4925 22.9496 21.48 22.954 21.4773C22.9585 21.4745 22.962 21.437 22.962 21.3923C22.962 21.341 22.9591 21.3141 22.954 21.3172C22.9494 21.3201 22.946 21.3126 22.9459 21.2997C22.9458 21.2652 22.926 21.1986 22.8986 21.1399C22.8323 20.9982 22.7109 20.8804 22.5702 20.8211C22.4865 20.7859 22.4278 20.7773 22.2682 20.7772L22.1222 20.7771V12.0221V3.26707L22.2682 3.26693C22.4278 3.26678 22.4865 3.25824 22.5702 3.22301C22.7508 3.14695 22.9057 2.96337 22.9382 2.78691C22.9434 2.7583 22.9509 2.72864 22.9549 2.721C22.9649 2.70136 22.9642 2.55255 22.954 2.55883C22.9494 2.5617 22.946 2.55386 22.946 2.54013C22.946 2.52714 22.9385 2.49181 22.9292 2.46163C22.8693 2.26586 22.7136 2.10976 22.5101 2.04144L22.4541 2.02264L12.9805 2.02157C7.77006 2.02099 3.48989 2.02338 3.46905 2.02689ZM2.96204 2.64286C2.96204 2.68907 2.96336 2.70798 2.96497 2.68487C2.96659 2.66176 2.96659 2.62395 2.96497 2.60084C2.96336 2.57773 2.96204 2.59664 2.96204 2.64286ZM5.04655 5.66789V8.06071H12.9565H20.8665V5.66789V3.27507H12.9565H5.04655V5.66789ZM7.22599 4.83286C7.2172 4.83473 7.18137 4.84178 7.14639 4.84851C7.06005 4.86514 7.00032 4.88639 6.90874 4.93306C6.41443 5.18495 6.24771 5.8196 6.5546 6.2811C6.65 6.42456 6.77387 6.53271 6.92965 6.60856C7.07104 6.6774 7.17769 6.70136 7.34228 6.70128C7.63613 6.70114 7.89822 6.57148 8.07977 6.33643C8.30801 6.04094 8.33721 5.62498 8.15227 5.30377C7.98025 5.00498 7.66894 4.82508 7.32997 4.82856C7.28158 4.82905 7.23479 4.83099 7.22599 4.83286ZM10.1006 4.83946C9.75135 4.89834 9.46044 5.15255 9.35869 5.48783C9.32302 5.60533 9.31457 5.67448 9.31978 5.80596C9.32781 6.00836 9.38709 6.17561 9.50662 6.33309C9.66689 6.54426 9.91281 6.67944 10.1717 6.69864C10.4609 6.72008 10.7176 6.62647 10.9172 6.42673C11.0506 6.29323 11.1443 6.11306 11.1764 5.92798C11.2765 5.35203 10.8285 4.82298 10.2452 4.82846C10.199 4.82889 10.134 4.83385 10.1006 4.83946ZM14.0483 5.16343C13.8353 5.21987 13.671 5.37954 13.6032 5.59607C13.5872 5.64718 13.5845 5.6722 13.5848 5.76793C13.585 5.84931 13.5889 5.89382 13.5991 5.93063C13.6588 6.14624 13.8284 6.31599 14.0456 6.37775C14.0938 6.39145 14.2062 6.39214 16.3917 6.39214H18.6871L18.7495 6.37403C18.969 6.3104 19.1459 6.12382 19.1918 5.90769C19.2107 5.81862 19.2036 5.66019 19.177 5.57852C19.1251 5.41877 19.008 5.28404 18.855 5.20791C18.7235 5.14243 18.9397 5.14766 16.3852 5.14815C14.1904 5.14858 14.1021 5.14915 14.0483 5.16343ZM5.04655 15.0431V20.7691H12.9565H20.8665V15.0431V9.31714H12.9565H5.04655V15.0431ZM8.32172 10.5814C8.22064 10.5993 8.1547 10.6163 8.07378 10.6451C7.6296 10.8032 7.28448 11.1794 7.17028 11.6299C7.12306 11.8162 7.12602 11.5952 7.12602 14.9391C7.12602 18.2562 7.12361 18.0614 7.16681 18.2362C7.27886 18.6896 7.62128 19.0706 8.05935 19.2293C8.15022 19.2622 8.23195 19.2833 8.34171 19.3021C8.42193 19.3159 8.62832 19.3166 12.9565 19.3166C17.2848 19.3166 17.4911 19.3159 17.5714 19.3021C17.6811 19.2833 17.7629 19.2622 17.8537 19.2293C18.2916 19.0707 18.6343 18.6894 18.7463 18.2362C18.7895 18.0614 18.7871 18.2561 18.7871 14.9403C18.7871 12.1963 18.7858 11.8695 18.7745 11.7922C18.7284 11.4765 18.5925 11.2036 18.371 10.9819C18.1519 10.7628 17.8855 10.6285 17.5695 10.578C17.4996 10.5669 17.022 10.5657 12.9466 10.5664C8.63332 10.5672 8.39762 10.568 8.32172 10.5814ZM8.48976 11.8268C8.44322 11.8439 8.39943 11.8903 8.38546 11.9373C8.36763 11.9974 8.36767 17.8808 8.3855 17.9409C8.39917 17.987 8.43578 18.0282 8.48168 18.0492C8.51253 18.0633 8.6709 18.0638 12.9565 18.0638C17.2422 18.0638 17.4005 18.0633 17.4314 18.0492C17.4773 18.0282 17.5139 17.987 17.5276 17.9409C17.5454 17.8808 17.5454 11.9974 17.5276 11.9373C17.5133 11.889 17.4695 11.8437 17.4204 11.8263C17.389 11.8153 16.9282 11.814 12.9535 11.8146C9.08904 11.815 8.51758 11.8166 8.48976 11.8268ZM10.5624 13.0708C10.4432 13.0909 10.3311 13.1465 10.244 13.2287C10.1488 13.3186 10.0895 13.4141 10.0599 13.5253C10.0405 13.5983 10.0368 13.7522 10.0527 13.8258C10.103 14.0592 10.3033 14.2553 10.5412 14.3042C10.6183 14.32 15.2948 14.32 15.3719 14.3042C15.6076 14.2558 15.7992 14.0706 15.8578 13.8347C15.876 13.7614 15.8736 13.6018 15.8532 13.5253C15.7992 13.323 15.6285 13.1495 15.4199 13.085L15.3599 13.0664L12.9805 13.0653C11.6719 13.0647 10.5837 13.0672 10.5624 13.0708ZM2.96204 21.4013C2.96204 21.4475 2.96336 21.4664 2.96497 21.4433C2.96659 21.4202 2.96659 21.3824 2.96497 21.3593C2.96336 21.3362 2.96204 21.3551 2.96204 21.4013Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Support.tsx

function Support() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_118_11)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0.832703 14.7224C0.832703 14.9985 1.05656 15.2224 1.3327 15.2224C1.60885 15.2224 1.8327 14.9985 1.8327 14.7224H0.832703ZM2.58563 11.6975L2.93918 12.0511L2.93919 12.0511L2.58563 11.6975ZM8.6353 11.6975L8.28173 12.0511L8.28176 12.0511L8.6353 11.6975ZM9.38826 14.7224C9.38826 14.9985 9.61212 15.2224 9.88826 15.2224C10.1644 15.2224 10.3883 14.9985 10.3883 14.7224H9.38826ZM9.27721 5.66675C9.00106 5.66675 8.77721 5.89061 8.77721 6.16675C8.77721 6.44289 9.00106 6.66675 9.27721 6.66675V5.66675ZM10.4994 6.16675H10.9994C10.9994 5.89061 10.7756 5.66675 10.4994 5.66675V6.16675ZM10.4994 7.38897H9.99943C9.99943 7.58117 10.1096 7.75636 10.2828 7.83962C10.4561 7.92288 10.6617 7.89947 10.8118 7.7794L10.4994 7.38897ZM12.0272 6.16675V5.66675C11.9137 5.66675 11.8035 5.70539 11.7149 5.77631L12.0272 6.16675ZM14.5829 5.36129L14.9364 5.71486L14.9364 5.71484L14.5829 5.36129ZM14.5829 1.4722L14.9364 1.11865L14.9364 1.11863L14.5829 1.4722ZM8.97165 0.666748L8.97155 1.16675H8.97165V0.666748ZM7.13798 1.36684L6.80469 0.994124L6.80468 0.994132L7.13798 1.36684ZM5.74123 3.05564C5.71055 3.33007 5.90815 3.57742 6.18259 3.6081C6.45702 3.63878 6.70436 3.44118 6.73504 3.16675L5.74123 3.05564ZM5.61173 10.0279C7.32228 10.0279 8.70894 8.64118 8.70894 6.93064H7.70894C7.70894 8.0889 6.76999 9.02786 5.61173 9.02786V10.0279ZM8.70894 6.93064C8.70894 5.22009 7.32228 3.83341 5.61173 3.83341V4.83342C6.76999 4.83342 7.70894 5.77237 7.70894 6.93064H8.70894ZM5.61173 3.83341C3.90118 3.83341 2.51451 5.22009 2.51451 6.93064H3.51451C3.51451 5.77237 4.45346 4.83342 5.61173 4.83342V3.83341ZM2.51451 6.93064C2.51451 8.64118 3.90118 10.0279 5.61173 10.0279V9.02786C4.45347 9.02786 3.51451 8.0889 3.51451 6.93064H2.51451ZM1.8327 14.7224C1.8327 13.7204 2.23072 12.7595 2.93918 12.0511L2.23209 11.344C1.33607 12.24 0.832703 13.4552 0.832703 14.7224H1.8327ZM2.93919 12.0511C3.64767 11.3426 4.60855 10.9446 5.61048 10.9446V9.94458C4.34333 9.94458 3.12809 10.448 2.23207 11.344L2.93919 12.0511ZM5.61048 10.9446C6.61241 10.9446 7.5733 11.3426 8.28173 12.0511L8.98886 11.344C8.09288 10.448 6.87763 9.94458 5.61048 9.94458V10.9446ZM8.28176 12.0511C8.99024 12.7595 9.38826 13.7204 9.38826 14.7224H10.3883C10.3883 13.4552 9.88489 12.24 8.98884 11.344L8.28176 12.0511ZM9.27721 6.66675H10.4994V5.66675H9.27721V6.66675ZM9.99943 6.16675V7.38897H10.9994V6.16675H9.99943ZM10.8118 7.7794L12.3396 6.55718L11.7149 5.77631L10.1871 6.99854L10.8118 7.7794ZM12.0272 6.66675H12.6383V5.66675H12.0272V6.66675ZM12.6383 6.66675C13.5003 6.66675 14.3269 6.32433 14.9364 5.71486L14.2293 5.00772C13.8073 5.4297 13.2351 5.66675 12.6383 5.66675V6.66675ZM14.9364 5.71484C15.5459 5.10535 15.8883 4.2787 15.8883 3.41675H14.8883C14.8883 4.01349 14.6513 4.58579 14.2293 5.00774L14.9364 5.71484ZM15.8883 3.41675C15.8883 2.5548 15.5459 1.72815 14.9364 1.11865L14.2293 1.82576C14.6513 2.24771 14.8883 2.82001 14.8883 3.41675H15.8883ZM14.9364 1.11863C14.3269 0.509167 13.5003 0.166748 12.6383 0.166748V1.16675C13.2351 1.16675 13.8073 1.40379 14.2293 1.82578L14.9364 1.11863ZM12.6383 0.166748H8.97165V1.16675H12.6383V0.166748ZM8.97175 0.166748C8.17217 0.166595 7.40069 0.461173 6.80469 0.994124L7.47126 1.73956C7.88391 1.37057 8.41801 1.16664 8.97155 1.16675L8.97175 0.166748ZM6.80468 0.994132C6.20869 1.5271 5.83007 2.26106 5.74123 3.05564L6.73504 3.16675C6.79654 2.61665 7.05866 2.10853 7.47127 1.73955L6.80468 0.994132ZM8.8327 3.41166C8.8327 3.31961 8.90732 3.245 8.99937 3.245V4.245C9.45961 4.245 9.8327 3.8719 9.8327 3.41166H8.8327ZM8.99937 3.245C9.09142 3.245 9.16604 3.31961 9.16604 3.41166H8.16604C8.16604 3.8719 8.53913 4.245 8.99937 4.245V3.245ZM9.16604 3.41166C9.16604 3.50371 9.09142 3.57833 8.99937 3.57833V2.57833C8.53913 2.57833 8.16604 2.95142 8.16604 3.41166H9.16604ZM8.99937 3.57833C8.90732 3.57833 8.8327 3.50371 8.8327 3.41166H9.8327C9.8327 2.95142 9.45961 2.57833 8.99937 2.57833V3.57833ZM10.8327 3.41166C10.8327 3.31961 10.9073 3.245 10.9994 3.245V4.245C11.4596 4.245 11.8327 3.8719 11.8327 3.41166H10.8327ZM10.9994 3.245C11.0914 3.245 11.166 3.31961 11.166 3.41166H10.166C10.166 3.8719 10.5391 4.245 10.9994 4.245V3.245ZM11.166 3.41166C11.166 3.50371 11.0914 3.57833 10.9994 3.57833V2.57833C10.5391 2.57833 10.166 2.95142 10.166 3.41166H11.166ZM10.9994 3.57833C10.9073 3.57833 10.8327 3.50371 10.8327 3.41166H11.8327C11.8327 2.95142 11.4596 2.57833 10.9994 2.57833V3.57833ZM12.8327 3.41166C12.8327 3.31961 12.9073 3.245 12.9994 3.245V4.245C13.4596 4.245 13.8327 3.8719 13.8327 3.41166H12.8327ZM12.9994 3.245C13.0914 3.245 13.166 3.31961 13.166 3.41166H12.166C12.166 3.8719 12.5391 4.245 12.9994 4.245V3.245ZM13.166 3.41166C13.166 3.50371 13.0914 3.57833 12.9994 3.57833V2.57833C12.5391 2.57833 12.166 2.95142 12.166 3.41166H13.166ZM12.9994 3.57833C12.9073 3.57833 12.8327 3.50371 12.8327 3.41166H13.8327C13.8327 2.95142 13.4596 2.57833 12.9994 2.57833V3.57833Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_118_11",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0.666016)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Toilet.tsx

function Toilet() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.2989 2.875C15.2124 2.875 15.1294 2.90937 15.0682 2.97055C15.007 3.03173 14.9727 3.1147 14.9727 3.20122V3.52744H19.43V3.20122C19.43 3.1147 19.3956 3.03173 19.3344 2.97055C19.2732 2.90937 19.1903 2.875 19.1038 2.875H15.2989ZM14.1982 4.75947C13.9252 4.69249 13.7227 4.44612 13.7227 4.15244V3.20122C13.7227 2.78318 13.8887 2.38226 14.1843 2.08666C14.4799 1.79107 14.8808 1.625 15.2989 1.625H19.1038C19.5218 1.625 19.9227 1.79107 20.2183 2.08666C20.5139 2.38226 20.68 2.78318 20.68 3.20122V4.15244C20.68 4.44614 20.4774 4.69252 20.2043 4.75948V12C20.2043 12.4811 20.0132 12.9425 19.673 13.2827C19.4695 13.4862 19.2227 13.6364 18.9542 13.7242C18.8784 14.1805 18.7043 14.6172 18.4413 15.0029C18.0765 15.538 17.5579 15.9498 16.9541 16.1839C16.8438 16.2268 16.7496 16.3028 16.6843 16.4015C16.619 16.5002 16.5859 16.6167 16.5895 16.735L16.5898 16.7542V21.75C16.5898 22.0952 16.31 22.375 15.9648 22.375H8.13434C7.94313 22.375 7.76244 22.2875 7.64391 22.1374C7.52538 21.9874 7.48206 21.7913 7.52632 21.6053L8.02055 19.5285C7.01359 18.9042 6.16794 18.0474 5.55646 17.0271C4.95011 16.0155 4.59396 14.8765 4.51407 13.7047C4.26742 13.6149 4.04079 13.4719 3.85163 13.2827C3.51143 12.9425 3.32031 12.4811 3.32031 12C3.32031 11.5189 3.51143 11.0575 3.85163 10.7173C4.19182 10.3771 4.65323 10.186 5.13434 10.186H14.1982V4.75947ZM15.4482 4.77747V10.7946C15.4484 10.8 15.4485 10.8055 15.4485 10.811L15.4483 12.564H18.3723L18.3781 12.5641H18.3903C18.5399 12.5641 18.6834 12.5046 18.7891 12.3989C18.8949 12.2931 18.9543 12.1496 18.9543 12V4.77747H15.4482ZM14.1982 12.564V11.436H5.13434C4.98475 11.436 4.84129 11.4954 4.73551 11.6012C4.62974 11.7069 4.57031 11.8504 4.57031 12C4.57031 12.1496 4.62974 12.293 4.73551 12.3988C4.84129 12.5046 4.98475 12.564 5.13434 12.564L14.1982 12.564ZM5.7775 13.814C5.86804 14.7206 6.15762 15.5987 6.62862 16.3845C7.20708 17.3496 8.03734 18.1391 9.03036 18.6682C9.28122 18.8018 9.41029 19.0879 9.34449 19.3644L8.92553 21.125H15.3398V16.7628C15.3305 16.3898 15.4359 16.0229 15.6419 15.7117C15.8498 15.3975 16.15 15.1554 16.5011 15.0188C16.8692 14.8762 17.1861 14.6249 17.4085 14.2987C17.5111 14.1482 17.5915 13.985 17.6482 13.8141L5.7775 13.814Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Wheelchair.tsx

function Wheelchair() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.3271 2.02251C10.9595 2.05069 10.6612 2.12064 10.3604 2.24929C9.72586 2.52059 9.1959 3.02973 8.9041 3.64836C8.47414 4.55991 8.54801 5.61582 9.1002 6.45124C9.4598 6.99528 9.98263 7.3926 10.6078 7.59691C10.897 7.69145 11.1563 7.73143 11.4818 7.73173C11.816 7.73204 12.0763 7.69094 12.3837 7.5893C13.2409 7.30591 13.9133 6.63353 14.1964 5.77666C14.3098 5.4335 14.3536 5.11101 14.3373 4.7404C14.2979 3.84346 13.8317 3.01404 13.0827 2.50858C12.6954 2.24719 12.281 2.09434 11.8067 2.03788C11.704 2.02567 11.4093 2.01622 11.3271 2.02251ZM11.2906 3.30256C10.7491 3.37226 10.2783 3.7139 10.0489 4.20359C9.94972 4.41525 9.90076 4.6375 9.90076 4.87591C9.90076 5.24186 10.0229 5.59172 10.248 5.87013C10.3117 5.94898 10.457 6.08957 10.5348 6.14765C10.8022 6.3473 11.15 6.46344 11.4804 6.46344C12.088 6.46344 12.6436 6.11716 12.9084 5.57347C13.0735 5.2346 13.1132 4.85135 13.0213 4.48439C12.9795 4.3176 12.8803 4.10276 12.7795 3.96066C12.7162 3.87138 12.5663 3.71278 12.4778 3.64129C12.2513 3.45831 11.9672 3.33868 11.6728 3.30223C11.5933 3.2924 11.3681 3.29259 11.2906 3.30256ZM11.3434 8.0564C11.0209 8.07993 10.7025 8.18926 10.4337 8.36879C10.305 8.45477 10.2293 8.51801 10.1155 8.63464C9.87352 8.88274 9.69376 9.21448 9.62508 9.5397C9.57708 9.76694 9.5811 9.47127 9.5778 13.0183C9.57474 16.3089 9.57581 16.4534 9.60445 16.6188C9.67566 17.0301 9.86446 17.3879 10.1619 17.6753C10.4565 17.96 10.7884 18.1236 11.2134 18.1936C11.3186 18.211 11.3253 18.2111 13.0361 18.2138L14.7532 18.2165L15.4674 19.6446C16.0313 20.7719 16.1954 21.0932 16.2466 21.1702C16.5616 21.6438 17.0669 21.9498 17.6365 22.0117C17.766 22.0258 18.029 22.0179 18.1502 21.9963C18.3414 21.9622 18.4857 21.9159 18.6582 21.8333C19.558 21.4022 19.9736 20.3461 19.6079 19.42C19.5588 19.2956 17.6046 15.389 17.544 15.294C17.3463 14.9842 17.0922 14.7564 16.7644 14.5951C16.5937 14.511 16.4553 14.4653 16.2565 14.427L16.163 14.409L14.7773 14.4045L13.3915 14.4L13.3873 12.0674C13.3827 9.49091 13.3874 9.71534 13.3334 9.495C13.2731 9.24869 13.1395 8.9778 12.975 8.76811C12.9053 8.67939 12.7262 8.50577 12.6316 8.43529C12.2572 8.1564 11.8032 8.02287 11.3434 8.0564ZM11.3699 9.3322C11.1612 9.37013 10.9759 9.52258 10.895 9.72291C10.8486 9.83765 10.8513 9.6156 10.8536 13.1605L10.8557 16.4237L10.8746 16.4845C10.9386 16.6912 11.1006 16.8531 11.307 16.9168L11.3678 16.9356L13.3062 16.94C15.4655 16.9449 15.2762 16.9395 15.4073 17.0001C15.524 17.054 15.6051 17.1242 15.6755 17.2324C15.6945 17.2614 16.0685 18.0021 16.5068 18.8782C17.3758 20.6153 17.3306 20.5317 17.4452 20.6178C17.6385 20.7631 17.8831 20.7904 18.0986 20.6908C18.2696 20.6119 18.3849 20.4774 18.444 20.2883C18.4687 20.2095 18.4713 20.0388 18.4491 19.9551C18.4329 19.8939 16.5127 16.0427 16.4548 15.9554C16.3895 15.8567 16.2605 15.7526 16.1589 15.7164C16.0374 15.6732 16.1748 15.6765 14.3343 15.672L12.6357 15.6678L12.5705 15.6473C12.3689 15.5836 12.2079 15.4226 12.1442 15.2209L12.1236 15.1558L12.1196 12.5022C12.1158 10.0462 12.1145 9.84519 12.1018 9.80347C12.0677 9.69106 12.0428 9.64242 11.978 9.56134C11.8987 9.46229 11.7797 9.38151 11.6644 9.34848C11.5964 9.32899 11.4363 9.32014 11.3699 9.3322ZM7.59412 11.2752C7.48139 11.2905 7.42207 11.316 7.239 11.4275C6.50411 11.8754 5.89028 12.4715 5.42094 13.193C4.92793 13.9509 4.62506 14.811 4.52799 15.7288C4.41749 16.7734 4.61499 17.8785 5.07953 18.8147C5.55336 19.7696 6.22044 20.5245 7.09677 21.0972C7.90681 21.6267 8.85481 21.9424 9.84387 22.0119C10.0069 22.0234 10.4313 22.0233 10.5875 22.0118C11.2506 21.963 11.8453 21.8221 12.4325 21.5749C12.6822 21.4697 13.0365 21.2868 13.1451 21.2069C13.2955 21.0964 13.3875 20.9063 13.3882 20.7052C13.3886 20.5799 13.3622 20.4842 13.2979 20.3775C13.1807 20.1833 12.9903 20.0763 12.7576 20.0739C12.6281 20.0726 12.5687 20.0883 12.4327 20.1595C12.2009 20.281 12.0517 20.3545 11.948 20.3982C10.7533 20.9019 9.42952 20.8657 8.26262 20.2972C7.79566 20.0697 7.40936 19.7906 7.0394 19.4135C6.71569 19.0835 6.47617 18.7497 6.25868 18.3255C6.00176 17.8244 5.8559 17.3303 5.79083 16.7407C5.77289 16.578 5.77022 16.0741 5.78648 15.9157C5.8643 15.1571 6.09515 14.4905 6.49191 13.8786C6.76328 13.4602 7.13632 13.0612 7.54378 12.7536C7.62484 12.6924 7.84653 12.5449 7.97055 12.4697C8.15205 12.3595 8.2466 12.2378 8.29172 12.0564C8.36608 11.7573 8.20835 11.4413 7.92526 11.3224C7.82812 11.2816 7.69109 11.262 7.59412 11.2752Z",
            fill: "currentColor"
        })
    });
}

;// CONCATENATED MODULE: ./components/icons/small/Document.tsx

function Document() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "25",
        viewBox: "0 0 21 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 22.0536C20 22.5983 19.7836 23.1208 19.3984 23.506C19.0132 23.8912 18.4907 24.1076 17.9459 24.1076H3.05405C2.50929 24.1076 1.98683 23.8912 1.60162 23.506C1.21641 23.1208 1 22.5983 1 22.0536V3.05357C1 2.5088 1.21641 1.98634 1.60162 1.60113C1.98683 1.21592 2.50929 0.999512 3.05405 0.999512H13.3243L20 7.67519V22.0536Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 7.67519H15.3784C14.8336 7.67519 14.3112 7.45878 13.926 7.07357C13.5407 6.68836 13.3243 6.1659 13.3243 5.62113V0.999512L20 7.67519Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1486 10.7563H4.85132",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1486 14.0122H4.85132",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1486 17.2573H4.85132",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.2535 20.5132H4.85132",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/small/index.tsx


















/***/ }),

/***/ 6797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Expander; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: 100vw;\n        max-width: var( --container-max-width );\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: calc( 100vw - ( var( --container-small-margin-width ) * 2 ) );\n        max-width: var( --container-max-width );\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: calc( 100vw - ( var( --container-margin-width ) * 2 ) );\n        max-width: var( --container-max-width );\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-width: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  --margin-diff: calc( -1 * ( 100vw - 2000px ) );\n  --negative-margin-width: calc( var( --margin-diff ) / 2 );\n  margin-left: min( 0px, var( --negative-margin-width ) );\n  /* margin-left: var( --negative-margin-width ); */\n  margin-right: min( 0px, var( --negative-margin-width ) );\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var getContainerCss = function(containerType) {
    switch(containerType){
        case "full":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
        case "small-margin":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1());
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
    }
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1bf95e98-0"
})(_templateObject4(), function(p) {
    return getContainerCss(p.$containerType);
}, function(p) {
    return p.$maxWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), p.$maxWidth);
});
Container.defaultProps = {
    $containerType: "normal"
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
var Expander = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1bf95e98-1"
})(_templateObject5());


/***/ }),

/***/ 7325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ BodyScrollProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var BodyScrollContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
BodyScrollContext.displayName = "BodyScrollContext";
var useBodyScrollContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BodyScrollContext);
};
var usePreventBodyScroll = function(preventScroll, id) {
    var setIds = useBodyScrollContext();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (preventScroll) {
            setIds(function(s) {
                return Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(s).concat([
                    id
                ])));
            });
        } else {
            setIds(function(s) {
                return s.filter(function(i) {
                    return i !== id;
                });
            });
        }
        return function() {
            setIds(function(s) {
                return s.filter(function(i) {
                    return i !== id;
                });
            });
        };
    }, [
        id,
        preventScroll,
        setIds
    ]);
};
function BodyScrollProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), ids = ref[0], setIds = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (ids.length) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "unset";
        }
        return function() {
            document.body.style.overflowY = "unset";
        };
    }, [
        ids
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BodyScrollContext.Provider, {
        value: setIds,
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (usePreventBodyScroll);


/***/ }),

/***/ 4029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function MetaTags(param) {
    var metaTags = param.metaTags;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: metaTags.map(function(tag) {
            if (!tag.value) {
                return null;
            }
            if (tag.name === "title") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: tag.value
                }, "title");
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: tag.name,
                content: tag.value
            }, tag.name);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 8767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j7": function() { return /* binding */ CraftProvider; },
  "Yi": function() { return /* binding */ useCraft; }
});

// UNUSED EXPORTS: getCraftData, getServerSideCraftData

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
;// CONCATENATED MODULE: ./lib/craft/request.ts


var NEXT_PUBLIC_CMS_HOSTNAME = "cms.brixel.ch";
var request_request = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(query) {
        var variables, options, endpoint, headers, body;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            variables = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
            endpoint = "/graphql";
            if (!NEXT_PUBLIC_CMS_HOSTNAME) {
                throw new Error("NEXT_PUBLIC_CMS_HOSTNAME must be provided.");
            }
            headers = {
                "Content-Type": "application/json",
                Accept: "application/json"
            };
            if (false) {}
            if (options === null || options === void 0 ? void 0 : options.previewToken) {
                endpoint += "?token=".concat(options.previewToken);
            }
            if (options === null || options === void 0 ? void 0 : options.schemaToken) {
                headers.Authorization = "Bearer ".concat(options.schemaToken);
            }
            body = {
                query: query
            };
            if (variables) {
                body.variables = variables;
            }
            return [
                2,
                fetch(endpoint, {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(body)
                }).then(function(r) {
                    return r.json();
                })// .then( r => {
                //   console.log( r )
                //   return r
                // } )
                .then(function(r) {
                    if (r.errors) {
                        console.error(r);
                    }
                    return r;
                }).catch(function(e) {
                    console.error(e);
                    throw e;
                })
            ];
        });
    });
    return function request(query) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var craft_request = (request_request);

// EXTERNAL MODULE: ./lib/craft/MetaTags.tsx
var MetaTags = __webpack_require__(4029);
;// CONCATENATED MODULE: ./graphql/fragments/image.ts
var IMAGE_FRAGMENT = "\n  id\n  url\n  alt\n  width\n  height\n  focalPoint\n  dateModified\n";
/* harmony default export */ var fragments_image = (IMAGE_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/accordion.ts

var ACCORDION_FRAGMENT = "\n...on pageSegments_accordion_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  accordionStyle\n  accordionLayout\n  buttonLabel\n  buttonLink\n  buttonIcon\n  mainImage {\n    ".concat(fragments_image, "\n  }\n  accordion {\n    ...on accordion_BlockType {\n      id\n      heading\n      itemContent\n    }\n  }\n}\n");
/* harmony default export */ var accordion = (ACCORDION_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/cards.ts

var CARDS_FRAGMENT = "\n...on pageSegments_cards_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  alignment\n  mainImage {\n    ".concat(fragments_image, "\n  }\n  cards {\n    ...on cards_BlockType {\n      id\n      cardTitle\n      cardDescription\n      cardImage {\n        ").concat(fragments_image, "\n      }\n      cardImageAlignment\n      cardButtonLabel\n      cardButtonLink\n      cardColor\n    }\n  }\n}\n");
/* harmony default export */ var cards = (CARDS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/contact.ts

var CONTACT_FRAGMENT = "\n...on pageSegments_contact_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  contactCards {\n    ...on contactCards_BlockType {\n      id\n      icon {\n        ".concat(fragments_image, "\n      }\n      text\n      linkText\n      linkDestination\n    }\n  }\n}\n");
/* harmony default export */ var contact = (CONTACT_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/experts.ts

var EXPERTS_FRAGMENT = "\n...on pageSegments_experts_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  experts {\n    ...on experts_default_Entry {\n      id\n      title\n      mainImage {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var experts = (EXPERTS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/footer.ts
var FOOTER_FRAGMENT = "\n...on pageSegments_footer_Entry {\n  id\n  anchorId\n  typeHandle\n  bodyText\n  hideLanguagePicker\n}\n";
/* harmony default export */ var footer = (FOOTER_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/infoPoints.ts

var INFO_POINTS_FRAGMENT = "\n...on pageSegments_infoPoints_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  infoPointsAlignment\n  infoPoints {\n    ...on infoPoints_BlockType {\n      id\n      infoPointTitle\n      infoPointDescription\n      infoPointIcon {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var infoPoints = (INFO_POINTS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/largePostcards.ts

var LARGE_POSTCARDS_FRAGMENT = "\n...on pageSegments_largePostcards_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  largeCardsSectionBGColor\n  largePostcards {\n    ...on largePostcards_BlockType {\n      id\n      heading\n      bodyText\n      cardColor\n      image {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var largePostcards = (LARGE_POSTCARDS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/logoGrid.ts

var LOGO_GRID_FRAGMENT = "\n...on pageSegments_logoGrid_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  linkedLogos {\n    ...on linkedLogos_BlockType {\n      id\n      logoLink\n      logoImage {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var logoGrid = (LOGO_GRID_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/postcards.ts

var POSTCARDS_FRAGMENT = "\n...on pageSegments_postcards_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  postcards {\n    ...on postcards_BlockType {\n      id\n      number\n      tag\n      heading\n      bodyText\n      cardColor\n      image {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var postcards = (POSTCARDS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/packages.ts

var PACKAGES_FRAGMENT = "\n...on pageSegments_packages_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  bodyText\n  packageEntries {\n    ...on packages_default_Entry {\n      id\n      slug\n      highlight\n      packageName\n      packageDescription\n      price\n      pricePostfix\n      originalPrice\n      originalPriceLabel\n      discountHighlight\n      buttonLink\n      buttonLabel\n      moreInfoLink\n      moreInfoLabel\n      bulletPoints {\n        ...on bulletPoints_TableRow {\n          highlight\n          text\n        }\n      }\n      packageAdditional {\n        ...on packageAdditional_text_BlockType {\n          id\n          typeHandle\n          text\n        }\n        ...on packageAdditional_textHighlight_BlockType {\n          id\n          typeHandle\n          text\n        }\n        ...on packageAdditional_bullets_BlockType {\n          id\n          typeHandle\n          bullets {\n            ...on bullets_TableRow {\n              highlight\n              text\n            }\n          }\n        }\n        ...on packageAdditional_partnerLogo_BlockType {\n          id\n          typeHandle\n          partnerLabel\n          partnerLogo {\n            ".concat(fragments_image, "\n          }\n        }\n      }\n    }\n  }\n}\n");
/* harmony default export */ var pageSegments_packages = (PACKAGES_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/partnerLogos.ts

var PARTNER_LOGOS_FRAGMENT = "\n...on pageSegments_partnerLogos_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  partnerLogos {\n    ...on partnerLogos_BlockType {\n      id\n      label\n      logoLink\n      logo {\n        ...on brixelCms_Asset {\n          ".concat(fragments_image, "\n        }\n      }\n    }\n  }\n}\n");
/* harmony default export */ var partnerLogos = (PARTNER_LOGOS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/processSteps.ts
var PROCESS_STEPS_FRAGMENT = "\n...on pageSegments_processSteps_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  bodyText\n  processSteps {\n    ...on processSteps_BlockType {\n      id\n      text1\n      text2\n      color\n      highlight\n    }\n  }\n}\n";
/* harmony default export */ var processSteps = (PROCESS_STEPS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/linkIt.ts
var LINK_IT_FRAGMENT = "\n  url\n  text\n  target\n";
/* harmony default export */ var linkIt = (LINK_IT_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/processStepsSimple.ts

var PROCESS_STEPS_SIMPLE_FRAGMENT = "\n...on pageSegments_processStepsSimple_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  bodyText\n  button {\n    ".concat(linkIt, "\n  }\n  processStepsSimple {\n    ...on processStepsSimple_BlockType {\n      id\n      stepText\n    }\n  }\n}\n");
/* harmony default export */ var processStepsSimple = (PROCESS_STEPS_SIMPLE_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/properties.ts

var PROPERTIES = "\n...on pageSegments_properties_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  properties {\n    ...on properties_BlockType {\n      id\n      propertyUrl\n      propertyTitle\n      location\n      price\n      rooms\n      area\n      yearBuilt\n      exclusivityEndsAt\n      propertyImage {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var properties = (PROPERTIES);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/propertyListings.ts
var PROPERTY_LISTINGS_FRAGMENT = "\n...on pageSegments_propertyListings_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  buttonLabel\n  buttonLink\n  company\n  related\n  numberOfProperties\n  showCountdown\n  propertyCardStyle\n  carouselForSmallScreens\n  showLoadMoreButton\n  showFilterControls\n}\n";
/* harmony default export */ var propertyListings = (PROPERTY_LISTINGS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/story.ts


var STORY_FRAGMENT = "\n...on pageSegments_story_Entry {\n  id\n  anchorId\n  typeHandle\n  label\n  mainTitle\n  subtitle\n  button {\n    ".concat(linkIt, "\n  }\n  mainImage {\n    ").concat(fragments_image, "\n  }\n}\n");
/* harmony default export */ var story = (STORY_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/testimonials.ts

var TESTIMONIALS_FRAGMENT = "\n...on pageSegments_testimonials_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  testimonials {\n    ...on testimonials_default_Entry {\n      id\n      title\n      description\n      amountSaved\n      mainImage {\n        ".concat(fragments_image, "\n      }\n    }\n  }\n}\n");
/* harmony default export */ var testimonials = (TESTIMONIALS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/textCta.ts
var TEXT_CTA_FRAGMENT = "\n...on pageSegments_textCta_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  ctaTheme\n  ctaIcon\n  buttonGroup {\n    ...on buttonGroup_BlockType {\n      id\n      buttonLink\n      buttonLabel\n      primary\n      openInNewTab\n    }\n  }\n}\n";
/* harmony default export */ var textCta = (TEXT_CTA_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/videoCta.ts

var VIDEO_CTA_FRAGMENT = "\n...on pageSegments_videoCta_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  description\n  buttonLabel\n  videoUrl\n  mainImage {\n    ".concat(fragments_image, "\n  }\n}\n");
/* harmony default export */ var videoCta = (VIDEO_CTA_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/highlights.ts

var HIGHLIGHTS_FRAGEMENT = "\n... on highlights_images_BlockType {\n  id\n  typeHandle\n  highlightImages {\n    ".concat(fragments_image, "\n  }\n  highlightEyebrow\n  highlightTitle\n  highlightDescription\n}\n... on highlights_threeDeeTour_BlockType {\n  id\n  typeHandle\n  highlightEyebrow\n  highlightTourUrl\n  highlightButtonText\n  highlightTitle\n  highlightDescription\n  highlightPreviewImage {\n    ").concat(fragments_image, "\n  }\n}\n");
/* harmony default export */ var highlights = (HIGHLIGHTS_FRAGEMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/highlights.ts

var HIGHLIGHTS_PAGE_SEGMENT_FRAGMENT = "\n...on pageSegments_highlights_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  highlights {\n    ".concat(highlights, "\n  }\n}\n");
/* harmony default export */ var pageSegments_highlights = (HIGHLIGHTS_PAGE_SEGMENT_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/floorplan.ts

var FLOORPLAN_SEGMENT = "\n...on pageSegments_floorplan_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  mainImage {\n    ".concat(fragments_image, "\n  }\n  floorplanTable {\n    ... on floorplanTable_BlockType {\n      id\n      floor\n      apartment\n      numberOfRooms\n      livingArea\n      balcony\n      rent\n      extraCosts\n      availability\n    }\n  }\n  floorplanFooter {\n    ... on floorplanFooter_BlockType {\n      id\n      sectionTitle\n      options {\n        ... on options_list_BlockType {\n          id\n          typeHandle\n          listIcon\n          listTitle\n          listContent\n        }\n      }\n    }\n  }\n}\n");
/* harmony default export */ var floorplan = (FLOORPLAN_SEGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/localArea.ts

var LOCAL_AREA_FRAGMENT = "\n...on pageSegments_localArea_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  location {\n    lat\n    lng\n    address\n  }\n  distances {\n    ... on distances_BlockType {\n      id\n      place\n      distance\n    }\n  }\n  mainImage {\n    ".concat(fragments_image, "\n  }\n  subtitle\n  bodyText\n}\n");
/* harmony default export */ var localArea = (LOCAL_AREA_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/columns.ts
var COLUMNS_FRAGMENT = "\n...on pageSegments_columns_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  textColumns {\n    ... on textColumns_BlockType {\n      id\n      columnHeading\n      columnContent\n    }\n  }\n}\n";
/* harmony default export */ var columns = (COLUMNS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments/videoGroup.ts
var VIDEO_GROUP_FRAGMENT = "\n...on pageSegments_videoGroup_Entry {\n  id\n  anchorId\n  typeHandle\n  mainTitle\n  subtitle\n  videos {\n    ... on videos_BlockType {\n      id\n      videoUrl\n      videoTitle\n      videoDescription\n    }\n  }\n}\n";
/* harmony default export */ var videoGroup = (VIDEO_GROUP_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/pageSegments.ts
























var PAGE_SEGMENTS_FRAGMENT = "\npageSegments {\n  ".concat(accordion, "\n  ").concat(cards, "\n  ").concat(contact, "\n  ").concat(experts, "\n  ").concat(footer, "\n  ").concat(infoPoints, "\n  ").concat(largePostcards, "\n  ").concat(logoGrid, "\n  ").concat(postcards, "\n  ").concat(pageSegments_packages, "\n  ").concat(partnerLogos, "\n  ").concat(processSteps, "\n  ").concat(processStepsSimple, "\n  ").concat(properties, "\n  ").concat(propertyListings, "\n  ").concat(story, "\n  ").concat(testimonials, "\n  ").concat(textCta, "\n  ").concat(videoCta, "\n  ").concat(pageSegments_highlights, "\n  ").concat(floorplan, "\n  ").concat(localArea, "\n  ").concat(columns, "\n  ").concat(videoGroup, "\n}\n");
/* harmony default export */ var pageSegments = (PAGE_SEGMENTS_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/fragments/nagivationBar.ts
var NAVIGATION_BAR_FRAGMENT = "\nnavigationBar {\n  ...on navigationBar_button_BlockType {\n    id\n    typeHandle\n    linkIt {\n      url\n      text\n      target\n    }\n    buttonStyle\n    buttonColor\n  }\n  ...on navigationBar_textLink_BlockType {\n    id\n    typeHandle\n    linkIt {\n      url\n      text\n      target\n    }\n  }\n  ...on navigationBar_dropdown_BlockType {\n    id\n    typeHandle\n    label\n    icon\n    dropdownList {\n      ...on dropdownList_BlockType {\n        id\n        linkIt {\n          url\n          text\n          target\n        }\n        withSeparator\n      }\n    }\n  }\n}\n";
/* harmony default export */ var nagivationBar = (NAVIGATION_BAR_FRAGMENT);

;// CONCATENATED MODULE: ./graphql/globals.ts


var globals_GLOBALS_QUERY = '\n  query GlobalsQuery(\n    $siteHandle: String! \n  ) {\n    footer: globalSets(\n      site: [$siteHandle]\n      handle: "footer"\n    ) {\n      ...on footer_GlobalSet {\n        '.concat(pageSegments, '\n      }\n    }\n\n    header: globalSets(\n      site: [$siteHandle]\n      handle: "header"\n    ) {\n      ...on header_GlobalSet {\n        ').concat(nagivationBar, '\n      }\n    }\n\n    gtm: globalSets(\n      site: [$siteHandle]\n      handle: "tagManagerCookieBanner"\n    ) {\n      ...on tagManagerCookieBanner_GlobalSet {\n        tagManagerId\n      }\n    }\n    \n    cookieBanner: globalSets(\n      site: [$siteHandle]\n      handle: "tagManagerCookieBanner"\n    ) {\n      ...on tagManagerCookieBanner_GlobalSet {\n        tagManagerId\n        cookieBanner {\n          ...on cookieBanner_BlockType {\n            titleCopy\n            bodyCopy\n            acceptButtonLabel\n            rejectButtonLabel\n          }\n        }\n      }\n    }\n\n    companyInfo: globalSet(\n      handle: "companyInfo"\n    ) {\n      ...on companyInfo_GlobalSet {\n        companyTitle\n        companyAddress\n      }\n    }\n\n    businessHours: globalSet(\n      site: [$siteHandle]\n      handle: "businessHours"\n    ) {\n      ...on businessHours_GlobalSet {\n        openSign\n        openingTimes {\n          day\n          time\n        }\n      }\n    }\n  }\n');
/* harmony default export */ var globals = (globals_GLOBALS_QUERY);

;// CONCATENATED MODULE: ./lib/craft/index.tsx









var CraftContext = /*#__PURE__*/ (0,react.createContext)(null);
CraftContext.displayName = "CraftContext";
var useCraft = function() {
    return (0,react.useContext)(CraftContext);
};
function CraftProvider(param) {
    var hostname = param.hostname, pageProps = param.pageProps, _MetaTagsComponent = param.MetaTagsComponent, MetaTagsComponent = _MetaTagsComponent === void 0 ? null : _MetaTagsComponent, children = param.children;
    var ref = (0,react.useState)({}), clientSideRequestProps = ref[0], setClientSideRequestProps = ref[1];
    var clientSideRequest = function() {
        var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        getCraftData(query, variables).then(function(param) {
            var props = param.props;
            return setClientSideRequestProps(props);
        });
    };
    var value = (0,react.useMemo)(function() {
        return {
            pageProps: (0,src_object_spread/* default */.Z)({}, pageProps, clientSideRequestProps),
            clientSideRequest: clientSideRequest
        };
    }, [
        pageProps,
        clientSideRequestProps
    ]);
    var metaTags = function() {
        var ref;
        if (!(pageProps === null || pageProps === void 0 ? void 0 : pageProps.entry)) {
            return null;
        }
        if (MetaTagsComponent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComponent, {
                entry: pageProps.entry,
                hostname: hostname
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
            metaTags: (ref = pageProps.entry) === null || ref === void 0 ? void 0 : ref.metaTags
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CraftContext.Provider, {
        value: value,
        children: [
            metaTags(),
            children
        ]
    });
}
function getServerSideCraftData(_) {
    return _getServerSideCraftData.apply(this, arguments);
}
function _getServerSideCraftData() {
    _getServerSideCraftData = _async_to_generator(function(param) {
        var query, variables, _options, options, _passThru, passThru, ref, ref1, queryResponse, globalsResponse;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, variables = param.variables, _options = param.options, options = _options === void 0 ? {} : _options, _passThru = param.passThru, passThru = _passThru === void 0 ? {} : _passThru;
                    return [
                        4,
                        Promise.all([
                            request(query, variables, options),
                            request(GLOBALS_QUERY, {
                                siteHandle: variables.siteHandle
                            })
                        ])
                    ];
                case 1:
                    ref1 = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), queryResponse = ref1[0], globalsResponse = ref1[1];
                    if (!(queryResponse === null || queryResponse === void 0 ? void 0 : (ref = queryResponse.data) === null || ref === void 0 ? void 0 : ref.entry)) {
                        return [
                            2,
                            {
                                notFound: true,
                                props: _object_spread({}, passThru, globalsResponse.data)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            props: _object_spread({}, passThru, queryResponse.data, globalsResponse.data)
                        }
                    ];
            }
        });
    });
    return _getServerSideCraftData.apply(this, arguments);
}
var getCraftData = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, passThru = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var requests = [
        craft_request(globals)
    ];
    if (query) {
        requests.push(craft_request(query, variables));
    }
    return Promise.all(requests).then(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), queryResponse = _param[0], globalsResponse = _param[1];
        return {
            props: (0,src_object_spread/* default */.Z)({}, passThru, queryResponse.data, globalsResponse.data)
        };
    });
};


/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(8875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(8748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 8045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(9361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(3929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(9309);
var _useIntersection = __webpack_require__(7190);
var _imageConfigContext = __webpack_require__(9977);
var _utils = __webpack_require__(3794);
var _normalizeTrailingSlash = __webpack_require__(2392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 8418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(5753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _router = __webpack_require__(6273);
var _addLocale = __webpack_require__(2725);
var _routerContext = __webpack_require__(3462);
var _appRouterContext = __webpack_require__(1018);
var _useIntersection = __webpack_require__(7190);
var _getDomainLocale = __webpack_require__(1210);
var _addBasePath = __webpack_require__(8684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 8875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(4317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 9615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/urls.ts
var getUrl = function(hostname, locale, defaultLocale, asPath) {
    return "https://".concat(hostname).concat(locale === defaultLocale ? "" : "/".concat(locale)).concat(asPath);
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(4806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(5687);
// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(6284);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 9 modules
var lib = __webpack_require__(6096);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
var formatMessage = function (_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_es6.__assign)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
};

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(2644);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(1050);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = ['type'];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: formatMessage.bind(null, resolvedConfig, formatters), $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(1092);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6.__spreadArray)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6.__rest)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements,
    };
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, coreIntl), { formatMessage: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters), $t: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

;// CONCATENATED MODULE: ./compiled-lang/en.json
var en_namespaceObject = JSON.parse('{"+2W/WP":[{"type":0,"value":"Rent"}],"+d/91N":[{"type":0,"value":"Terms and Conditions"}],"+ewVnD":[{"type":0,"value":"How many units are planned? (optional)"}],"+hh+VE":[{"type":0,"value":"Neuchâtel"}],"01+OP2":[{"type":0,"value":"Please read carefully and accept the following terms to continue."}],"0M6MT1":[{"type":0,"value":"Our team will contact you shortly to clarify any questions and to proceed with the next steps."}],"0YlyNR":[{"type":0,"value":"Load more"}],"0ZUZJD":[{"type":0,"value":"Enter ZIP or City"}],"1a/4ve":[{"type":0,"value":"Type in your first name"}],"1bVkdA":[{"type":0,"value":"Thank you!"}],"2+9Uxt":[{"type":0,"value":"Authorization"}],"26YeFt":[{"type":0,"value":"Strasse, Nr"}],"27XvY/":[],"3CyOuX":[{"type":0,"value":"Fribourg"}],"4f05T8":[{"type":0,"value":"Ort"}],"4rDHbT":[{"type":0,"value":"Phone number"}],"4tUhkX":[{"type":0,"value":"Go to the homepage"}],"5JJKRj":[{"type":0,"value":"Date of Birth"}],"5vG1Zi":[{"type":0,"value":"Lucerne"}],"6fRR0B":[{"type":0,"value":"Appenzell Outer-Rhodes"}],"6jqj//":[{"type":0,"value":"Email address "}],"77fZeN":[{"type":0,"value":"Thank you for your registration."}],"7CxCV3":[{"type":0,"value":"Date of foundation"}],"7Ix/Zg":[{"type":0,"value":"Last Name"}],"8I3TCk":[{"type":0,"value":"Income"}],"8o9EVS":[{"type":0,"value":"All rights reserved"}],"95YuSo":[],"9YvFif":[{"type":0,"value":"Access to financing services"}],"9k8diP":[{"type":0,"value":"Type in your email address"}],"9ksGHk":[{"type":0,"value":"Strasse, Nr"}],"AFUEkj":[{"type":0,"value":"Type in here the project name"}],"AFf+Gi":[{"type":0,"value":"When is the start of construction planned? (optional)"}],"AeDkKF":[{"type":0,"value":"example@brixel.io"}],"B/RrjS":[{"type":0,"value":"Let us know more!"}],"BAkEOU":[{"type":0,"value":"More info"}],"BML85d":[{"type":0,"value":"Geneva"}],"BTZrof":[{"type":0,"value":"Get in touch"}],"Bpj1ZF":[{"type":0,"value":"What is your phone number?"}],"CSI5gE":[{"type":0,"value":"Create your project"}],"CkmV9k":[{"type":0,"value":"Available"}],"D41ybz":[{"type":0,"value":"Balcony"}],"DXJv2Y":[{"type":0,"value":"Schwyz"}],"DeyxnX":[{"type":0,"value":"Hanz"}],"Dp+wIA":[{"type":0,"value":"My offer has already been accepted"}],"E2Ajt6":[{"type":0,"value":"Apartment"}],"EQ/XxL":[{"type":0,"value":"Nidwalden"}],"Eet4Q0":[{"type":0,"value":"Selling Price"}],"FScS0U":[{"type":0,"value":"Valais"}],"FkqCBt":[{"type":0,"value":"First Name"}],"FthgtD":[{"type":0,"value":"is open"}],"GJDsYb":[{"type":0,"value":"Sold"}],"H2RnT8":[{"type":0,"value":"Name, address and telephone number of the employer"}],"HS4fmx":[{"type":0,"value":"opens at"}],"HTUOPV":[{"type":0,"value":"Next property"}],"HfEl6c":[{"type":0,"value":"Page not found"}],"I2CV+g":[{"type":0,"value":"Place of residence/nationality"}],"IRXVxP":[{"type":0,"value":"Fill out the application form now"}],"ISffvh":[{"type":0,"value":"This product is exclusively available to promoters whose project is financed by UBS. Therefore, Brixel and third parties may infer information about their banking relationship with UBS."}],"IX9egs":[{"type":0,"value":"On request"}],"J4JtcB":[{"type":0,"value":"Extra Costs"}],"JAY+qC":[{"type":0,"value":"Get access to an innovative platform"}],"JL9eQ8":[{"type":0,"value":"Email"}],"JVS7kL":[{"type":0,"value":"Feel free to contact us in the meantime."}],"JchSgw":[{"type":0,"value":"Jura"}],"JhNeE2":[{"type":0,"value":"Andrea"}],"JkP/dR":[{"type":0,"value":"Number of rooms"}],"KF8k24":[{"type":0,"value":"I hereby confirm that I have read, understood the "},{"children":[{"type":0,"value":"terms"}],"type":8,"value":"termsLink"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyLink"},{"type":0,"value":" of Brixel and hereby accept them."}],"KHged8":[{"type":0,"value":"saved"}],"KWSZCn":[{"type":0,"value":"Uri"}],"LEa4Ij":[{"type":0,"value":"Marital Status"}],"LGpzov":[{"type":0,"value":"Basel District"}],"LX35RZ":[{"type":0,"value":"What is your company name?"}],"LcKY+0":[{"type":0,"value":"Register Now"}],"Lj1rw3":[{"type":0,"value":"What is your first name?"}],"LkwhlX":[{"type":0,"value":"Garden"}],"M4rc0X":[{"type":0,"value":"What is your last name?"}],"MIYCJc":[{"type":0,"value":"Thurgau"}],"N+Qpvr":[{"type":0,"value":"Create your profile"}],"N+qhzw":[{"type":0,"value":"Prepare your project for the promotion"}],"NHXhAa":[{"type":0,"value":"Legal Status"}],"Npim2S":[{"type":0,"value":"I confirm that I have answered all questions truthfully."}],"Nq6A4S":[{"type":0,"value":"Please confirm"}],"O4nooC":[{"type":0,"value":"Price"}],"OrXeKM":[{"type":0,"value":"Which services interest you the most?"}],"P+DnaV":[{"type":0,"value":"Please enter a valid email address"}],"PRS+w1":[{"type":0,"value":"Your Full Name"}],"PZkcXk":[{"type":0,"value":"CHF"}],"QTAhhR":[{"type":0,"value":"Text us via WhatsApp"}],"QhhPzk":[{"type":0,"value":"Email us"}],"RE0BIp":[{"type":0,"value":"Type in e-mail of client advisor"}],"REcF0D":[{"type":0,"value":"Cantons"}],"RXO/tj":[{"type":0,"value":"What’s the name of your project?"}],"RZ5rZu":[{"type":0,"value":"What is your email address?"}],"RlDzFA":[{"type":0,"value":"opens on"}],"RnLTlM":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" days left"}],"Rx9JZ7":[{"type":0,"value":"I\'m waiting for my offer to be accepted"}],"RxH0Zp":[{"type":0,"value":"Grisons"}],"SHw40G":[{"type":0,"value":"Type in your company name"}],"Saeg/p":[{"type":0,"value":"Please complete this field"}],"T8b2I3":[{"type":0,"value":"Full Name"}],"TARSh2":[{"type":0,"value":"Eg. Single"}],"UibFRK":[{"type":0,"value":"Thank you very much!"}],"V2MxOz":[{"type":0,"value":"Rooms"}],"V7DS5l":[{"type":0,"value":"What stage are you at in the process?"}],"VRSxyL":[{"type":0,"value":"Call us"}],"W9nrzJ":[{"type":0,"value":"Company"}],"WDROA9":[{"type":0,"value":"Back"}],"WIKBIe":[{"type":0,"value":"Reserved"}],"WrCo4m":[{"type":0,"value":"We couldn\'t find the page you were looking for."}],"Wzz5/m":[{"type":0,"value":"Nr. of units"}],"XCRJXE":[{"type":0,"value":"E-mail us"}],"XOCDU1":[{"type":0,"value":"St. Gallen"}],"XcW/Ag":[{"type":0,"value":"Yes"}],"YCIsxs":[{"type":0,"value":"The management will contact you as soon as possible to arrange a viewing appointment."}],"YdJS7t":[{"type":0,"value":"Phone Number"}],"YyoBcv":[{"type":0,"value":"Ticino"}],"ZQWkJ9":[{"type":0,"value":"Appenzell Inner-Rhodes"}],"Zl57e/":[{"type":0,"value":"The administration is authorized to obtain information about the aforementioned persons. All information will be treated confidentially. If the prospective tenant withdraws his application after an agreed tenancy agreement has been drawn up, the administration may demand compensation for any loss of turnover."}],"ZtZAli":[{"type":0,"value":"Type in your last name"}],"ZxssWD":[{"type":0,"value":"Profession"}],"aL71Hk":[{"type":0,"value":"Have debt collection proceedings been initiated in the last 2 years or are there any certificates of loss?"}],"aQrqNd":[{"type":0,"value":"Surface Area"}],"aik0OQ":[{"type":0,"value":"I already have a property in mind"}],"b7qnrL":[{"type":0,"value":"Annual income in CHF"}],"bURm/c":[{"type":0,"value":"Price"}],"biUozd":[{"type":0,"value":"Floor"}],"ctK4I6":[{"type":0,"value":"Sold"}],"dN54n3":[{"type":0,"value":"Unit"}],"eZuFFq":[{"type":0,"value":"Do you have any issues or questions? Feel free to contact us."}],"ev8tkE":[{"type":0,"value":"Previous property"}],"f02PwW":[{"type":0,"value":"What are the estimated costs? (optional)"}],"feisHm":[{"type":0,"value":"Highlights"}],"fqr0vR":[{"type":0,"value":"Services to help me moving in"}],"fwKxxb":[{"type":0,"value":"Cancel"}],"gRUp1P":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"day"}]},"other":{"value":[{"type":0,"value":"days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"},{"type":0,"value":" left"}],"gUmdV3":[{"type":0,"value":"Current Address"}],"go/Pzx":[{"type":0,"value":"Maximal distribution for your promotion"}],"gtiHtC":[{"type":0,"value":"Basel"}],"gus/j8":[{"type":0,"value":"If you need help selling or buying, or would like to report a problem, please contact Brixel."}],"h4gb19":[{"type":0,"value":"Vaud"}],"h7EkPG":[{"type":0,"value":"Continue"}],"iIDcto":[{"type":0,"value":"Glarus"}],"iPAnLE":[{"type":0,"value":"Bern"}],"jBgMdv":[{"type":0,"value":"Legal support"}],"jFhx+1":[{"type":0,"value":"Select…"}],"jaxp8G":[{"type":0,"value":"Available"}],"kB1Pu4":[{"type":0,"value":"Zug"}],"kSwmMq":[{"type":0,"value":"Where is it located?"}],"kawHwE":[{"type":0,"value":"z.B. C"}],"kcqF2C":[{"type":0,"value":"Solothurn"}],"kmnyH/":[{"type":0,"value":"Amount in CHF"}],"kxXd6Z":[{"type":0,"value":"Who is your company\'s client advisor at UBS? (optional)"}],"mHZeeW":[{"type":0,"value":"We can\'t find any properties meeting your search criteria."}],"mJNLNN":[{"type":0,"value":"Availability"}],"mWoieu":[{"type":0,"value":"Call us"}],"n8gN6R":[{"type":0,"value":"Back"}],"naP5t5":[{"type":0,"value":"Designation"}],"oCoQLk":[{"type":0,"value":"Reserved"}],"owqmnW":[{"type":0,"value":"dd/mm/yyyy"}],"pC0zq4":[{"type":0,"value":"Switzerland"}],"pK2hCf":[{"type":0,"value":"No"}],"qZ3eCE":[{"type":0,"value":"When would you like to be contacted? "}],"rU6OoX":[{"type":0,"value":"Reserved"}],"ro2QWQ":[{"type":0,"value":"hans.müller@email.com"}],"s1lpzV":[{"type":0,"value":"We will review your information and you will be contacted as soon as possible."}],"sRn9qE":[{"type":0,"value":"I\'m just curious"}],"sYBL2K":[{"type":0,"value":"PLZ"}],"ssOh8n":[{"type":0,"value":"Obwalden"}],"t3uTml":[{"type":0,"value":"Living Area"}],"tW7atw":[{"type":0,"value":"Market know-how"}],"tsDsIk":[{"type":0,"value":"Year built"}],"uKUxlF":[{"type":0,"value":"Which apartment are you interested in? (several possible)"}],"unWaE3":[{"type":0,"value":"Surname, first name (owner/manager)"}],"v9byQt":[{"type":0,"value":"andrea.müller@email.com"}],"vCo0EH":[{"type":0,"value":"Privacy policy"}],"w+vERP":[{"type":0,"value":"Aargau"}],"wDKxsa":[{"type":0,"value":"Living area"}],"wInrQd":[{"type":0,"value":"01.01.1960"}],"wNgL3D":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"day left"}]},"other":{"value":[{"type":0,"value":"days left"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"wQJ8/A":[{"type":0,"value":"Schaffhausen"}],"wg4/VJ":[{"type":0,"value":"Your advantages"}],"wwzVAX":[{"type":0,"value":"Activity/industry"}],"x0XB+L":[{"type":0,"value":"MM/YYYY"}],"x38j5Q":[{"type":0,"value":"I hereby confirm that I have read, understood the terms and privacy policy of Brixel and hereby accept them."}],"xHyaHg":[{"type":0,"value":"Distances"}],"y39M9H":[{"type":0,"value":"Müller"}],"yO/4jP":[{"type":0,"value":"I’ve started searching for a home"}],"yiRud2":[{"type":0,"value":"How long have you been at this address"}],"z+bbkF":[{"type":0,"value":"Zurich"}],"zeu/se":[{"type":0,"value":"Transparent management of all prospects"}],"zxC1er":[{"type":0,"value":"Occupied"}]}');
;// CONCATENATED MODULE: ./compiled-lang/de.json
var de_namespaceObject = JSON.parse('{"+2W/WP":[{"type":0,"value":"Miete"}],"+d/91N":[{"type":0,"value":"Nutzungsbedingungen"}],"+ewVnD":[{"type":0,"value":"Wie viele Einheiten umfasst das Projekt? (optional)"}],"+hh+VE":[{"type":0,"value":"Neuenburg"}],"01+OP2":[{"type":0,"value":"Bitte lies die folgenden Bedingungen sorgfältig durch und akzeptiere diese um fortzufahren."}],"0M6MT1":[{"type":0,"value":"Unser Team wird dich in Kürze kontaktieren, um alle Fragen zu klären und die nächsten Schritte einzuleiten."}],"0YlyNR":[{"type":0,"value":"Mehr anzeigen"}],"0ZUZJD":[{"type":0,"value":"Suche nach PLZ oder Ort"}],"1a/4ve":[{"type":0,"value":"Gib deinen Vornamen ein"}],"1bVkdA":[{"type":0,"value":"Vielen Dank!"}],"2+9Uxt":[{"type":0,"value":"Bewilligung"}],"26YeFt":[{"type":0,"value":"Strasse, Nr"}],"27XvY/":[{"type":0,"value":"Noch "},{"type":1,"value":"daysLeft"},{"type":0,"value":" Tage"}],"3CyOuX":[{"type":0,"value":"Freiburg"}],"4f05T8":[{"type":0,"value":"Ort"}],"4rDHbT":[{"type":0,"value":"Telefonnummer"}],"4tUhkX":[{"type":0,"value":"Gehe zur Homepage"}],"5JJKRj":[{"type":0,"value":"Geburtsdatum"}],"5vG1Zi":[{"type":0,"value":"Luzern"}],"6fRR0B":[{"type":0,"value":"Appenzell Ausserrhoden"}],"6jqj//":[{"type":0,"value":"E-Mail-Adresse"}],"77fZeN":[{"type":0,"value":"Vielen Dank für deine Registrierung."}],"7CxCV3":[{"type":0,"value":"Gründungsdatum"}],"7Ix/Zg":[{"type":0,"value":"Vorname"}],"8I3TCk":[{"type":0,"value":"Einkommen"}],"8o9EVS":[{"type":0,"value":"Alle Rechte vorbehalten"}],"95YuSo":[{"type":0,"value":"Jetzt bewerben"}],"9YvFif":[{"type":0,"value":"Zugang zu Finanzierungsangeboten"}],"9k8diP":[{"type":0,"value":"Gib deine E-Mail-Adresse ein"}],"9ksGHk":[{"type":0,"value":"Strasse, Nr"}],"AFUEkj":[{"type":0,"value":"Gib hier den Namen deines Projekt ein"}],"AFf+Gi":[{"type":0,"value":"Wann ist der Baubeginn geplant? (optional)"}],"AeDkKF":[{"type":0,"value":"example@brixel.io"}],"B/RrjS":[{"type":0,"value":"Lass uns mehr von dir wissen!"}],"BAkEOU":[{"type":0,"value":"Weitere Informationen"}],"BML85d":[{"type":0,"value":"Genf"}],"BTZrof":[{"type":0,"value":"Kontaktiere uns"}],"Bpj1ZF":[{"type":0,"value":"Was ist deine Telefonnummer?"}],"CSI5gE":[{"type":0,"value":"Erfasse dein Projekt"}],"CkmV9k":[{"type":0,"value":"Verfügbar"}],"D41ybz":[{"type":0,"value":"Balkon"}],"DXJv2Y":[{"type":0,"value":"Schwyz"}],"DeyxnX":[{"type":0,"value":"Hanz"}],"Dp+wIA":[{"type":0,"value":"Mein Angebot wurde bereits angenommen"}],"E2Ajt6":[{"type":0,"value":"Wohnung"}],"EQ/XxL":[{"type":0,"value":"Nidwalden"}],"Eet4Q0":[{"type":0,"value":"Verkaufspreis"}],"FScS0U":[{"type":0,"value":"Wallis"}],"FkqCBt":[{"type":0,"value":"Name"}],"FthgtD":[{"type":0,"value":"ist offen"}],"GJDsYb":[{"type":0,"value":"Verkauft"}],"H2RnT8":[{"type":0,"value":"Name, Adresse und Tel.-Nr. des Arbeitgebers"}],"HS4fmx":[{"type":0,"value":"öffnet um"}],"HTUOPV":[{"type":0,"value":"Nächstes Objekt"}],"HfEl6c":[{"type":0,"value":"Seite nicht gefunden"}],"I2CV+g":[{"type":0,"value":"Bürgerort/Nationalität"}],"IRXVxP":[{"type":0,"value":"Jetzt Bewerbungsformular ausfüllen"}],"ISffvh":[{"type":0,"value":"Dieses Produkt steht exklusiv Promotoren zur Verfügung, deren Projekt durch UBS finanziert wird. Brixel und Dritte können deshalb Rückschlüsse auf ihre Bankbeziehung zu UBS ziehen."}],"IX9egs":[{"type":0,"value":"Auf Anfrage"}],"J4JtcB":[{"type":0,"value":"Nebenkosten"}],"JAY+qC":[{"type":0,"value":"Erhalte Zugang zur innovativen Vermarktungsplattform"}],"JL9eQ8":[{"type":0,"value":"E-mail"}],"JVS7kL":[{"type":0,"value":"Du kannst uns auch gerne jederzeit kontaktieren."}],"JchSgw":[{"type":0,"value":"Jura"}],"JhNeE2":[{"type":0,"value":"Andrea"}],"JkP/dR":[{"type":0,"value":"Zimmer"}],"KF8k24":[{"type":0,"value":"Ich bestätige, dass ich die "},{"children":[{"type":0,"value":"AGBs"}],"type":8,"value":"termsLink"},{"type":0,"value":" und "},{"children":[{"type":0,"value":"Datenschutzrichtlinien"}],"type":8,"value":"privacyLink"},{"type":0,"value":" von Brixel gelesen und verstanden habe und diese hiermit akzeptiere."}],"KHged8":[{"type":0,"value":"gespart"}],"KWSZCn":[{"type":0,"value":"Uri"}],"LEa4Ij":[{"type":0,"value":"Zivilstand"}],"LGpzov":[{"type":0,"value":"Basel-Landschaft"}],"LX35RZ":[{"type":0,"value":"Wie heisst deine Firma?"}],"LcKY+0":[{"type":0,"value":"Jetzt registrieren"}],"Lj1rw3":[{"type":0,"value":"Wie lautet dein Vorname?"}],"LkwhlX":[{"type":0,"value":"Garten"}],"M4rc0X":[{"type":0,"value":"Wie lautet dein Nachname?"}],"MIYCJc":[{"type":0,"value":"Thurgau"}],"N+Qpvr":[{"type":0,"value":"Erstelle dein Profil"}],"N+qhzw":[{"type":0,"value":"Bereite dein Projekt für die Promotion vor"}],"NHXhAa":[{"type":0,"value":"Rechtsform"}],"Npim2S":[{"type":0,"value":"Ich bestätige alle Fragen wahrheitsgetreu beantwortet zu haben."}],"Nq6A4S":[{"type":0,"value":"Bitte akzeptieren"}],"O4nooC":[{"type":0,"value":"Preis"}],"OrXeKM":[{"type":0,"value":"Welche Services interessieren dich am meisten?"}],"P+DnaV":[{"type":0,"value":"Bitte gib eine gültige E-Mail-Adresse ein"}],"PRS+w1":[{"type":0,"value":"Dein vollständiger Name"}],"PZkcXk":[{"type":0,"value":"CHF"}],"QTAhhR":[{"type":0,"value":"Schreibe uns via WhatsApp"}],"QhhPzk":[{"type":0,"value":"Schick uns eine E-Mail"}],"RE0BIp":[{"type":0,"value":"Gib die E-Mail oder den Namen ein"}],"REcF0D":[{"type":0,"value":"Kantone"}],"RXO/tj":[{"type":0,"value":"Wie heisst dein Projekt?"}],"RZ5rZu":[{"type":0,"value":"Wie lautet deine E-Mail-Adresse?"}],"RlDzFA":[{"type":0,"value":"öffnet am"}],"RnLTlM":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" Tage übrig"}],"Rx9JZ7":[{"type":0,"value":"Ich warte darauf, dass mein Angebot angenommen wird"}],"RxH0Zp":[{"type":0,"value":"Graubünden"}],"SHw40G":[{"type":0,"value":"Gib deinen Firmennamen ein"}],"Saeg/p":[{"type":0,"value":"Bitte fülle dieses Feld aus"}],"T8b2I3":[{"type":0,"value":"Vollständiger Name"}],"TARSh2":[{"type":0,"value":"z.B. ledig"}],"UibFRK":[{"type":0,"value":"Vielen Dank!"}],"V2MxOz":[{"type":0,"value":"Zimmer"}],"V7DS5l":[{"type":0,"value":"Wo befindest du dich im Kaufprozess?"}],"VRSxyL":[{"type":0,"value":"Rufe uns an"}],"W9nrzJ":[{"type":0,"value":"Firma"}],"WDROA9":[{"type":0,"value":"Zurück"}],"WIKBIe":[{"type":0,"value":"Reserviert"}],"WrCo4m":[{"type":0,"value":"Wir konnten die Seite, die du gesucht hast, nicht finden."}],"Wzz5/m":[{"type":0,"value":"Anzahl Einheiten"}],"XCRJXE":[{"type":0,"value":"Schreibe uns eine E-Mail"}],"XOCDU1":[{"type":0,"value":"St. Gallen"}],"XcW/Ag":[{"type":0,"value":"Ja"}],"YCIsxs":[{"type":0,"value":"Die Verwaltung wird sich bei Ihnen so schnell wie möglich für einen Besichtigungstermin melden."}],"YdJS7t":[{"type":0,"value":"Telefon Nr."}],"YyoBcv":[{"type":0,"value":"Tessin"}],"ZQWkJ9":[{"type":0,"value":"Appenzell Innerrhoden"}],"Zl57e/":[{"type":0,"value":"Die Verwaltungs wird ermächtigt, über vorgenannte Personen Auskünfte einzuholen. Alle Angaben werden vertraulich behandelt. Zieht der Mietinteressent nach Ausfertigung eines vereinbarten Mietvertrages seine Bewerbung zurück, kann die Verwaltung eine Umtriebsentschädigung fordern."}],"ZtZAli":[{"type":0,"value":"Gib deinen Nachnamen ein"}],"ZxssWD":[{"type":0,"value":"Beruf"}],"aL71Hk":[{"type":0,"value":"Wurden in den letzen 2 jahren Betreibungen eingeleit oder liegen Verlustscheine vor?"}],"aQrqNd":[{"type":0,"value":"Fläche"}],"aik0OQ":[{"type":0,"value":"Ich habe eine spezifische Immobilie im Auge"}],"b7qnrL":[{"type":0,"value":"Jahreseinkommen in CHF"}],"bURm/c":[{"type":0,"value":"Preis"}],"biUozd":[{"type":0,"value":"Stockwerk"}],"ctK4I6":[{"type":0,"value":"Verkauft"}],"dN54n3":[{"type":0,"value":"Einheit"}],"eZuFFq":[{"type":0,"value":"Ist etwas unklar oder hast du Fragen? Wir sind für dich da."}],"ev8tkE":[{"type":0,"value":"Vorheriges Objekt"}],"f02PwW":[{"type":0,"value":"Wie hoch sind die geschätzten Kosten? (optional)"}],"feisHm":[{"type":0,"value":"Highlights"}],"fqr0vR":[{"type":0,"value":"Unterstützung für den Umzug"}],"fwKxxb":[{"type":0,"value":"Abbrechen"}],"gRUp1P":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"Tag"}]},"other":{"value":[{"type":0,"value":"Tage"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"},{"type":0,"value":" übrig"}],"gUmdV3":[{"type":0,"value":"Jetzige Adresse"}],"go/Pzx":[{"type":0,"value":"Maximale Verbreitung deiner Promotion"}],"gtiHtC":[{"type":0,"value":"Basel-Stadt"}],"gus/j8":[{"type":0,"value":"Wenn du Hilfe beim Verkauf oder Kauf brauchst oder ein Problem melden möchtest, wende dich bitte an Brixel."}],"h4gb19":[{"type":0,"value":"Waadt"}],"h7EkPG":[{"type":0,"value":"Weiter"}],"iIDcto":[{"type":0,"value":"Glarus"}],"iPAnLE":[{"type":0,"value":"Bern"}],"jBgMdv":[{"type":0,"value":"Rechtliche Unterstützung"}],"jFhx+1":[{"type":0,"value":"Auswählen…"}],"jaxp8G":[{"type":0,"value":"Verfügbar"}],"kB1Pu4":[{"type":0,"value":"Zug"}],"kSwmMq":[{"type":0,"value":"Wo befindet sich dein Projekt?"}],"kawHwE":[{"type":0,"value":"z.B. C"}],"kcqF2C":[{"type":0,"value":"Solothurn"}],"kmnyH/":[{"type":0,"value":"Betrag in CHF"}],"kxXd6Z":[{"type":0,"value":"Wer ist deine Kundenberater:in bei UBS? (optional)"}],"mHZeeW":[{"type":0,"value":"Leider haben wir keine passenden Immobilien gefunden."}],"mJNLNN":[{"type":0,"value":"Verfügbarkeit"}],"mWoieu":[{"type":0,"value":"Ruf uns an"}],"n8gN6R":[{"type":0,"value":"Zurück"}],"naP5t5":[{"type":0,"value":"Bezeichnung"}],"oCoQLk":[{"type":0,"value":"Reserviert"}],"owqmnW":[{"type":0,"value":"tt/mm/jjjj"}],"pC0zq4":[{"type":0,"value":"Schweiz"}],"pK2hCf":[{"type":0,"value":"Nein"}],"qZ3eCE":[{"type":0,"value":"Wann möchtest du kontaktiert werden? "}],"rU6OoX":[{"type":0,"value":"Reserviert"}],"ro2QWQ":[{"type":0,"value":"hans.müller@email.com"}],"s1lpzV":[{"type":0,"value":"Wir werden deine Angaben prüfen und dich so schnell wie möglich kontaktieren."}],"sRn9qE":[{"type":0,"value":"Ich bin nur neugierig"}],"sYBL2K":[{"type":0,"value":"PLZ"}],"ssOh8n":[{"type":0,"value":"Obwalden"}],"t3uTml":[{"type":0,"value":"Wohnfläche"}],"tW7atw":[{"type":0,"value":"Markt-Know-how"}],"tsDsIk":[{"type":0,"value":"Baujahr"}],"uKUxlF":[{"type":0,"value":"Für welche Wohnung interessieren Sie sich? (mehrere möglich)"}],"unWaE3":[{"type":0,"value":"Name, Vorname (Inhaberin/Geshäftsführerin)"}],"v9byQt":[{"type":0,"value":"andrea.müller@email.com"}],"vCo0EH":[{"type":0,"value":"Datenschutz"}],"w+vERP":[{"type":0,"value":"Aargau"}],"wDKxsa":[{"type":0,"value":"Wohnbereich"}],"wInrQd":[{"type":0,"value":"01.01.1960"}],"wNgL3D":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"Tag übrig"}]},"other":{"value":[{"type":0,"value":"Tage übrig"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"wQJ8/A":[{"type":0,"value":"Schaffhausen"}],"wg4/VJ":[{"type":0,"value":"Deine Vorteile"}],"wwzVAX":[{"type":0,"value":"Tätigkeit/Branche"}],"x0XB+L":[{"type":0,"value":"MM/JJJJ"}],"x38j5Q":[{"type":0,"value":"Ich bestätige, dass ich die AGBs und Datenschutzrichtlinien von Brixel gelesen und verstanden habe und diese hiermit akzeptiere."}],"xHyaHg":[{"type":0,"value":"Distanzen"}],"y39M9H":[{"type":0,"value":"Müller"}],"yO/4jP":[{"type":0,"value":"Ich habe die Suche gestartet"}],"yiRud2":[{"type":0,"value":"Seit wann an dieser Adresse"}],"z+bbkF":[{"type":0,"value":"Zürich"}],"zeu/se":[{"type":0,"value":"Transparentes Management der Käuferanfragen"}],"zxC1er":[{"type":0,"value":"Besetzt"}]}');
;// CONCATENATED MODULE: ./compiled-lang/fr.json
var fr_namespaceObject = JSON.parse('{"+2W/WP":[],"+d/91N":[{"type":0,"value":"Conditions d\'utilisation"}],"+ewVnD":[{"type":0,"value":"Combien d\'unités comprend le projet ? (facultatif)"}],"+hh+VE":[{"type":0,"value":"Neuchâtel"}],"01+OP2":[{"type":0,"value":"Veuillez lire attentivement les conditions suivantes et les accepter pour pouvoir continuer."}],"0M6MT1":[{"type":0,"value":"Notre équipe vous contactera prochainement pour répondre à vos questions et passer aux étapes suivantes."}],"0YlyNR":[{"type":0,"value":"Afficher plus"}],"0ZUZJD":[{"type":0,"value":"Cherchez par code postal ou par ville"}],"1a/4ve":[{"type":0,"value":"Saisissez votre prénom"}],"1bVkdA":[{"type":0,"value":"Merci beaucoup!"}],"2+9Uxt":[],"26YeFt":[],"27XvY/":[{"type":0,"value":"Plus que "},{"type":1,"value":"daysLeft"},{"type":0,"value":" jours"}],"3CyOuX":[{"type":0,"value":"Fribourg"}],"4f05T8":[],"4rDHbT":[{"type":0,"value":"Numéro de téléphone"}],"4tUhkX":[{"type":0,"value":"Aller à l’accueil"}],"5JJKRj":[],"5vG1Zi":[{"type":0,"value":"Lucerne"}],"6fRR0B":[{"type":0,"value":"Appenzell Rhodes-Extérieures"}],"6jqj//":[{"type":0,"value":"Adresse e-mail"}],"77fZeN":[{"type":0,"value":"Merci beaucoup pour votre inscription."}],"7CxCV3":[],"7Ix/Zg":[],"8I3TCk":[],"8o9EVS":[{"type":0,"value":"Tous droits réservés"}],"95YuSo":[],"9YvFif":[{"type":0,"value":"Accès à des produits de financement"}],"9k8diP":[{"type":0,"value":"Saisissez votre adresse e-mail"}],"9ksGHk":[],"AFUEkj":[{"type":0,"value":"Saisissez ici le nom de votre projet"}],"AFf+Gi":[{"type":0,"value":"Quand la construction doit-elle commencer ? (facultatif)"}],"AeDkKF":[{"type":0,"value":"example@brixel.io"}],"B/RrjS":[{"type":0,"value":"Dites-nous en plus !"}],"BAkEOU":[],"BML85d":[{"type":0,"value":"Genève"}],"BTZrof":[{"type":0,"value":"Contacter Brixel"}],"Bpj1ZF":[{"type":0,"value":"Quel est votre numéro de téléphone?"}],"CSI5gE":[{"type":0,"value":"Créez votre projet"}],"CkmV9k":[],"D41ybz":[],"DXJv2Y":[{"type":0,"value":"Schwyz"}],"DeyxnX":[],"Dp+wIA":[{"type":0,"value":"Mon offre a été acceptée"}],"E2Ajt6":[],"EQ/XxL":[{"type":0,"value":"Nidwald"}],"Eet4Q0":[],"FScS0U":[{"type":0,"value":"Valais"}],"FkqCBt":[],"FthgtD":[{"type":0,"value":"est ouvert"}],"GJDsYb":[{"type":0,"value":"Vendu"}],"H2RnT8":[],"HS4fmx":[{"type":0,"value":"s\'ouvre à"}],"HTUOPV":[{"type":0,"value":"Prochain bien"}],"HfEl6c":[{"type":0,"value":"Page introuvable"}],"I2CV+g":[],"IRXVxP":[],"ISffvh":[{"type":0,"value":"Ce produit est exclusivement réservé aux promoteurs dont le projet est financé par UBS. Brixel et des tiers peuvent donc tirer des conclusions sur leur relation bancaire avec UBS."}],"IX9egs":[{"type":0,"value":"Sur demande"}],"J4JtcB":[],"JAY+qC":[{"type":0,"value":"Accédez à une plateforme marketing innovante"}],"JL9eQ8":[],"JVS7kL":[{"type":0,"value":"N\'hésitez pas à nous contacter."}],"JchSgw":[{"type":0,"value":"Jura"}],"JhNeE2":[],"JkP/dR":[],"KF8k24":[{"type":0,"value":"Je confirme par la présente que j\'ai lu, compris et accepté "},{"children":[{"type":0,"value":"les conditions"}],"type":8,"value":"termsLink"},{"type":0,"value":" et la "},{"children":[{"type":0,"value":"politique de confidentialité"}],"type":8,"value":"privacyLink"},{"type":0,"value":" de Brixel."}],"KHged8":[{"type":0,"value":"économisé"}],"KWSZCn":[{"type":0,"value":"Uri"}],"LEa4Ij":[],"LGpzov":[{"type":0,"value":"Bâle-Campagne"}],"LX35RZ":[{"type":0,"value":"Quel est le nom de votre société ?"}],"LcKY+0":[{"type":0,"value":"S\'enregistrer"}],"Lj1rw3":[{"type":0,"value":"Quel est votre prénom ?"}],"LkwhlX":[],"M4rc0X":[{"type":0,"value":"Quel est votre nom de famille ?"}],"MIYCJc":[{"type":0,"value":"Thurgovie"}],"N+Qpvr":[{"type":0,"value":"Créez votre profil"}],"N+qhzw":[{"type":0,"value":"Préparez votre projet pour la promotion"}],"NHXhAa":[],"Npim2S":[],"Nq6A4S":[{"type":0,"value":"Veuillez confirmer"}],"O4nooC":[],"OrXeKM":[{"type":0,"value":"Quels sont les services qui vous intéressent le plus ?"}],"P+DnaV":[{"type":0,"value":"Veuillez saisir une adresse e-mail valide"}],"PRS+w1":[{"type":0,"value":"Votre nom complet"}],"PZkcXk":[],"QTAhhR":[{"type":0,"value":"Écrivez-nous via WhatsApp"}],"QhhPzk":[{"type":0,"value":"Envoyez-nous un courriel"}],"RE0BIp":[{"type":0,"value":"Saisissez l\'adresse e-mail ou le nom"}],"REcF0D":[{"type":0,"value":"Cantons"}],"RXO/tj":[{"type":0,"value":"Quel est le nom de ton projet ?"}],"RZ5rZu":[{"type":0,"value":"Quelle est votre adresse e-mail ?"}],"RlDzFA":[{"type":0,"value":"ouvre sur"}],"RnLTlM":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" jours restants"}],"Rx9JZ7":[{"type":0,"value":"J\'attends que mon offre soit acceptée"}],"RxH0Zp":[{"type":0,"value":"Grisons"}],"SHw40G":[{"type":0,"value":"Saisissez le nom de votre société"}],"Saeg/p":[{"type":0,"value":"veuillez compléter ce champ"}],"T8b2I3":[{"type":0,"value":"Nom complet"}],"TARSh2":[],"UibFRK":[],"V2MxOz":[{"type":0,"value":"Chambres"}],"V7DS5l":[{"type":0,"value":"Où en êtes-vous dans le processus ?"}],"VRSxyL":[{"type":0,"value":"Appellez-nous"}],"W9nrzJ":[],"WDROA9":[],"WIKBIe":[],"WrCo4m":[{"type":0,"value":"Nous n’avons pas trouvé la page que vous recherchiez."}],"Wzz5/m":[{"type":0,"value":"Nombre d\'unités"}],"XCRJXE":[{"type":0,"value":"Écrivez-nous"}],"XOCDU1":[{"type":0,"value":"Saint-Gall"}],"XcW/Ag":[],"YCIsxs":[],"YdJS7t":[],"YyoBcv":[{"type":0,"value":"Tessin"}],"ZQWkJ9":[{"type":0,"value":"Appenzell Rhodes-Intérieures"}],"Zl57e/":[],"ZtZAli":[{"type":0,"value":"Saisissez votre nom de famille"}],"ZxssWD":[],"aL71Hk":[],"aQrqNd":[],"aik0OQ":[{"type":0,"value":"J\'ai déjà une propriété en tête"}],"b7qnrL":[],"bURm/c":[{"type":0,"value":"Prix"}],"biUozd":[],"ctK4I6":[],"dN54n3":[],"eZuFFq":[{"type":0,"value":"Avez-vous des questions ? Nous sommes là pour vous."}],"ev8tkE":[{"type":0,"value":"Bien précédent"}],"f02PwW":[{"type":0,"value":"Quels sont les coûts estimés ? (facultatif)"}],"feisHm":[],"fqr0vR":[{"type":0,"value":"Services d\'aide au déménagement"}],"fwKxxb":[{"type":0,"value":"Annuler"}],"gRUp1P":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"day"}]},"other":{"value":[{"type":0,"value":"days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"},{"type":0,"value":" restant"}],"gUmdV3":[],"go/Pzx":[{"type":0,"value":"Diffusion maximales de votre promotion"}],"gtiHtC":[{"type":0,"value":"Bâle-Ville"}],"gus/j8":[{"type":0,"value":"Si vous avez besoin d’aide pour vendre ou acheter, ou si vous souhaitez signaler un problème, veuillez contacter Brixel."}],"h4gb19":[{"type":0,"value":"Vaud"}],"h7EkPG":[{"type":0,"value":"Continuer"}],"iIDcto":[{"type":0,"value":"Glaris"}],"iPAnLE":[{"type":0,"value":"Berne"}],"jBgMdv":[{"type":0,"value":"Support juridique"}],"jFhx+1":[],"jaxp8G":[],"kB1Pu4":[{"type":0,"value":"Zoug"}],"kSwmMq":[{"type":0,"value":"Où est-ce que votre projet ?"}],"kawHwE":[],"kcqF2C":[{"type":0,"value":"Soleure"}],"kmnyH/":[{"type":0,"value":"Montant en CHF"}],"kxXd6Z":[{"type":0,"value":"Qui est votre conseillère chez UBS ? (facultatif)"}],"mHZeeW":[{"type":0,"value":"Malheureusement, aucun objet ne correspond à vos critères."}],"mJNLNN":[],"mWoieu":[{"type":0,"value":"Appelez-nous"}],"n8gN6R":[],"naP5t5":[],"oCoQLk":[],"owqmnW":[{"type":0,"value":"jj/mm/aaaa"}],"pC0zq4":[],"pK2hCf":[],"qZ3eCE":[{"type":0,"value":"Quand souhaitez-vous être contacté ? "}],"rU6OoX":[{"type":0,"value":"Réservé"}],"ro2QWQ":[],"s1lpzV":[{"type":0,"value":"Nous allons vérifier vos données. Vous serez contacté·e dès que possible."}],"sRn9qE":[{"type":0,"value":"Je suis juste curieux-se"}],"sYBL2K":[],"ssOh8n":[{"type":0,"value":"Obwald"}],"t3uTml":[],"tW7atw":[{"type":0,"value":"Connaissance du marché"}],"tsDsIk":[{"type":0,"value":"Année de construction"}],"uKUxlF":[],"unWaE3":[],"v9byQt":[],"vCo0EH":[{"type":0,"value":"Politique de confidentialité"}],"w+vERP":[{"type":0,"value":"Argovie"}],"wDKxsa":[{"type":0,"value":"Surface habitable"}],"wInrQd":[],"wNgL3D":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"jour restant"}]},"other":{"value":[{"type":0,"value":"jours restants"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"wQJ8/A":[{"type":0,"value":"Schaffhouse"}],"wg4/VJ":[{"type":0,"value":"Vos avantages"}],"wwzVAX":[],"x0XB+L":[{"type":0,"value":"MM/AAAA"}],"x38j5Q":[{"type":0,"value":"Je confirme par la présente que j\'ai lu, compris et accepté les conditions et la politique de confidentialité de Brixel."}],"xHyaHg":[],"y39M9H":[],"yO/4jP":[{"type":0,"value":"J\'ai commencé à chercher un logement"}],"yiRud2":[],"z+bbkF":[{"type":0,"value":"Zurich"}],"zeu/se":[{"type":0,"value":"Gestion transparente des acheteurs"}],"zxC1er":[{"type":0,"value":"Occupé"}]}');
;// CONCATENATED MODULE: ./compiled-lang/it.json
var it_namespaceObject = JSON.parse('{"+2W/WP":[],"+d/91N":[{"type":0,"value":"Termini e condizioni"}],"+ewVnD":[{"type":0,"value":"Quante unità sono previste? (opzionale)"}],"+hh+VE":[{"type":0,"value":"Neuchâtel"}],"01+OP2":[{"type":0,"value":"Per favore, leggi attentamente le seguenti condizioni e accetta per proseguire."}],"0M6MT1":[{"type":0,"value":"Il nostro team ti contatterà a breve per chiarire eventuali domande e procedere con i prossimi passaggi."}],"0YlyNR":[{"type":0,"value":"Carica altro"}],"0ZUZJD":[{"type":0,"value":"Inserisci il CAP o la città"}],"1a/4ve":[{"type":0,"value":"Scrivi il tuo nome"}],"1bVkdA":[{"type":0,"value":"Grazie!"}],"2+9Uxt":[],"26YeFt":[],"27XvY/":[{"type":1,"value":"daysLeft"},{"type":0,"value":" giorni rimasti"}],"3CyOuX":[{"type":0,"value":"Friburgo"}],"4f05T8":[],"4rDHbT":[{"type":0,"value":"Numero di telefono"}],"4tUhkX":[{"type":0,"value":"Vai alla home"}],"5JJKRj":[],"5vG1Zi":[{"type":0,"value":"Lucerna"}],"6fRR0B":[{"type":0,"value":"Appenzello Esterno"}],"6jqj//":[{"type":0,"value":"Indirizzo email"}],"77fZeN":[{"type":0,"value":"Grazie per la tua registrazione."}],"7CxCV3":[],"7Ix/Zg":[],"8I3TCk":[],"8o9EVS":[{"type":0,"value":"Tutti i diritti riservati"}],"95YuSo":[],"9YvFif":[{"type":0,"value":"Accesso ai prodotti di finanziamento"}],"9k8diP":[{"type":0,"value":"Scrivi il tuo indirizzo email"}],"9ksGHk":[],"AFUEkj":[{"type":0,"value":"Scrivi qui il nome del Progetto"}],"AFf+Gi":[{"type":0,"value":"Quando è previsto l\'inizio dei lavori? (opzionale)"}],"AeDkKF":[{"type":0,"value":"example@brixel.io"}],"B/RrjS":[{"type":0,"value":"Dicci di più!"}],"BAkEOU":[],"BML85d":[{"type":0,"value":"Ginevra"}],"BTZrof":[{"type":0,"value":"Contattaci"}],"Bpj1ZF":[{"type":0,"value":"Qual è il tuo numero di telefono?"}],"CSI5gE":[{"type":0,"value":"Crea il tuo Progetto"}],"CkmV9k":[],"D41ybz":[],"DXJv2Y":[{"type":0,"value":"Svitto"}],"DeyxnX":[],"Dp+wIA":[{"type":0,"value":"La mia offerta è già stata accettata"}],"E2Ajt6":[],"EQ/XxL":[{"type":0,"value":"Nidvaldo"}],"Eet4Q0":[],"FScS0U":[{"type":0,"value":"Vallese"}],"FkqCBt":[],"FthgtD":[{"type":0,"value":"è aperto"}],"GJDsYb":[{"type":0,"value":"Venduto"}],"H2RnT8":[],"HS4fmx":[{"type":0,"value":"si apre a"}],"HTUOPV":[{"type":0,"value":"Immobile successivo"}],"HfEl6c":[{"type":0,"value":"Pagina non trovata"}],"I2CV+g":[],"IRXVxP":[],"ISffvh":[{"type":0,"value":"Questo prodotto è disponibile esclusivamente per promotori la cui progettazione è finanziata da UBS. Pertanto, Brixel e terze parti potrebbero trarre conclusioni sulla tua relazione bancaria con UBS."}],"IX9egs":[{"type":0,"value":"Su richiesta"}],"J4JtcB":[],"JAY+qC":[{"type":0,"value":"Ottieni l’accesso a una piattaforma innovativa"}],"JL9eQ8":[],"JVS7kL":[{"type":0,"value":"Sentiti libero di contattarci nel frattempo."}],"JchSgw":[{"type":0,"value":"Giura"}],"JhNeE2":[],"JkP/dR":[],"KF8k24":[{"type":0,"value":"Confermo di aver letto e compreso i "},{"children":[{"type":0,"value":"termini"}],"type":8,"value":"termsLink"},{"type":0,"value":" e "},{"children":[{"type":0,"value":"l\'informativa sulla privacy"}],"type":8,"value":"privacyLink"},{"type":0,"value":" di Brixel e li accetto."}],"KHged8":[{"type":0,"value":"risparmiato"}],"KWSZCn":[{"type":0,"value":"Uri"}],"LEa4Ij":[],"LGpzov":[{"type":0,"value":"Basilea Campagna"}],"LX35RZ":[{"type":0,"value":"Qual è il nome della tua azienda?"}],"LcKY+0":[{"type":0,"value":"Registrati ora"}],"Lj1rw3":[{"type":0,"value":"Qual è il tuo nome?"}],"LkwhlX":[],"M4rc0X":[{"type":0,"value":"Qual è il tuo cognome?"}],"MIYCJc":[{"type":0,"value":"Turgovia"}],"N+Qpvr":[{"type":0,"value":"Crea il tuo profilo"}],"N+qhzw":[{"type":0,"value":"Prepara il tuo progetto per la promozione"}],"NHXhAa":[],"Npim2S":[],"Nq6A4S":[{"type":0,"value":"Confermare per favore"}],"O4nooC":[],"OrXeKM":[{"type":0,"value":"Quali servizi ti interessano di più?"}],"P+DnaV":[{"type":0,"value":"Inserire un indirizzo e-mail valido"}],"PRS+w1":[{"type":0,"value":"Il tuo nome completo"}],"PZkcXk":[],"QTAhhR":[{"type":0,"value":"Scrivici su WhatsApp"}],"QhhPzk":[{"type":0,"value":"Inviaci una mail"}],"RE0BIp":[{"type":0,"value":"Scrivi l\'email del consulente clienti"}],"REcF0D":[{"type":0,"value":"Cantoni"}],"RXO/tj":[{"type":0,"value":"Qual è il nome del tuo Progetto?"}],"RZ5rZu":[{"type":0,"value":"Qual è il tuo indirizzo email?"}],"RlDzFA":[{"type":0,"value":"si apre su"}],"RnLTlM":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" giorni rimasti"}],"Rx9JZ7":[{"type":0,"value":"Sto aspettando che la mia offerta venga accettata"}],"RxH0Zp":[{"type":0,"value":"Grigioni"}],"SHw40G":[{"type":0,"value":"Scrivi il nome della tua azienda"}],"Saeg/p":[{"type":0,"value":"Compilare questo campo per favore"}],"T8b2I3":[{"type":0,"value":"Nome completo"}],"TARSh2":[],"UibFRK":[],"V2MxOz":[{"type":0,"value":"Locali"}],"V7DS5l":[{"type":0,"value":"In quale fase del processo ti trovi?"}],"VRSxyL":[{"type":0,"value":"Chiamaci"}],"W9nrzJ":[],"WDROA9":[],"WIKBIe":[],"WrCo4m":[{"type":0,"value":"Non siamo riusciti a trovare la pagina che stavi cercando."}],"Wzz5/m":[{"type":0,"value":"Nr. di unità"}],"XCRJXE":[{"type":0,"value":"Inviaci una mail"}],"XOCDU1":[{"type":0,"value":"San Gallo"}],"XcW/Ag":[],"YCIsxs":[],"YdJS7t":[],"YyoBcv":[{"type":0,"value":"Ticino"}],"ZQWkJ9":[{"type":0,"value":"Appenzello Interno"}],"Zl57e/":[],"ZtZAli":[{"type":0,"value":"Scrivi il tuo cognome"}],"ZxssWD":[],"aL71Hk":[],"aQrqNd":[],"aik0OQ":[{"type":0,"value":"Ho già in mente un immobile"}],"b7qnrL":[],"bURm/c":[{"type":0,"value":"Prezzo"}],"biUozd":[],"ctK4I6":[],"dN54n3":[],"eZuFFq":[{"type":0,"value":"Hai qualche problema o domanda? Sentiti libero di contattarci."}],"ev8tkE":[{"type":0,"value":"Immobile precedente"}],"f02PwW":[{"type":0,"value":"Quali sono i costi stimati? (opzionale)"}],"feisHm":[],"fqr0vR":[{"type":0,"value":"Servizi di assistenza al trasloco"}],"fwKxxb":[{"type":0,"value":"Annulla"}],"gRUp1P":[],"gUmdV3":[],"go/Pzx":[{"type":0,"value":"Massima distribuzione per la tua promozione"}],"gtiHtC":[{"type":0,"value":"Basilea Città"}],"gus/j8":[{"type":0,"value":"Se hai bisogno di aiuto per vendere o comprare, o vuoi segnalare un problema, contatta Brixel."}],"h4gb19":[{"type":0,"value":"Vaud"}],"h7EkPG":[{"type":0,"value":"Continua"}],"iIDcto":[{"type":0,"value":"Glarona"}],"iPAnLE":[{"type":0,"value":"Berna"}],"jBgMdv":[{"type":0,"value":"Assistenza legale"}],"jFhx+1":[],"jaxp8G":[],"kB1Pu4":[{"type":0,"value":"Zugo"}],"kSwmMq":[{"type":0,"value":"Dove si trova?"}],"kawHwE":[],"kcqF2C":[{"type":0,"value":"Soletta"}],"kmnyH/":[{"type":0,"value":"Importo in CHF"}],"kxXd6Z":[{"type":0,"value":"Chi è il tuo consulente presso UBS (opzionale)?"}],"mHZeeW":[{"type":0,"value":"Ci dispiace, non abbiamo trovato immobili corrispondenti."}],"mJNLNN":[],"mWoieu":[{"type":0,"value":"Chiamaci"}],"n8gN6R":[],"naP5t5":[],"oCoQLk":[],"owqmnW":[{"type":0,"value":"gg/mm/aaaa"}],"pC0zq4":[],"pK2hCf":[],"qZ3eCE":[{"type":0,"value":"Quando possiamo contattarti? "}],"rU6OoX":[{"type":0,"value":"Riservato"}],"ro2QWQ":[],"s1lpzV":[{"type":0,"value":"Verificheremo le tue informazioni. Verrai contattato il prima possibile."}],"sRn9qE":[{"type":0,"value":"Sono qui solo per curiosità"}],"sYBL2K":[],"ssOh8n":[{"type":0,"value":"Obvaldo"}],"t3uTml":[],"tW7atw":[{"type":0,"value":"Know-how del mercato"}],"tsDsIk":[{"type":0,"value":"Anno di costruzione"}],"uKUxlF":[],"unWaE3":[],"v9byQt":[],"vCo0EH":[{"type":0,"value":"Politica sulla riservatezza"}],"w+vERP":[{"type":0,"value":"Argovia"}],"wDKxsa":[{"type":0,"value":"Superficie abitabile"}],"wInrQd":[],"wNgL3D":[{"type":1,"value":"daysRemaining"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"giorno rimanente"}]},"other":{"value":[{"type":0,"value":"giorni rimasti"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"wQJ8/A":[{"type":0,"value":"Sciaffusa"}],"wg4/VJ":[{"type":0,"value":"I tuoi vantaggi"}],"wwzVAX":[],"x0XB+L":[{"type":0,"value":"MM/AAAA"}],"x38j5Q":[{"type":0,"value":"Per favore, leggi attentamente le seguenti condizioni e accetta per proseguire."}],"xHyaHg":[],"y39M9H":[],"yO/4jP":[{"type":0,"value":"Ho iniziato a cercare casa"}],"yiRud2":[],"z+bbkF":[{"type":0,"value":"Zurigo"}],"zeu/se":[{"type":0,"value":"Gestione trasparente di tutti i prospetti"}],"zxC1er":[{"type":0,"value":"Occupato"}]}');
;// CONCATENATED MODULE: ./compiled-lang/pt.json
var pt_namespaceObject = JSON.parse('{"KHged8":[{"type":0,"value":"saved"}],"vC6BQl":[{"type":0,"value":"Menu"}]}');
;// CONCATENATED MODULE: ./components/IntlProvider.tsx









function IntlProvider_IntlProvider(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, defaultLocale = ref.defaultLocale;
    var l = locale || defaultLocale || "de";
    var fullLocale = [
        "en",
        "de",
        "fr",
        "it"
    ].includes(l) ? "".concat(l, "-CH") : l;
    var messages = (0,react.useMemo)(function() {
        switch(l){
            case "en":
                return en_namespaceObject;
            case "de":
                return de_namespaceObject;
            case "fr":
                return fr_namespaceObject;
            case "it":
                return it_namespaceObject;
            case "pt":
                return pt_namespaceObject;
            default:
                return en_namespaceObject;
        }
    }, [
        l
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(provider, {
        locale: fullLocale,
        defaultLocale: defaultLocale,
        messages: messages,
        children: children
    });
}
/* harmony default export */ var components_IntlProvider = (IntlProvider_IntlProvider);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./hooks/useRouterLoading.tsx


var useRouterLoading = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var startLoading = function() {
        return setIsLoading(true);
    };
    var stopLoading = function() {
        return setIsLoading(false);
    };
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", startLoading);
        router.events.on("routeChangeComplete", stopLoading);
        router.events.on("routeChangeError", stopLoading);
        return function() {
            router.events.off("routeChangeStart", startLoading);
            router.events.off("routeChangeComplete", stopLoading);
            router.events.off("routeChangeError", stopLoading);
        };
    });
    return isLoading;
};
/* harmony default export */ var hooks_useRouterLoading = (useRouterLoading);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
;// CONCATENATED MODULE: ./styles/fonts.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: 'Poppins', sans-serif;\n    font-weight:  400;\n    font-style:   normal;\n    font-stretch: normal;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: 'Poppins', sans-serif;\n    font-weight:  500;\n    font-style:   normal;\n    font-stretch: normal;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: 'Poppins', sans-serif;\n    font-weight:  600;\n    font-style:   normal;\n    font-stretch: normal;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: 'Space Mono', monospace;\n    font-weight:  400;\n    font-style:   normal;\n    font-stretch: normal;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-size: ",
        ";\n  line-height: 1.1;\n\n  @media ( max-width: 850px ) {\n    font-size: ",
        ";\n  }\n\n  @media ( max-width: 400px ) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n\n  @media ( max-width: 400px ) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-size: ",
        ";\n  line-height: 1.25;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  html,\n  body,\n  input,\n  textarea,\n  select,\n  button {\n    ",
        "\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: ",
        ";\n    font-size: 18px;\n    line-height: 1.4;\n\n    @media ( max-width: 350px ) {\n      font-size: 16px;\n    }\n  }\n\n  sup {\n    vertical-align: top;\n    position: relative;\n    top: -0.1em;\n  }\n\n  sub {\n    vertical-align: bottom;\n    position: relative;\n    bottom: -0.1em;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var textSizes = {
    small: "0.777rem",
    dropped: "0.888rem",
    normal: "1rem",
    medium: "1.222rem",
    large: "1.444rem",
    veryLarge: "1.777rem",
    smallHero: "2.444rem",
    hero: "3.111rem"
};
var typo = {
    regular: (0,styled_components_browser_esm/* css */.iv)(_templateObject()),
    medium: (0,styled_components_browser_esm/* css */.iv)(_templateObject1()),
    semiBold: (0,styled_components_browser_esm/* css */.iv)(_templateObject2()),
    mono: (0,styled_components_browser_esm/* css */.iv)(_templateObject3()),
    heroTitle: (0,styled_components_browser_esm/* css */.iv)(_templateObject4()),
    heroSubTitle: (0,styled_components_browser_esm/* css */.iv)(_templateObject5()),
    smallMeta: (0,styled_components_browser_esm/* css */.iv)(_templateObject6()),
    sizes: textSizes,
    urls: [
        'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&family=Space+Mono:wght@400;700&display=swap" rel="stylesheet', 
    ]
};
typo.heroTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), typo.semiBold, typo.sizes.hero, typo.sizes.smallHero, typo.sizes.veryLarge);
typo.heroSubTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), typo.regular, typo.sizes.large, typo.sizes.medium);
typo.smallMeta = (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), typo.regular, typo.sizes.small);
var fonts = (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), typo.regular, colors/* default.black */.Z.black);
/* harmony default export */ var styles_fonts = ((/* unused pure expression or super */ null && (fonts)));

;// CONCATENATED MODULE: ./styles/ThemeProvider.tsx









var theme = {
    typo: typo,
    colors: colors/* default */.Z,
    getColor: colors/* getColor */.L,
    noJs: true,
    isGrid: false
};
var useTheme = function() {
    return useContext(ThemeContext);
};
function ThemeProvider(param) {
    var children = param.children;
    var pathname = (0,next_router.useRouter)().pathname;
    var ref = (0,react.useState)(true), noJs = ref[0], setNoJs = ref[1];
    var isLoading = hooks_useRouterLoading();
    theme.isGrid = pathname.startsWith("/_grid");
    (0,react.useEffect)(function() {
        setNoJs(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
        theme: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme), {
            noJs: noJs,
            isLoading: isLoading
        }),
        children: children
    });
}
/* harmony default export */ var styles_ThemeProvider = (ThemeProvider);

// EXTERNAL MODULE: ./lib/craft/index.tsx + 31 modules
var craft = __webpack_require__(8767);
;// CONCATENATED MODULE: ./lib/gtm.tsx



var initalConsentScript = "\nwindow.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('consent', 'default', {\n  'ad_storage': 'denied',\n  'analytics_storage': 'denied',\n});\n";
var headScript = function(gtmCode) {
    return "\n(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','".concat(gtmCode, "');\n");
};
var bodyScript = function(gtmCode) {
    return '\n<!-- Google Tag Manager (noscript) -->\n<noscript><iframe src="https://www.googletagmanager.com/ns.html?id='.concat(gtmCode, '"\nheight="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>\n<!-- End Google Tag Manager (noscript) -->\n');
};
var useConsentListener = function() {
    var consentListeners = useRef([]);
    useEffect(function() {
        window.addConsentListener = function(callback) {
            consentListeners.current.push(callback);
        };
    }, []);
    var onConsentChange = useCallback(function(consent) {
        consentListeners.current.forEach(function(callback) {
            callback(consent);
        });
    }, []);
    return onConsentChange;
};
function GtmScripts(param) {
    var gtmCode = param.gtmCode;
    if (!gtmCode) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: bodyScript(gtmCode)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "initial-consent",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: initalConsentScript
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: headScript(gtmCode)
                }
            })
        ]
    });
}
/* harmony default export */ var gtm = (GtmScripts);
var grantAnalytics = function() {
    if ( true && window.gtag) {
        window.gtag("consent", "update", {
            analytics_storage: "granted"
        });
    }
};
var denyAnalytics = function() {
    if ( true && window.gtag) {
        window.gtag("consent", "update", {
            analytics_storage: "denied"
        });
    }
};

// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

;// CONCATENATED MODULE: ./lib/cookie-cutter/cookies.ts


var cookieName = "cookie-consent";
var defaultOptions = {
    secure: true,
    expires: 365,
    sameSite: "Lax"
};
var setCookie = function(userPreferences) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var payload = JSON.stringify(userPreferences);
    js_cookie.set(cookieName, payload, (0,_object_spread/* default */.Z)({}, defaultOptions, options));
};
var getCookie = function() {
    var cookieString = js_cookie.get(cookieName);
    return cookieString ? JSON.parse(cookieString) || null : null;
};

;// CONCATENATED MODULE: ./lib/cookie-cutter/CookieCutter.tsx






var defaultContext = {
    userOptions: [],
    userPreferences: {
        adConsentGranted: false,
        analyticsConsentGranted: false,
        functionalityConsentGranted: true,
        securityConsentGranted: true,
        personalizationConsentGranted: true
    },
    openPreferences: function() {},
    openBanner: function() {},
    close: function() {},
    setUserPreferences: function() {},
    currentView: null
};
var CookieCutterContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
var useCookieCutter = function() {
    return (0,react.useContext)(CookieCutterContext);
};
var getInitialUserPreferences = function(userOptions) {
    var cookie = getCookie();
    return cookie || userOptions.map(function(option) {
        return {
            handle: option.handle,
            setting: option.initial
        };
    }).reduce(function(prefsObj, pref) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prefsObj), (0,_define_property/* default */.Z)({}, pref.handle, pref.setting));
    }, {});
};
var hasUserInteracted = function() {
    return !!getCookie();
};
var accept = function(userOptions) {
    var userPrefs = userOptions.map(function(option) {
        return {
            handle: option.handle,
            setting: option.acceptAll
        };
    }).reduce(function(prefsObj, pref) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prefsObj), (0,_define_property/* default */.Z)({}, pref.handle, pref.setting));
    }, {});
    setCookie(userPrefs);
    return userPrefs;
};
var reject = function(userOptions) {
    var userPrefs = userOptions.map(function(option) {
        return {
            handle: option.handle,
            setting: option.rejectAll
        };
    }).reduce(function(prefsObj, pref) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prefsObj), (0,_define_property/* default */.Z)({}, pref.handle, pref.setting));
    }, {});
    setCookie(userPrefs);
    return userPrefs;
};
function CookieCutter(param) {
    var userOptions = param.userOptions, children = param.children;
    var ref;
    var ref1 = (0,react.useState)(null), currentView = ref1[0], setCurrentView = ref1[1];
    var ref2 = (0,react.useState)(getInitialUserPreferences(userOptions)), userPreferences = ref2[0], setUserPreferences = ref2[1];
    var openPreferences = (0,react.useCallback)(function() {
        return setCurrentView("preferences");
    }, []);
    var openBanner = (0,react.useCallback)(function() {
        return setCurrentView("banner");
    }, []);
    var close = (0,react.useCallback)(function() {
        return setCurrentView(null);
    }, []);
    var urlHash =  true ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hash : 0;
    var context = (0,react.useMemo)(function() {
        return {
            userOptions: userOptions,
            userPreferences: userPreferences,
            openPreferences: openPreferences,
            openBanner: openBanner,
            close: close,
            setUserPreferences: setUserPreferences,
            currentView: currentView
        };
    }, [
        userOptions,
        userPreferences,
        openPreferences,
        openBanner,
        close,
        setUserPreferences,
        currentView, 
    ]);
    (0,react.useEffect)(function() {
        if (!hasUserInteracted()) {
            setCurrentView("banner");
        }
        setUserPreferences(getInitialUserPreferences(userOptions));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(userOptions)
    ]);
    (0,react.useEffect)(function() {
        if (urlHash === "#cc-test") {
            setCurrentView("banner");
        }
    }, [
        urlHash
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieCutterContext.Provider, {
        value: context,
        children: children
    });
}
/* harmony default export */ var cookie_cutter_CookieCutter = (CookieCutter);
function AcceptButton(param) {
    var children = param.children;
    var ref = useCookieCutter(), userOptions = ref.userOptions, close = ref.close, setUserPreferences = ref.setUserPreferences;
    var onClick = function() {
        var userPrefs = accept(userOptions);
        setUserPreferences(userPrefs);
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onClick,
        children: children
    });
}
function RejectButton(param) {
    var children = param.children;
    var ref = useCookieCutter(), userOptions = ref.userOptions, close = ref.close, setUserPreferences = ref.setUserPreferences;
    var onClick = function() {
        var userPrefs = reject(userOptions);
        setUserPreferences(userPrefs);
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onClick,
        children: children
    });
}
function SettingsButton(param) {
    var children = param.children;
    var openPreferences = useCookieCutter().openPreferences;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        onClick: openPreferences,
        children: children
    });
}

// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
// EXTERNAL MODULE: ./styles/links.tsx
var links = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/CookieConsent.tsx

function CookieConsent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-top: 0;\n\n    * {\n      font-family: 'GeneralSans-Variable' !important;\n    }\n\n    a {\n      color: inherit !important;\n    }\n\n    ",
        " button {\n      --button-color: ",
        " !important;\n      --button-hover-color: #f9f674;\n      --button-hover-border-color: #f9f674;\n      --button-hover-text-color: ",
        " !important;\n      font-size: 14px;\n      font-family: 'GeneralSans-Variable';\n    }\n  "
    ]);
    CookieConsent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CookieConsent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  ",
        " \n"
    ]);
    CookieConsent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CookieConsent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2.5rem 0;\n  color: ",
        ";\n\n  ",
        " {\n    display: block;\n    margin-top: 1.5rem;\n  }\n\n  @media all and ( max-width: 700px ) {\n    flex-wrap: wrap;\n\n    &:first-child {\n      flex-grow: 1;\n    }\n  }\n"
    ]);
    CookieConsent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CookieConsent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 52rem;\n\n  h3 {\n    ",
        "\n    font-size: ",
        ";\n  }\n  \n  p {\n    font-size: ",
        ";\n  }\n\n  > * {\n    margin: 0 0 calc( 3 * var( --stack-basis ) ) 0;\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  a {\n    ",
        "\n  }\n"
    ]);
    CookieConsent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









function CookieConsentProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(cookie_cutter_CookieCutter, {
        userOptions: [
            {
                handle: "adConsentGranted",
                name: "Advertising",
                initial: false,
                acceptAll: false,
                rejectAll: false,
                canEdit: false
            },
            {
                handle: "analyticsConsentGranted",
                name: "Analytics",
                initial: false,
                acceptAll: true,
                rejectAll: true
            },
            {
                handle: "functionalityConsentGranted",
                name: "Essential Functionality",
                initial: true,
                acceptAll: true,
                rejectAll: true,
                canEdit: false
            },
            {
                handle: "personalizationConsentGranted",
                name: "Personalization",
                initial: true,
                acceptAll: true,
                rejectAll: false,
                canEdit: false
            },
            {
                handle: "securityConsentGranted",
                name: "Security",
                initial: true,
                acceptAll: true,
                rejectAll: true,
                canEdit: false
            }, 
        ],
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsentBanner, {})
        ]
    });
}
function CookieConsentBanner() {
    var ref, ref1, ref2, ref3;
    var ref4 = useCookieCutter(), currentView = ref4.currentView, userPreferences = ref4.userPreferences;
    var craftData = (0,craft/* useCraft */.Yi)();
    var cookieBannerContent = craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.cookieBanner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cookieBanner) === null || ref3 === void 0 ? void 0 : ref3[0];
    (0,react.useEffect)(function() {
        if (userPreferences.analyticsConsentGranted) {
            grantAnalytics();
        } else {
            denyAnalytics();
        }
    }, [
        userPreferences
    ]);
    if (currentView !== "banner" || !cookieBannerContent || !cookieBannerContent.acceptButtonLabel || !cookieBannerContent.rejectButtonLabel) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCookieConsent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCookieConsentInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCopy, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: cookieBannerContent.titleCopy
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                // eslint-disable-next-line react/jsx-props-no-multi-spaces, react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: cookieBannerContent.bodyCopy
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* StyledButtonGroup */.zu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* StyledButton */.Sn, {
                                $color: "green",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptButton, {
                                    children: cookieBannerContent.acceptButtonLabel
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* StyledButton */.Sn, {
                                $color: "green",
                                $style: "outline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectButton, {
                                    children: cookieBannerContent.rejectButtonLabel
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var StyledCookieConsent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61303b2b-0"
})(CookieConsent_templateObject1(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.grey300;
}, function(p) {
    return p.theme.isGrid && (0,styled_components_browser_esm/* css */.iv)(CookieConsent_templateObject(), Button/* StyledButton */.Sn, p.theme.colors.black, p.theme.colors.black);
});
var StyledCookieConsentInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61303b2b-1"
})(CookieConsent_templateObject2(), function(p) {
    return p.theme.colors.black;
}, Button/* StyledButton */.Sn);
var StyledCopy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61303b2b-2"
})(CookieConsent_templateObject3(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return (0,links/* textLink */.k)(p.theme);
});

// EXTERNAL MODULE: ./hooks/usePreventBodyScroll.tsx
var usePreventBodyScroll = __webpack_require__(7325);
// EXTERNAL MODULE: ./lib/craft/MetaTags.tsx
var MetaTags = __webpack_require__(4029);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
;// CONCATENATED MODULE: ./components/BrixelMetaTags.tsx





function BrixelMetaTags(param) {
    var hostname = param.hostname, entry = param.entry;
    var router = (0,next_router.useRouter)();
    if (!entry) {
        return null;
    }
    var tags = getTags(hostname, entry, router);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        metaTags: tags
    });
}
var getTags = function(hostname, entry, router) {
    var ref, ref1;
    var locale = router.locale, defaultLocale = router.defaultLocale, asPath = router.asPath;
    var url = getUrl(hostname, locale, defaultLocale, asPath);
    var metaTags = entry === null || entry === void 0 ? void 0 : (ref = entry.metaTags) === null || ref === void 0 ? void 0 : ref[0];
    var title = (metaTags === null || metaTags === void 0 ? void 0 : metaTags.metaTitle) || entry.mainTitle || entry.title || "Brixel";
    var description = (metaTags === null || metaTags === void 0 ? void 0 : metaTags.metaDescription) || "";
    var imgUrl = (ref1 = metaTags === null || metaTags === void 0 ? void 0 : metaTags.metaImage[0]) === null || ref1 === void 0 ? void 0 : ref1.url;
    var ogImage = imgUrl && (0,Image/* imageUrl */.sQ)({
        src: imgUrl,
        width: 1200,
        height: 630
    });
    var twitterImage = imgUrl && (0,Image/* imageUrl */.sQ)({
        src: imgUrl,
        width: 1200,
        height: 675
    });
    return [
        // Primary Meta Tags
        {
            name: "title",
            value: title
        },
        {
            name: "description",
            value: description
        },
        // Open Graph / Facebook 
        {
            name: "og:type",
            value: "website"
        },
        {
            name: "og:url",
            value: url
        },
        {
            name: "og:title",
            value: title
        },
        {
            name: "og:description",
            value: description
        },
        {
            name: "og:image",
            value: ogImage
        },
        // Twitter
        {
            name: "twitter:card",
            value: "summary_large_image"
        },
        {
            name: "twitter:url",
            value: url
        },
        {
            name: "twitter:title",
            value: title
        },
        {
            name: "twitter:description",
            value: description
        },
        {
            name: "twitter:image",
            value: twitterImage
        }, 
    ];
};
/* harmony default export */ var components_BrixelMetaTags = (BrixelMetaTags);

;// CONCATENATED MODULE: ./components/ContextProviders.tsx





// import { ModalProvider } from '../lib/modal'


// import Modal from './Modal'
function ContextProviders(param) {
    var hostname = param.hostname, pageProps = param.pageProps, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(craft/* CraftProvider */.j7, {
        hostname: hostname,
        pageProps: pageProps,
        MetaTagsComponent: components_BrixelMetaTags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ThemeProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(usePreventBodyScroll/* BodyScrollProvider */.f, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IntlProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsentProvider, {
                        children: children
                    })
                })
            })
        })
    });
}
/* harmony default export */ var components_ContextProviders = (ContextProviders);

;// CONCATENATED MODULE: ./components/Gtm.tsx



function Gtm() {
    var ref, ref1, ref2;
    var craftData = (0,craft/* useCraft */.Yi)();
    var gtmCode = craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.gtm) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.tagManagerId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gtm, {
        gtmCode: gtmCode
    });
}
/* harmony default export */ var components_Gtm = (Gtm);

// EXTERNAL MODULE: ./components/gridBrand/styles/fonts.css
var gridBrand_styles_fonts = __webpack_require__(412);
;// CONCATENATED MODULE: ./pages/_app.tsx













function BrixelApp(param) {
    var Component = param.Component, pageProps = param.pageProps, hostname = param.hostname;
    var ref;
    var ref1 = (0,next_router.useRouter)(), locales = ref1.locales, defaultLocale = ref1.defaultLocale, asPath = ref1.asPath, currentlLocale = ref1.locale;
    var iconDir = (hostname === null || hostname === void 0 ? void 0 : hostname.indexOf("gogrid")) > -1 ? "/grid" : "";
    var iconThemeColor = (hostname === null || hostname === void 0 ? void 0 : hostname.indexOf("gogrid")) > -1 ? "#a5d9d0" : "#009877";
    var canonicalUrl = null;
    if ((pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.entry) === null || ref === void 0 ? void 0 : ref.canonicalUrl) && new URL(pageProps.entry.canonicalUrl, "https://".concat(hostname)).hostname === hostname) {
        canonicalUrl = getUrl(hostname, currentlLocale, defaultLocale, pageProps.entry.canonicalUrl);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ContextProviders, {
        hostname: hostname,
        pageProps: pageProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "".concat(iconDir, "/apple-touch-icon.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "".concat(iconDir, "/favicon-32x32.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "".concat(iconDir, "/favicon-16x16.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "".concat(iconDir, "/site.webmanifest")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "".concat(iconDir, "/safari-pinned-tab.svg"),
                        color: iconThemeColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: iconThemeColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: iconThemeColor
                    }),
                    locales.map(function(locale) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            hrefLang: locale,
                            href: getUrl(hostname, locale, defaultLocale, asPath)
                        }, locale);
                    }),
                    canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }, "canonical")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://widget.superchat.de/snippet.js?applicationKey=WCyQKxJ081w98o5xr25VqAzXpn",
                referrerPolicy: "no-referrer-when-downgrade",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Gtm, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
        ]
    });
}
BrixelApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(appContext) {
        var appProps, hostname;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        app["default"].getInitialProps(appContext)
                    ];
                case 1:
                    appProps = _state.sent();
                    hostname = appContext.ctx.req ? appContext.ctx.req.headers.host :  true ? window.location.host : 0;
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appProps), {
                            hostname: hostname
                        })
                    ];
            }
        });
    });
    return function(appContext) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (BrixelApp);


/***/ }),

/***/ 2317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getColor; }
/* harmony export */ });
var colors = {
    black: "#06262D",
    ivory: "#F7F6F5",
    white: "#F2F2F2",
    realWhite: "#FFFFFF",
    // Grey
    grey700: "#676C6E",
    grey400: "#A2A9AD",
    grey300: "#CFD2D3",
    grey200: "#EDEDED",
    grey100: "#F6F6F6",
    // Blue
    blue700: "#004D71",
    blue400: "#00C1DE",
    blue300: "#96DAEA",
    blue200: "#D7F0F1",
    blue100: "#E8F6F6",
    // Green
    green700: "#00615C",
    green400: "#009877",
    green300: "#95E1BF",
    green200: "#DCF2E8",
    green100: "#E7F5EF",
    // Red
    red700: "#72253D",
    red400: "#FF595A",
    red300: "#FFB1B9",
    red200: "#FFD8DC",
    red100: "#FFEBED",
    // Yellow
    yellow400: "#FFC368",
    // Status
    error: "",
    success: "",
    notice: ""
};
// export const gridColors = {
//   ...colors,
//   black: '#082328',
//   grey300: '#B3B8EE',
//   grey200: '#DEE0F5',
//   grey100: '#E9EBFC',
//   blue300: '#A5D9D0',
//   blue200: '#C2E6E8',
//   blue100: '#D4EFF0',
//   green700: '#26704C',
//   green400: '#6FC277',
//   green200: '#FDFBA1',
//   green100: '#FFFECB',
//   red200: '#FFD2E7',
//   red100: '#FFDFEE',
// }
// Status
colors.error = colors.red400;
colors.success = colors.green400;
colors.notice = colors.yellow400;
/* harmony default export */ __webpack_exports__["Z"] = (colors);
var getColor = function(color) {
    if (colors[color]) {
        return colors[color];
    }
    return color;
};


/***/ }),

/***/ 2676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ textLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var textLink = function(theme) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "green400";
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), theme.getColor(color));
};


/***/ }),

/***/ 1876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 412:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 5675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8045)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ }),

/***/ 4806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5687);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2644);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 6774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 2125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Fe; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, createGlobalStyle, isStyledComponent, keyframes, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(9864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(6774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(3454);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.5",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.5"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.5");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.5"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=(0,react.useContext)(Ge),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.5"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,emotion_is_prop_valid_browser_esm,_):!N||emotion_is_prop_valid_browser_esm(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.5"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.5",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);